export const axios = require("axios");
export const AUTH_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMSIsImlhdCI6MTY0NjQ4NjUzNSwiZXhwIjoxNjQ2NTcyOTM1fQ.7gz3RSKX7yDWDlfd9pO9yzmLFlGaGvenivMChUImwGs";
// normal
export const baseURL = "https://api.medisevas.com/3332";
export const serviceUrl = "https://api.medisevas.com/3031";

// export const baseURL = "https://api.medisevas.com/3332";
// export const serviceUrl = "https://api.medisevas.com/3331";
export const imgUrl =
  "https://medisevasappointment-logebucket.s3.ap-southeast-2.amazonaws.com/";
// aws
// axios.defaults.baseURL = 'https://nvk.nvkgenesys.com/';

export const config = {
  headers: {
    "Content-type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};
export const set = "set";
export const LOGINAUTH = "LOGINAUTH";
export const LOGINULL = "LOGINULL";
export const GETHOSPITAL = "GETHOSPITAL";
export const CREATEHOSPITAL = "CREATEHOSPITAL";
export const UPDATEHOSPITAL = "UPDATEHOSPITAL";
export const CREATEUSER = "CREATEUSER";
export const GETUSER = "GETUSER";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const LOGOUT = "LOGOUT";

export const GETUSERBYROLL = "GETUSERBYROLL";
export const SAVE_SOCIAL_MEDIA = "GETUSERBYROLL";
export const RESET_SOCIAL_MEDIA = "RESET_SOCIAL_MEDIA";

export const GET_ALL_DOCTORS_REQUEST = "GET_ALL_DOCTORS_REQUEST";
export const GET_ALL_DOCTORS_SUCCESS = "GET_ALL_DOCTORS_SUCCESS";
export const GET_ALL_DOCTORS_FAIL = "GET_ALL_DOCTORS_FAIL";

export const GET_DOCTOR_PROFILE_REQUEST = "GET_DOCTOR_PROFILE_REQUEST";
export const GET_DOCTOR_PROFILE_SUCCESS = "GET_DOCTOR_PROFILE_SUCCESS";
export const GET_DOCTOR_PROFILE_FAIL = "GET_DOCTOR_PROFILE_FAIL";

export const DOCTOR_FILTER = "DOCTOR_FILTER";

export const UPDATEUSER = "UPDATEUSER";
export const UPDATEUSERBYMOBAIL = "UPDATEUSERBYMOBAIL";
export const DELETEUSER = "DELETEUSER";
export const UPDATE_DOCTOR_PROFILE = "UPDATE_DOCTOR_PROFILE";

export const ADD_SPECIALITY = "ADD_SPECIALITY";
export const FETCH_SPECIALITIES_REQUEST = "FETCH_SPECIALITIES_REQUEST";
export const FETCH_SPECIALITIES_SUCCESS = "FETCH_SPECIALITIES_SUCCESS";
export const FETCH_SPECIALITIES_FAILURE = "FETCH_SPECIALITIES_FAILURE";
export const SPECIALITY_UPDATE_FAIL = "SPECIALITY_UPDATE_FAIL";
export const SPECIALITY_UPDATE_SUCCESS = "SPECIALITY_UPDATE_SUCCESS";
export const SPECIALITY_DELETE_SUCCESS = "SPECIALITY_DELETE_SUCCESS";
export const SPECIALITY_DELETE_FAIL = "SPECIALITY_DELETE_FAIL";
export const GET_SPECIALITY_FAIL = "GET_SPECIALITY_FAIL";
export const GET_SPECIALITY_SUCCESS = "GET_SPECIALITY_SUCCESS";
// Services delete
export const DELETE_SERVICE_REQUEST = "DELETE_SERVICE_REQUEST";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAIL = "DELETE_SERVICE_FAIL";

// Specialization delete
export const DELETE_SPECIALIZATION_REQUEST = "DELETE_SPECIALIZATION_REQUEST";
export const DELETE_SPECIALIZATION_SUCCESS = "DELETE_SPECIALIZATION_SUCCESS";
export const DELETE_SPECIALIZATION_FAIL = "DELETE_SPECIALIZATION_FAIL";

// Education delete
export const DELETE_EDUCATION_REQUEST = "DELETE_EDUCATION_REQUEST";
export const DELETE_EDUCATION_SUCCESS = "DELETE_EDUCATION_SUCCESS";
export const DELETE_EDUCATION_FAIL = "DELETE_EDUCATION_FAIL";

// Experience delete
export const DELETE_EXPERIENCE_REQUEST = "DELETE_EXPERIENCE_REQUEST";
export const DELETE_EXPERIENCE_SUCCESS = "DELETE_EXPERIENCE_SUCCESS";
export const DELETE_EXPERIENCE_FAIL = "DELETE_EXPERIENCE_FAIL";
// Exercise Template Types
export const EXERCISE_TEMPLATE_LIST_REQUEST = "EXERCISE_TEMPLATE_LIST_REQUEST";
export const EXERCISE_TEMPLATE_LIST_SUCCESS = "EXERCISE_TEMPLATE_LIST_SUCCESS";
export const EXERCISE_TEMPLATE_LIST_FAIL = "EXERCISE_TEMPLATE_LIST_FAIL";

export const EXERCISE_TEMPLATE_CREATE_REQUEST = "EXERCISE_TEMPLATE_CREATE_REQUEST";
export const EXERCISE_TEMPLATE_CREATE_SUCCESS = "EXERCISE_TEMPLATE_CREATE_SUCCESS";
export const EXERCISE_TEMPLATE_CREATE_FAIL = "EXERCISE_TEMPLATE_CREATE_FAIL";

export const EXERCISE_TEMPLATE_UPDATE_REQUEST = "EXERCISE_TEMPLATE_UPDATE_REQUEST";
export const EXERCISE_TEMPLATE_UPDATE_SUCCESS = "EXERCISE_TEMPLATE_UPDATE_SUCCESS";
export const EXERCISE_TEMPLATE_UPDATE_FAIL = "EXERCISE_TEMPLATE_UPDATE_FAIL";

export const EXERCISE_TEMPLATE_DELETE_REQUEST = "EXERCISE_TEMPLATE_DELETE_REQUEST";
export const EXERCISE_TEMPLATE_DELETE_SUCCESS = "EXERCISE_TEMPLATE_DELETE_SUCCESS";
export const EXERCISE_TEMPLATE_DELETE_FAIL = "EXERCISE_TEMPLATE_DELETE_FAIL";

export const EXERCISE_TEMPLATE_DETAILS_REQUEST = 'EXERCISE_TEMPLATE_DETAILS_REQUEST';
export const EXERCISE_TEMPLATE_DETAILS_SUCCESS = 'EXERCISE_TEMPLATE_DETAILS_SUCCESS';
export const EXERCISE_TEMPLATE_DETAILS_FAIL = 'EXERCISE_TEMPLATE_DETAILS_FAIL';

export const EXERCISE_TEMPLATE_RESET = "EXERCISE_TEMPLATE_RESET";
// Diet Chart Types
export const GET_DIET = "GET_DIET";
export const CREATE_DIET = "CREATE_DIET";
export const UPDATE_DIET = "UPDATE_DIET";
export const DELETE_DIET = "DELETE_DIET";
// DIET TEMPLATE CONSTANTS
export const DIET_TEMPLATE_LIST_REQUEST = 'DIET_TEMPLATE_LIST_REQUEST';
export const DIET_TEMPLATE_LIST_SUCCESS = 'DIET_TEMPLATE_LIST_SUCCESS';
export const DIET_TEMPLATE_LIST_FAIL = 'DIET_TEMPLATE_LIST_FAIL';

export const DIET_TEMPLATE_CREATE_REQUEST = 'DIET_TEMPLATE_CREATE_REQUEST';
export const DIET_TEMPLATE_CREATE_SUCCESS = 'DIET_TEMPLATE_CREATE_SUCCESS';
export const DIET_TEMPLATE_CREATE_FAIL = 'DIET_TEMPLATE_CREATE_FAIL';

export const DIET_TEMPLATE_UPDATE_REQUEST = 'DIET_TEMPLATE_UPDATE_REQUEST';
export const DIET_TEMPLATE_UPDATE_SUCCESS = 'DIET_TEMPLATE_UPDATE_SUCCESS';
export const DIET_TEMPLATE_UPDATE_FAIL = 'DIET_TEMPLATE_UPDATE_FAIL';

export const DIET_TEMPLATE_DELETE_REQUEST = 'DIET_TEMPLATE_DELETE_REQUEST';
export const DIET_TEMPLATE_DELETE_SUCCESS = 'DIET_TEMPLATE_DELETE_SUCCESS';
export const DIET_TEMPLATE_DELETE_FAIL = 'DIET_TEMPLATE_DELETE_FAIL';

export const DIET_TEMPLATE_DETAILS_REQUEST = 'DIET_TEMPLATE_DETAILS_REQUEST';
export const DIET_TEMPLATE_DETAILS_SUCCESS = 'DIET_TEMPLATE_DETAILS_SUCCESS';
export const DIET_TEMPLATE_DETAILS_FAIL = 'DIET_TEMPLATE_DETAILS_FAIL';

export const DIET_TEMPLATE_RESET = 'DIET_TEMPLATE_RESET';
export const DIET_TEMPLATE_DETAILS_RESET = 'DIET_TEMPLATE_DETAILS_RESET';
//patient diet 
export const GET_PATIENT_DIET = "GET_PATIENT_DIET";
export const CREATE_PATIENT_DIET = "CREATE_PATIENT_DIET";
export const UPDATE_PATIENT_DIET = "UPDATE_PATIENT_DIET";
export const DELETE_PATIENT_DIET = "DELETE_PATIENT_DIET";
// Exercise chart
export const GET_EXERCISE = "GET_EXERCISE";
export const CREATE_EXERCISE = "CREATE_EXERCISE";
export const UPDATE_EXERCISE = "UPDATE_EXERCISE";
export const DELETE_EXERCISE = "DELETE_EXERCISE";
// Exercise assignment 
export const GET_EXERCISE_ASSIGNMENT = "GET_EXERCISE_ASSIGNMENT";
export const CREATE_EXERCISE_ASSIGNMENT = "CREATE_EXERCISE_ASSIGNMENT";
export const UPDATE_EXERCISE_ASSIGNMENT = "UPDATE_EXERCISE_ASSIGNMENT";
export const DELETE_EXERCISE_ASSIGNMENT = "DELETE_EXERCISE_ASSIGNMENT";
// Award delete
export const DELETE_AWARD_REQUEST = "DELETE_AWARD_REQUEST";
export const DELETE_AWARD_SUCCESS = "DELETE_AWARD_SUCCESS";
export const DELETE_AWARD_FAIL = "DELETE_AWARD_FAIL";

// Patient Reminder Types
export const GET_REMINDERS_REQUEST = 'GET_REMINDERS_REQUEST';
export const GET_REMINDERS_SUCCESS = 'GET_REMINDERS_SUCCESS';
export const GET_REMINDERS_FAIL = 'GET_REMINDERS_FAIL';
// Membership delete
export const DELETE_MEMBERSHIP_REQUEST = "DELETE_MEMBERSHIP_REQUEST";
export const DELETE_MEMBERSHIP_SUCCESS = "DELETE_MEMBERSHIP_SUCCESS";
export const DELETE_MEMBERSHIP_FAIL = "DELETE_MEMBERSHIP_FAIL";

// Registration delete
export const DELETE_REGISTRATION_REQUEST = "DELETE_REGISTRATION_REQUEST";
export const DELETE_REGISTRATION_SUCCESS = "DELETE_REGISTRATION_SUCCESS";
export const DELETE_REGISTRATION_FAIL = "DELETE_REGISTRATION_FAIL";

// type.js
export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const PATCH_CLINIC_IMAGE_SUCCESS = "PATCH_CLINIC_IMAGE_SUCCESS";
export const PATCH_CLINIC_IMAGE_FAIL = "PATCH_CLINIC_IMAGE_FAIL";

export const UPDATE_SERVICES_REQUEST = "UPDATE_SERVICES_REQUEST";
export const UPDATE_SERVICES_SUCCESS = "UPDATE_SERVICES_SUCCESS";
export const UPDATE_SERVICES_FAIL = "UPDATE_SERVICES_FAIL";

export const UPDATE_SPECIALIZATION_REQUEST = "UPDATE_SPECIALIZATION_REQUEST";

export const UPDATE_SPECIALIZATION_SUCCESS = "UPDATE_SPECIALIZATION_SUCCESS";
export const UPDATE_SPECIALIZATION_FAIL = "UPDATE_SPECIALIZATION_FAIL";

export const UPDATE_EDUCATION_REQUEST = "UPDATE_EDUCATION_REQUEST";
export const UPDATE_EDUCATION_SUCCESS = "UPDATE_EDUCATION_SUCCESS";
export const UPDATE_EDUCATION_FAIL = "UPDATE_EDUCATION_FAIL";

export const UPDATE_EXPERIENCE_REQUEST = "UPDATE_EXPERIENCE_REQUEST";
export const UPDATE_EXPERIENCE_SUCCESS = "UPDATE_EXPERIENCE_SUCCESS";
export const UPDATE_EXPERIENCE_FAIL = "UPDATE_EXPERIENCE_FAIL";

export const UPDATE_AWARDS_REQUEST = "UPDATE_AWARDS_REQUEST";
export const UPDATE_AWARDS_SUCCESS = "UPDATE_AWARDS_SUCCESS";
export const UPDATE_AWARDS_FAIL = "UPDATE_AWARDS_FAIL";

export const UPDATE_MEMBERSHIPS_REQUEST = "UPDATE_MEMBERSHIPS_REQUEST";
export const UPDATE_MEMBERSHIPS_SUCCESS = "UPDATE_MEMBERSHIPS_SUCCESS";
export const UPDATE_MEMBERSHIPS_FAIL = "UPDATE_MEMBERSHIPS_FAIL";

export const UPDATE_REGISTRATIONS_REQUEST = "UPDATE_REGISTRATIONS_REQUEST";
export const UPDATE_REGISTRATIONS_SUCCESS = "UPDATE_REGISTRATIONS_SUCCESS";
export const UPDATE_REGISTRATIONS_FAIL = "UPDATE_REGISTRATIONS_FAIL";

export const PATCH_CLINIC_IMAGE_REQUEST = "PATCH_CLINIC_IMAGE_REQUEST";

export const PATIENT_PROFILE_CREATED = "PATIENT_PROFILE_CREATED";
export const GET_ALL_PATIENT_PROFILES = "GET_ALL_PATIENT_PROFILES";
export const GET_ONE_PATIENT_PROFILE = "GET_ONE_PATIENT_PROFILE";
export const PATIENT_PROFILE_UPDATED = "PATIENT_PROFILE_UPDATED";
export const PATIENT_PROFILE_DELETED = "PATIENT_PROFILE_DELETED";
// Patient Profile Types
export const GET_ALL_PATIENT_PROFILES_REQUEST =
  "GET_ALL_PATIENT_PROFILES_REQUEST";
export const GET_ALL_PATIENT_PROFILES_SUCCESS =
  "GET_ALL_PATIENT_PROFILES_SUCCESS";
export const GET_ALL_PATIENT_PROFILES_FAIL = "GET_ALL_PATIENT_PROFILES_FAIL";

export const APPOINTMENT_REQUEST = "APPOINTMENT_REQUEST";
export const APPOINTMENT_SUCCESS = "APPOINTMENT_SUCCESS";
export const APPOINTMENT_FAIL = "APPOINTMENT_FAIL";

export const APPOINTMENT_GET_ALL = "APPOINTMENT_GET_ALL";
export const APPOINTMENT_GET_ONE = "APPOINTMENT_GET_ONE";
export const APPOINTMENT_CREATE = "APPOINTMENT_CREATE";
export const APPOINTMENT_UPDATE = "APPOINTMENT_UPDATE";
export const APPOINTMENT_DELETE = "APPOINTMENT_DELETE";

// actions/types.js
export const CREATE_PRESCRIPTION = "CREATE_PRESCRIPTION";
export const CREATE_PRESCRIPTION_SUCCESS = "CREATE_PRESCRIPTION_SUCCESS";
export const CREATE_PRESCRIPTION_FAIL = "CREATE_PRESCRIPTION_FAIL";

export const GET_PRESCRIPTIONS = "GET_PRESCRIPTIONS";
export const GET_PRESCRIPTIONS_SUCCESS = "GET_PRESCRIPTIONS_SUCCESS";
export const GET_PRESCRIPTIONS_FAIL = "GET_PRESCRIPTIONS_FAIL";

export const UPDATE_PRESCRIPTION = "UPDATE_PRESCRIPTION";
export const UPDATE_PRESCRIPTION_SUCCESS = "UPDATE_PRESCRIPTION_SUCCESS";
export const UPDATE_PRESCRIPTION_FAIL = "UPDATE_PRESCRIPTION_FAIL";

export const DELETE_PRESCRIPTION = "DELETE_PRESCRIPTION";
export const DELETE_PRESCRIPTION_SUCCESS = "DELETE_PRESCRIPTION_SUCCESS";
export const DELETE_PRESCRIPTION_FAIL = "DELETE_PRESCRIPTION_FAIL";

// Medical Record Types
export const GET_ALL_MEDICAL_RECORDS_SUCCESS =
  "GET_ALL_MEDICAL_RECORDS_SUCCESS";
export const CREATE_MEDICAL_RECORD_SUCCESS = "CREATE_MEDICAL_RECORD_SUCCESS";
export const DELETE_MEDICAL_RECORD_SUCCESS = "DELETE_MEDICAL_RECORD_SUCCESS";
export const MEDICAL_RECORD_ERROR = "MEDICAL_RECORD_ERROR";

export const UPDATE_MEDICAL_RECORD_SUCCESS = "UPDATE_MEDICAL_RECORD_SUCCESS";

// Review & Feedback Types
export const GET_REVIEWS_REQUEST = "GET_REVIEWS_REQUEST";
export const GET_REVIEWS_SUCCESS = "GET_REVIEWS_SUCCESS";
export const GET_REVIEWS_FAILURE = "GET_REVIEWS_FAILURE";

export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAILURE = "CREATE_REVIEW_FAILURE";
export const RESET_REVIEW_STATE = "RESET_REVIEW_STATE"; // To reset the form state

export const UPDATE_REVIEW_REQUEST = "UPDATE_REVIEW_REQUEST";
export const UPDATE_REVIEW_SUCCESS = "UPDATE_REVIEW_SUCCESS";
export const UPDATE_REVIEW_FAILURE = "UPDATE_REVIEW_FAILURE";

export const DELETE_REVIEW_REQUEST = "DELETE_REVIEW_REQUEST";
export const DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS";
export const DELETE_REVIEW_FAILURE = "DELETE_REVIEW_FAILURE";
export const GET_ALL_REVIEWS_ADMIN_SUCCESS = "GET_ALL_REVIEWS_ADMIN_SUCCESS";

export const GET_REVIEWS_BY_PATIENT_REQUEST = "GET_REVIEWS_BY_PATIENT_REQUEST";
export const GET_REVIEWS_BY_PATIENT_SUCCESS = "GET_REVIEWS_BY_PATIENT_SUCCESS";
export const GET_REVIEWS_BY_PATIENT_FAILURE = "GET_REVIEWS_BY_PATIENT_FAILURE";
// src/actions/types.js

// A constant for the base image URL, used for displaying doctor photos.

// ===================================================================
// Schedule Actions (for both Doctor's management and Patient's view)
// ===================================================================

// For fetching all schedule data (template, holidays, blockers)
export const GET_SCHEDULE_DATA_REQUEST = "GET_SCHEDULE_DATA_REQUEST";
export const GET_SCHEDULE_DATA_SUCCESS = "GET_SCHEDULE_DATA_SUCCESS";
export const GET_SCHEDULE_DATA_FAILURE = "GET_SCHEDULE_DATA_FAILURE";

// For adding a new template slot (Doctor's view)
export const SAVE_TEMPLATE_SLOT_REQUEST = "SAVE_TEMPLATE_SLOT_REQUEST";
export const SAVE_TEMPLATE_SLOT_SUCCESS = "SAVE_TEMPLATE_SLOT_SUCCESS";
export const SAVE_TEMPLATE_SLOT_FAILURE = "SAVE_TEMPLATE_SLOT_FAILURE";

// For adding a full day off / holiday (Doctor's view)
export const ADD_DAY_OFF_REQUEST = "ADD_DAY_OFF_REQUEST";
export const ADD_DAY_OFF_SUCCESS = "ADD_DAY_OFF_SUCCESS";
export const ADD_DAY_OFF_FAILURE = "ADD_DAY_OFF_FAILURE";

// For adding a partial-day unavailability / blocker (Doctor's view)
export const ADD_BLOCKER_REQUEST = "ADD_BLOCKER_REQUEST";
export const ADD_BLOCKER_SUCCESS = "ADD_BLOCKER_SUCCESS";
export const ADD_BLOCKER_FAILURE = "ADD_BLOCKER_FAILURE";

// For deleting any schedule entry (template, holiday, or blocker) (Doctor's view)
export const DELETE_SCHEDULE_ENTRY_REQUEST = "DELETE_SCHEDULE_ENTRY_REQUEST";
export const DELETE_SCHEDULE_ENTRY_SUCCESS = "DELETE_SCHEDULE_ENTRY_SUCCESS";
export const DELETE_SCHEDULE_ENTRY_FAILURE = "DELETE_SCHEDULE_ENTRY_FAILURE";

// ===============================================
// Booking Flow Actions (for Patient's booking UI)
// ===============================================

export const SET_WEEK_OFFSET = "SET_WEEK_OFFSET";
export const SELECT_SLOT = "SELECT_SLOT";
export const SET_APPOINTMENT_TYPE = "SET_APPOINTMENT_TYPE";
export const SET_BOOKING_ERROR = "SET_BOOKING_ERROR";
export const SET_BOOKING_SUCCESS = "SET_BOOKING_SUCCESS";
export const CLEAR_BOOKING_STATE = "CLEAR_BOOKING_STATE"; // Useful for resetting the state when the user leaves the page

// ===============================================
// Doctor Profile Actions
// ===============================================

export const GET_DOCTOR_PROFILE_BY_ID_REQUEST =
  "GET_DOCTOR_PROFILE_BY_ID_REQUEST";
export const GET_DOCTOR_PROFILE_BY_ID_SUCCESS =
  "GET_DOCTOR_PROFILE_BY_ID_SUCCESS";
export const GET_DOCTOR_PROFILE_BY_ID_FAILURE =
  "GET_DOCTOR_PROFILE_BY_ID_FAILURE";

// --- LIKE/DISLIKE ACTION TYPES ---
export const GET_ALL_LIKES_REQUEST = "GET_ALL_LIKES_REQUEST";
export const GET_ALL_LIKES_SUCCESS = "GET_ALL_LIKES_SUCCESS";
export const GET_ALL_LIKES_FAIL = "GET_ALL_LIKES_FAIL";

export const GET_ONE_LIKE_REQUEST = "GET_ONE_LIKE_REQUEST";
export const GET_ONE_LIKE_SUCCESS = "GET_ONE_LIKE_SUCCESS";
export const GET_ONE_LIKE_FAIL = "GET_ONE_LIKE_FAIL";

export const CREATE_LIKE_REQUEST = "CREATE_LIKE_REQUEST";
export const CREATE_LIKE_SUCCESS = "CREATE_LIKE_SUCCESS";
export const CREATE_LIKE_FAIL = "CREATE_LIKE_FAIL";

export const UPDATE_LIKE_REQUEST = "UPDATE_LIKE_REQUEST";
export const UPDATE_LIKE_SUCCESS = "UPDATE_LIKE_SUCCESS";
export const UPDATE_LIKE_FAIL = "UPDATE_LIKE_FAIL";

export const DELETE_LIKE_REQUEST = "DELETE_LIKE_REQUEST";
export const DELETE_LIKE_SUCCESS = "DELETE_LIKE_SUCCESS";
export const DELETE_LIKE_FAIL = "DELETE_LIKE_FAIL";

export const RESET_LIKE_STATE = "RESET_LIKE_STATE";

// Forgot Password Actions
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const CLEAR_FORGOT_PASSWORD_STATE = "CLEAR_FORGOT_PASSWORD_STATE"; // To clear messages on component unmount

// Reset Password (Create New Password) Actions
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";
export const CLEAR_RESET_PASSWORD_STATE = "CLEAR_RESET_PASSWORD_STATE"; // To clear messages when the user navigates away


// Appointment Invoice Action Types
export const INVOICE_CREATE_REQUEST = "INVOICE_CREATE_REQUEST";
export const INVOICE_CREATE_SUCCESS = "INVOICE_CREATE_SUCCESS";
export const INVOICE_CREATE_FAIL = "INVOICE_CREATE_FAIL";

export const INVOICE_LIST_REQUEST = "INVOICE_LIST_REQUEST";
export const INVOICE_LIST_SUCCESS = "INVOICE_LIST_SUCCESS";
export const INVOICE_LIST_FAIL = "INVOICE_LIST_FAIL";

export const INVOICE_LIST_ALL_REQUEST = "INVOICE_LIST_ALL_REQUEST";
export const INVOICE_LIST_ALL_SUCCESS = "INVOICE_LIST_ALL_SUCCESS";
export const INVOICE_LIST_ALL_FAIL = "INVOICE_LIST_ALL_FAIL";

export const INVOICE_UPDATE_REQUEST = "INVOICE_UPDATE_REQUEST";
export const INVOICE_UPDATE_SUCCESS = "INVOICE_UPDATE_SUCCESS";
export const INVOICE_UPDATE_FAIL = "INVOICE_UPDATE_FAIL";

// GET
export const GET_UPI_DETAILS_REQUEST = "GET_UPI_DETAILS_REQUEST";
export const GET_UPI_DETAILS_SUCCESS = "GET_UPI_DETAILS_SUCCESS";
export const GET_UPI_DETAILS_FAIL = "GET_UPI_DETAILS_FAIL";
// SUBMIT (CREATE)
export const SUBMIT_UPI_DETAILS_REQUEST = "SUBMIT_UPI_DETAILS_REQUEST";
export const SUBMIT_UPI_DETAILS_SUCCESS = "SUBMIT_UPI_DETAILS_SUCCESS";
export const SUBMIT_UPI_DETAILS_FAIL = "SUBMIT_UPI_DETAILS_FAIL";
// UPDATE
export const UPDATE_UPI_DETAILS_REQUEST = "UPDATE_UPI_DETAILS_REQUEST";
export const UPDATE_UPI_DETAILS_SUCCESS = "UPDATE_UPI_DETAILS_SUCCESS";
export const UPDATE_UPI_DETAILS_FAIL = "UPDATE_UPI_DETAILS_FAIL";
// DELETE
export const DELETE_UPI_DETAILS_REQUEST = "DELETE_UPI_DETAILS_REQUEST";
export const DELETE_UPI_DETAILS_SUCCESS = "DELETE_UPI_DETAILS_SUCCESS";
export const DELETE_UPI_DETAILS_FAIL = "DELETE_UPI_DETAILS_FAIL";

// ==============================
// --- Bank Detail Action Types ---
// ==============================
// GET
export const GET_BANK_DETAILS_REQUEST = "GET_BANK_DETAILS_REQUEST";
export const GET_BANK_DETAILS_SUCCESS = "GET_BANK_DETAILS_SUCCESS";
export const GET_BANK_DETAILS_FAIL = "GET_BANK_DETAILS_FAIL";
// SUBMIT (CREATE)
export const SUBMIT_BANK_DETAILS_REQUEST = "SUBMIT_BANK_DETAILS_REQUEST";
export const SUBMIT_BANK_DETAILS_SUCCESS = "SUBMIT_BANK_DETAILS_SUCCESS";
export const SUBMIT_BANK_DETAILS_FAIL = "SUBMIT_BANK_DETAILS_FAIL";
// UPDATE
export const UPDATE_BANK_DETAILS_REQUEST = "UPDATE_BANK_DETAILS_REQUEST";
export const UPDATE_BANK_DETAILS_SUCCESS = "UPDATE_BANK_DETAILS_SUCCESS";
export const UPDATE_BANK_DETAILS_FAIL = "UPDATE_BANK_DETAILS_FAIL";
// DELETE
export const DELETE_BANK_DETAILS_REQUEST = "DELETE_BANK_DETAILS_REQUEST";
export const DELETE_BANK_DETAILS_SUCCESS = "DELETE_BANK_DETAILS_SUCCESS";
export const DELETE_BANK_DETAILS_FAIL = "DELETE_BANK_DETAILS_FAIL";

// ==============================
// --- Card Detail Action Types (if needed) ---
// ==============================
export const SUBMIT_CARD_DETAILS_REQUEST = "SUBMIT_CARD_DETAILS_REQUEST";
export const SUBMIT_CARD_DETAILS_SUCCESS = "SUBMIT_CARD_DETAILS_SUCCESS";
export const SUBMIT_CARD_DETAILS_FAIL = "SUBMIT_CARD_DETAILS_FAIL";
export const UPDATE_CARD_DETAILS_REQUEST = "UPDATE_CARD_DETAILS_REQUEST";
export const UPDATE_CARD_DETAILS_SUCCESS = "UPDATE_CARD_DETAILS_SUCCESS";
export const UPDATE_CARD_DETAILS_FAIL = "UPDATE_CARD_DETAILS_FAIL";
export const DELETE_CARD_DETAILS_REQUEST = "DELETE_CARD_DETAILS_REQUEST";
export const DELETE_CARD_DETAILS_SUCCESS = "DELETE_CARD_DETAILS_SUCCESS";
export const DELETE_CARD_DETAILS_FAIL = "DELETE_CARD_DETAILS_FAIL";



// Invoice Action Types
export const LIST_INVOICES_REQUEST = "LIST_INVOICES_REQUEST";
export const LIST_INVOICES_SUCCESS = "LIST_INVOICES_SUCCESS";
export const LIST_INVOICES_FAIL = "LIST_INVOICES_FAIL";
export const UPDATE_INVOICE_SUCCESS = "UPDATE_INVOICE_SUCCESS";

// Payout Initiation Action Types
export const PAYOUT_INITIATE_REQUEST = "PAYOUT_INITIATE_REQUEST";
export const PAYOUT_INITIATE_SUCCESS = "PAYOUT_INITIATE_SUCCESS";
export const PAYOUT_INITIATE_FAIL = "PAYOUT_INITIATE_FAIL";
export const PAYOUT_INITIATE_RESET = "PAYOUT_INITIATE_RESET";

// ✅ ADD THESE NEW TYPES FOR POLLING
export const CHECK_PAYOUT_STATUS_REQUEST = "CHECK_PAYOUT_STATUS_REQUEST";
export const CHECK_PAYOUT_STATUS_SUCCESS = "CHECK_PAYOUT_STATUS_SUCCESS";
export const CHECK_PAYOUT_STATUS_FAIL = "CHECK_PAYOUT_STATUS_FAIL";

//main transfer
export const CREATE_PAYOUT_RECORD = "CREATE_PAYOUT_RECORD";
export const UPDATE_PAYOUT_RECORD_STATUS = "UPDATE_PAYOUT_RECORD_STATUS";
export const CLEAR_PAYOUT_RECORDS = "CLEAR_PAYOUT_RECORDS"; // To clear on component unmount


// LIST all payout records for a doctor
export const DOCTOR_PAYOUT_LIST_REQUEST = "DOCTOR_PAYOUT_LIST_REQUEST";
export const DOCTOR_PAYOUT_LIST_SUCCESS = "DOCTOR_PAYOUT_LIST_SUCCESS";
export const DOCTOR_PAYOUT_LIST_FAIL = "DOCTOR_PAYOUT_LIST_FAIL";

// CREATE a new payout record
export const DOCTOR_PAYOUT_CREATE_REQUEST = "DOCTOR_PAYOUT_CREATE_REQUEST";
export const DOCTOR_PAYOUT_CREATE_SUCCESS = "DOCTOR_PAYOUT_CREATE_SUCCESS";
export const DOCTOR_PAYOUT_CREATE_FAIL = "DOCTOR_PAYOUT_CREATE_FAIL";

// UPDATE an existing payout record (e.g., with payoutId or final status)
export const DOCTOR_PAYOUT_UPDATE_REQUEST = "DOCTOR_PAYOUT_UPDATE_REQUEST";
export const DOCTOR_PAYOUT_UPDATE_SUCCESS = "DOCTOR_PAYOUT_UPDATE_SUCCESS";
export const DOCTOR_PAYOUT_UPDATE_FAIL = "DOCTOR_PAYOUT_UPDATE_FAIL";

// For fetching likes by a specific patient
export const GET_LIKES_BY_PATIENT_REQUEST = "GET_LIKES_BY_PATIENT_REQUEST";
export const GET_LIKES_BY_PATIENT_SUCCESS = "GET_LIKES_BY_PATIENT_SUCCESS";
export const GET_LIKES_BY_PATIENT_FAIL = "GET_LIKES_BY_PATIENT_FAIL";

export const GET_ALL_SOCIAL_MEDIA = "GET_ALL_SOCIAL_MEDIA";

// For Creating Coupons
export const SUBMIT_COUPON_SUCCESS = "SUBMIT_COUPON_SUCCESS";
export const SUBMIT_COUPON_FAIL = "SUBMIT_COUPON_FAIL";

// For Updating Coupons
export const UPDATE_COUPON_SUCCESS = "UPDATE_COUPON_SUCCESS";
export const UPDATE_COUPON_FAIL = "UPDATE_COUPON_FAIL";

// For Deleting Coupons
export const DELETE_COUPON_REQUEST = "DELETE_COUPON_REQUEST";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";
export const DELETE_COUPON_FAIL = "DELETE_COUPON_FAIL";

export const GET_COUPON_BY_CODE_REQUEST = "GET_COUPON_BY_CODE_REQUEST";
export const GET_COUPON_BY_CODE_SUCCESS = "GET_COUPON_BY_CODE_SUCCESS";
export const GET_COUPON_BY_CODE_FAIL = "GET_COUPON_BY_CODE_FAIL";

// ... your existing action types
export const GET_REPORT_SETTINGS_REQUEST = "GET_REPORT_SETTINGS_REQUEST";
export const GET_REPORT_SETTINGS_SUCCESS = "GET_REPORT_SETTINGS_SUCCESS";
export const GET_REPORT_SETTINGS_FAIL = "GET_REPORT_SETTINGS_FAIL";

export const UPDATE_REPORT_SETTINGS_REQUEST = "UPDATE_REPORT_SETTINGS_REQUEST";
export const UPDATE_REPORT_SETTINGS_SUCCESS = "UPDATE_REPORT_SETTINGS_SUCCESS";
export const UPDATE_REPORT_SETTINGS_FAIL = "UPDATE_REPORT_SETTINGS_FAIL";

export const CREATE_REPORT_SETTINGS_REQUEST = "CREATE_REPORT_SETTINGS_REQUEST";
export const CREATE_REPORT_SETTINGS_SUCCESS = "CREATE_REPORT_SETTINGS_SUCCESS";
export const CREATE_REPORT_SETTINGS_FAIL = "CREATE_REPORT_SETTINGS_FAIL";

// --- Favourites Action Types ---
export const GET_ALL_FAVOURITES_REQUEST = "GET_ALL_FAVOURITES_REQUEST";
export const GET_ALL_FAVOURITES_SUCCESS = "GET_ALL_FAVOURITES_SUCCESS";
export const GET_ALL_FAVOURITES_FAIL = "GET_ALL_FAVOURITES_FAIL";

export const ADD_FAVOURITE_REQUEST = "ADD_FAVOURITE_REQUEST";
export const ADD_FAVOURITE_SUCCESS = "ADD_FAVOURITE_SUCCESS";
export const ADD_FAVOURITE_FAIL = "ADD_FAVOURITE_FAIL";

export const UPDATE_FAVOURITE_REQUEST = "UPDATE_FAVOURITE_REQUEST";
export const UPDATE_FAVOURITE_SUCCESS = "UPDATE_FAVOURITE_SUCCESS";
export const UPDATE_FAVOURITE_FAIL = "UPDATE_FAVOURITE_FAIL";

export const DELETE_FAVOURITE_REQUEST = "DELETE_FAVOURITE_REQUEST";
export const DELETE_FAVOURITE_SUCCESS = "DELETE_FAVOURITE_SUCCESS";
export const DELETE_FAVOURITE_FAIL = "DELETE_FAVOURITE_FAIL";

// Action types for provisioning a video session (at checkout)
export const PROVISION_SESSION_REQUEST = "PROVISION_SESSION_REQUEST";
export const PROVISION_SESSION_SUCCESS = "PROVISION_SESSION_SUCCESS";
export const PROVISION_SESSION_FAIL = "PROVISION_SESSION_FAIL";

export const SET_USER_ROLE = "SET_USER_ROLE";

// Action types for generating a user token (before joining a call)
export const GENERATE_TOKEN_REQUEST = "GENERATE_TOKEN_REQUEST";
export const GENERATE_TOKEN_SUCCESS = "GENERATE_TOKEN_SUCCESS";
export const GENERATE_TOKEN_FAIL = "GENERATE_TOKEN_FAIL";
export const CHECK_SESSION_STATUS_FAIL = "CHECK_SESSION_STATUS_FAIL";
export const CHECK_SESSION_STATUS_REQUEST = "CHECK_SESSION_STATUS_REQUEST";
export const CHECK_SESSION_STATUS_SUCCESS = "CHECK_SESSION_STATUS_SUCCESS";

// Action type for cleaning up the state (after a call or on error)
export const CLEAR_VIDEO_STATE = "CLEAR_VIDEO_STATE";

// src/actions/smsTypes.js
export const SEND_SMS_REQUEST = "SEND_SMS_REQUEST";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_FAILURE = "SEND_SMS_FAILURE";

// Platform Charge Settings Action Types
export const GET_PLATFORM_SETTINGS_REQUEST = "GET_PLATFORM_SETTINGS_REQUEST";
export const GET_PLATFORM_SETTINGS_SUCCESS = "GET_PLATFORM_SETTINGS_SUCCESS";
export const GET_PLATFORM_SETTINGS_FAIL = "GET_PLATFORM_SETTINGS_FAIL";

// A single "SAVE" action will handle both CREATE and UPDATE from the UI's perspective
export const SAVE_PLATFORM_SETTINGS_REQUEST = "SAVE_PLATFORM_SETTINGS_REQUEST";
export const SAVE_PLATFORM_SETTINGS_SUCCESS = "SAVE_PLATFORM_SETTINGS_SUCCESS";
export const SAVE_PLATFORM_SETTINGS_FAIL = "SAVE_PLATFORM_SETTINGS_FAIL";

// Family Members Types
export const SET_FAMILY_MEMBERS = "SET_FAMILY_MEMBERS";
export const GET_FAMILY_MEMBERS = "GET_FAMILY_MEMBERS";
export const UPDATE_FAMILY_MEMBER = "UPDATE_FAMILY_MEMBER";
export const DELETE_FAMILY_MEMBER = "DELETE_FAMILY_MEMBER";
export const FAMILY_MEMBERS_LOADING = "FAMILY_MEMBERS_LOADING";
export const FAMILY_MEMBERS_ERROR = "FAMILY_MEMBERS_ERROR";
export const CLEAR_FAMILY_MEMBERS = "CLEAR_FAMILY_MEMBERS";

// src/actions/types.js
// Blog Types
export const BLOG_CREATE_REQUEST = "BLOG_CREATE_REQUEST";
export const BLOG_CREATE_SUCCESS = "BLOG_CREATE_SUCCESS";
export const BLOG_CREATE_FAIL = "BLOG_CREATE_FAIL";
export const BLOG_CREATE_RESET = "BLOG_CREATE_RESET";

export const BLOG_LIST_REQUEST = "BLOG_LIST_REQUEST";
export const BLOG_LIST_SUCCESS = "BLOG_LIST_SUCCESS";
export const BLOG_LIST_FAIL = "BLOG_LIST_FAIL";

export const BLOG_DETAILS_REQUEST = "BLOG_DETAILS_REQUEST";
export const BLOG_DETAILS_SUCCESS = "BLOG_DETAILS_SUCCESS";
export const BLOG_DETAILS_FAIL = "BLOG_DETAILS_FAIL";

export const BLOG_UPDATE_REQUEST = "BLOG_UPDATE_REQUEST";
export const BLOG_UPDATE_SUCCESS = "BLOG_UPDATE_SUCCESS";
export const BLOG_UPDATE_FAIL = "BLOG_UPDATE_FAIL";
export const BLOG_UPDATE_RESET = "BLOG_UPDATE_RESET";

export const BLOG_DELETE_REQUEST = "BLOG_DELETE_REQUEST";
export const BLOG_DELETE_SUCCESS = "BLOG_DELETE_SUCCESS";
export const BLOG_DELETE_FAIL = "BLOG_DELETE_FAIL";

export const FETCH_PATIENT_METRICS_REQUEST = "FETCH_PATIENT_METRICS_REQUEST";
export const FETCH_PATIENT_METRICS_SUCCESS = "FETCH_PATIENT_METRICS_SUCCESS";
export const FETCH_PATIENT_METRICS_FAIL = "FETCH_PATIENT_METRICS_FAIL";

export const METRIC_UPDATE_REQUEST = "METRIC_UPDATE_REQUEST";
export const METRIC_UPDATE_SUCCESS = "METRIC_UPDATE_SUCCESS";
export const METRIC_UPDATE_FAIL = "METRIC_UPDATE_FAIL";


// Business Module Types
export const CREATE_BUSINESS_MODULE_REQUEST = 'CREATE_BUSINESS_MODULE_REQUEST';
export const CREATE_BUSINESS_MODULE_SUCCESS = 'CREATE_BUSINESS_MODULE_SUCCESS';
export const CREATE_BUSINESS_MODULE_FAILURE = 'CREATE_BUSINESS_MODULE_FAILURE';

export const GET_BUSINESS_MODULE_REQUEST = 'GET_BUSINESS_MODULE_REQUEST';
export const GET_BUSINESS_MODULE_SUCCESS = 'GET_BUSINESS_MODULE_SUCCESS';
export const GET_BUSINESS_MODULE_FAILURE = 'GET_BUSINESS_MODULE_FAILURE';

export const UPDATE_BUSINESS_MODULE_REQUEST = 'UPDATE_BUSINESS_MODULE_REQUEST';
export const UPDATE_BUSINESS_MODULE_SUCCESS = 'UPDATE_BUSINESS_MODULE_SUCCESS';
export const UPDATE_BUSINESS_MODULE_FAILURE = 'UPDATE_BUSINESS_MODULE_FAILURE';

export const DELETE_BUSINESS_MODULE_REQUEST = 'DELETE_BUSINESS_MODULE_REQUEST';
export const DELETE_BUSINESS_MODULE_SUCCESS = 'DELETE_BUSINESS_MODULE_SUCCESS';
export const DELETE_BUSINESS_MODULE_FAILURE = 'DELETE_BUSINESS_MODULE_FAILURE';

// Generic status
export const CLEAR_BUSINESS_MODULE_ERROR = 'CLEAR_BUSINESS_MODULE_ERROR';
export const CLEAR_BUSINESS_MODULE_SUCCESS = 'CLEAR_BUSINESS_MODULE_SUCCESS';


// Add these to your existing types
export const GET_ACCOUNT_STATUS_REQUEST = 'GET_ACCOUNT_STATUS_REQUEST';
export const GET_ACCOUNT_STATUS_SUCCESS = 'GET_ACCOUNT_STATUS_SUCCESS';
export const GET_ACCOUNT_STATUS_FAILURE = 'GET_ACCOUNT_STATUS_FAILURE';
export const CLEAR_ACCOUNT_STATUS_ERROR = 'CLEAR_ACCOUNT_STATUS_ERROR';


// Business Model Types
export const GET_BUSINESS_MODELS_REQUEST = "GET_BUSINESS_MODELS_REQUEST";
export const GET_BUSINESS_MODELS_SUCCESS = "GET_BUSINESS_MODELS_SUCCESS";
export const GET_BUSINESS_MODELS_FAIL = "GET_BUSINESS_MODELS_FAIL";

export const CREATE_BUSINESS_MODEL_REQUEST = "CREATE_BUSINESS_MODEL_REQUEST";
export const CREATE_BUSINESS_MODEL_SUCCESS = "CREATE_BUSINESS_MODEL_SUCCESS";
export const CREATE_BUSINESS_MODEL_FAIL = "CREATE_BUSINESS_MODEL_FAIL";

export const UPDATE_BUSINESS_MODEL_REQUEST = "UPDATE_BUSINESS_MODEL_REQUEST";
export const UPDATE_BUSINESS_MODEL_SUCCESS = "UPDATE_BUSINESS_MODEL_SUCCESS";
export const UPDATE_BUSINESS_MODEL_FAIL = "UPDATE_BUSINESS_MODEL_FAIL";
export const DELETE_BUSINESS_MODEL_REQUEST = "DELETE_BUSINESS_MODEL_REQUEST";
export const DELETE_BUSINESS_MODEL_SUCCESS = "DELETE_BUSINESS_MODEL_REQUEST";
export const DELETE_BUSINESS_MODEL_FAIL = "DELETE_BUSINESS_MODEL_REQUEST";

// Add-on Package Types
export const GET_ADDON_PACKAGES_REQUEST = "GET_ADDON_PACKAGES_REQUEST";
export const GET_ADDON_PACKAGES_SUCCESS = "GET_ADDON_PACKAGES_SUCCESS";
export const GET_ADDON_PACKAGES_FAIL = "GET_ADDON_PACKAGES_FAIL";

export const CREATE_ADDON_PACKAGE_REQUEST = "CREATE_ADDON_PACKAGE_REQUEST";
export const CREATE_ADDON_PACKAGE_SUCCESS = "CREATE_ADDON_PACKAGE_SUCCESS";
export const CREATE_ADDON_PACKAGE_FAIL = "CREATE_ADDON_PACKAGE_FAIL";

export const UPDATE_ADDON_PACKAGE_REQUEST = "UPDATE_ADDON_PACKAGE_REQUEST";
export const UPDATE_ADDON_PACKAGE_SUCCESS = "UPDATE_ADDON_PACKAGE_SUCCESS";
export const UPDATE_ADDON_PACKAGE_FAIL = "UPDATE_ADDON_PACKAGE_FAIL";

export const DELETE_ADDON_PACKAGE_REQUEST = "GET_ADDON_PACKAGES_FAIL";
export const DELETE_ADDON_PACKAGE_SUCCESS = "GET_ADDON_PACKAGES_FAIL";
export const DELETE_ADDON_PACKAGE_FAIL = "GET_ADDON_PACKAGES_FAIL";


// Discount Types
export const GET_DISCOUNTS_REQUEST = 'GET_DISCOUNTS_REQUEST';
export const GET_DISCOUNTS_SUCCESS = 'GET_DISCOUNTS_SUCCESS';
export const GET_DISCOUNTS_FAIL = 'GET_DISCOUNTS_FAIL';

export const CREATE_DISCOUNT_REQUEST = 'CREATE_DISCOUNT_REQUEST';
export const CREATE_DISCOUNT_SUCCESS = 'CREATE_DISCOUNT_SUCCESS';
export const CREATE_DISCOUNT_FAIL = 'CREATE_DISCOUNT_FAIL';

export const UPDATE_DISCOUNT_REQUEST = 'UPDATE_DISCOUNT_REQUEST';
export const UPDATE_DISCOUNT_SUCCESS = 'UPDATE_DISCOUNT_SUCCESS';
export const UPDATE_DISCOUNT_FAIL = 'UPDATE_DISCOUNT_FAIL';

export const DELETE_DISCOUNT_REQUEST = 'DELETE_DISCOUNT_REQUEST';
export const DELETE_DISCOUNT_SUCCESS = 'DELETE_DISCOUNT_SUCCESS';
export const DELETE_DISCOUNT_FAIL = 'DELETE_DISCOUNT_FAIL';







export const NOTIFICATION_ACTION_TYPES = {
  // Email Settings
  CREATE_EMAIL_SETTING_REQUEST: 'CREATE_EMAIL_SETTING_REQUEST',
  CREATE_EMAIL_SETTING_SUCCESS: 'CREATE_EMAIL_SETTING_SUCCESS',
  CREATE_EMAIL_SETTING_FAIL: 'CREATE_EMAIL_SETTING_FAIL',
  
  GET_EMAIL_SETTINGS_REQUEST: 'GET_EMAIL_SETTINGS_REQUEST',
  GET_EMAIL_SETTINGS_SUCCESS: 'GET_EMAIL_SETTINGS_SUCCESS',
  GET_EMAIL_SETTINGS_FAIL: 'GET_EMAIL_SETTINGS_FAIL',
  
  UPDATE_EMAIL_SETTING_REQUEST: 'UPDATE_EMAIL_SETTING_REQUEST',
  UPDATE_EMAIL_SETTING_SUCCESS: 'UPDATE_EMAIL_SETTING_SUCCESS',
  UPDATE_EMAIL_SETTING_FAIL: 'UPDATE_EMAIL_SETTING_FAIL',
  
  DELETE_EMAIL_SETTING_REQUEST: 'DELETE_EMAIL_SETTING_REQUEST',
  DELETE_EMAIL_SETTING_SUCCESS: 'DELETE_EMAIL_SETTING_SUCCESS',
  DELETE_EMAIL_SETTING_FAIL: 'DELETE_EMAIL_SETTING_FAIL',

   // TWILIO SMS SETTINGS (getall1)
    CREATE_TWILIO_SMS_SETTING_REQUEST: 'CREATE_TWILIO_SMS_SETTING_REQUEST',
    CREATE_TWILIO_SMS_SETTING_SUCCESS: 'CREATE_TWILIO_SMS_SETTING_SUCCESS',
    CREATE_TWILIO_SMS_SETTING_FAIL: 'CREATE_TWILIO_SMS_SETTING_FAIL',

    GET_TWILIO_SMS_SETTINGS_REQUEST: 'GET_TWILIO_SMS_SETTINGS_REQUEST',
    GET_TWILIO_SMS_SETTINGS_SUCCESS: 'GET_TWILIO_SMS_SETTINGS_SUCCESS',
    GET_TWILIO_SMS_SETTINGS_FAIL: 'GET_TWILIO_SMS_SETTINGS_FAIL',

    UPDATE_TWILIO_SMS_SETTING_REQUEST: 'UPDATE_TWILIO_SMS_SETTING_REQUEST',
    UPDATE_TWILIO_SMS_SETTING_SUCCESS: 'UPDATE_TWILIO_SMS_SETTING_SUCCESS',
    UPDATE_TWILIO_SMS_SETTING_FAIL: 'UPDATE_TWILIO_SMS_SETTING_FAIL',

    DELETE_TWILIO_SMS_SETTING_REQUEST: 'DELETE_TWILIO_SMS_SETTING_REQUEST',
    DELETE_TWILIO_SMS_SETTING_SUCCESS: 'DELETE_TWILIO_SMS_SETTING_SUCCESS',
    DELETE_TWILIO_SMS_SETTING_FAIL: 'DELETE_TWILIO_SMS_SETTING_FAIL',

  // MSG Club SMS Settings
  CREATE_MSGCLUB_SMS_SETTING_REQUEST: 'CREATE_MSGCLUB_SMS_SETTING_REQUEST',
  CREATE_MSGCLUB_SMS_SETTING_SUCCESS: 'CREATE_MSGCLUB_SMS_SETTING_SUCCESS',
  CREATE_MSGCLUB_SMS_SETTING_FAIL: 'CREATE_MSGCLUB_SMS_SETTING_FAIL',
  
  GET_MSGCLUB_SMS_SETTINGS_REQUEST: 'GET_MSGCLUB_SMS_SETTINGS_REQUEST',
  GET_MSGCLUB_SMS_SETTINGS_SUCCESS: 'GET_MSGCLUB_SMS_SETTINGS_SUCCESS',
  GET_MSGCLUB_SMS_SETTINGS_FAIL: 'GET_MSGCLUB_SMS_SETTINGS_FAIL',
  
  UPDATE_MSGCLUB_SMS_SETTING_REQUEST: 'UPDATE_MSGCLUB_SMS_SETTING_REQUEST',
  UPDATE_MSGCLUB_SMS_SETTING_SUCCESS: 'UPDATE_MSGCLUB_SMS_SETTING_SUCCESS',
  UPDATE_MSGCLUB_SMS_SETTING_FAIL: 'UPDATE_MSGCLUB_SMS_SETTING_FAIL',
  
  DELETE_MSGCLUB_SMS_SETTING_REQUEST: 'DELETE_MSGCLUB_SMS_SETTING_REQUEST',
  DELETE_MSGCLUB_SMS_SETTING_SUCCESS: 'DELETE_MSGCLUB_SMS_SETTING_SUCCESS',
  DELETE_MSGCLUB_SMS_SETTING_FAIL: 'DELETE_MSGCLUB_SMS_SETTING_FAIL',

  // Email Notifications
  CREATE_EMAIL_NOTIFICATION_REQUEST: 'CREATE_EMAIL_NOTIFICATION_REQUEST',
  CREATE_EMAIL_NOTIFICATION_SUCCESS: 'CREATE_EMAIL_NOTIFICATION_SUCCESS',
  CREATE_EMAIL_NOTIFICATION_FAIL: 'CREATE_EMAIL_NOTIFICATION_FAIL',
  
  GET_EMAIL_NOTIFICATIONS_REQUEST: 'GET_EMAIL_NOTIFICATIONS_REQUEST',
  GET_EMAIL_NOTIFICATIONS_SUCCESS: 'GET_EMAIL_NOTIFICATIONS_SUCCESS',
  GET_EMAIL_NOTIFICATIONS_FAIL: 'GET_EMAIL_NOTIFICATIONS_FAIL',
  
  UPDATE_EMAIL_NOTIFICATION_REQUEST: 'UPDATE_EMAIL_NOTIFICATION_REQUEST',
  UPDATE_EMAIL_NOTIFICATION_SUCCESS: 'UPDATE_EMAIL_NOTIFICATION_SUCCESS',
  UPDATE_EMAIL_NOTIFICATION_FAIL: 'UPDATE_EMAIL_NOTIFICATION_FAIL',
  
  DELETE_EMAIL_NOTIFICATION_REQUEST: 'DELETE_EMAIL_NOTIFICATION_REQUEST',
  DELETE_EMAIL_NOTIFICATION_SUCCESS: 'DELETE_EMAIL_NOTIFICATION_SUCCESS',
  DELETE_EMAIL_NOTIFICATION_FAIL: 'DELETE_EMAIL_NOTIFICATION_FAIL',

  // SMS Notifications
  CREATE_SMS_NOTIFICATION_REQUEST: 'CREATE_SMS_NOTIFICATION_REQUEST',
  CREATE_SMS_NOTIFICATION_SUCCESS: 'CREATE_SMS_NOTIFICATION_SUCCESS',
  CREATE_SMS_NOTIFICATION_FAIL: 'CREATE_SMS_NOTIFICATION_FAIL',
  
  GET_SMS_NOTIFICATIONS_REQUEST: 'GET_SMS_NOTIFICATIONS_REQUEST',
  GET_SMS_NOTIFICATIONS_SUCCESS: 'GET_SMS_NOTIFICATIONS_SUCCESS',
  GET_SMS_NOTIFICATIONS_FAIL: 'GET_SMS_NOTIFICATIONS_FAIL',
  
  UPDATE_SMS_NOTIFICATION_REQUEST: 'UPDATE_SMS_NOTIFICATION_REQUEST',
  UPDATE_SMS_NOTIFICATION_SUCCESS: 'UPDATE_SMS_NOTIFICATION_SUCCESS',
  UPDATE_SMS_NOTIFICATION_FAIL: 'UPDATE_SMS_NOTIFICATION_FAIL',
  
  DELETE_SMS_NOTIFICATION_REQUEST: 'DELETE_SMS_NOTIFICATION_REQUEST',
  DELETE_SMS_NOTIFICATION_SUCCESS: 'DELETE_SMS_NOTIFICATION_SUCCESS',
  DELETE_SMS_NOTIFICATION_FAIL: 'DELETE_SMS_NOTIFICATION_FAIL',

  // Reset State
  RESET_NOTIFICATION_STATE: 'RESET_NOTIFICATION_STATE',
  CREATE_NOTIFICATION_SETTING_REQUEST: 'CREATE_NOTIFICATION_SETTING_REQUEST',
  CREATE_NOTIFICATION_SETTING_SUCCESS: 'CREATE_NOTIFICATION_SETTING_SUCCESS',
  CREATE_NOTIFICATION_SETTING_FAIL: 'CREATE_NOTIFICATION_SETTING_FAIL',
  
  GET_NOTIFICATION_SETTINGS_REQUEST: 'GET_NOTIFICATION_SETTINGS_REQUEST',
  GET_NOTIFICATION_SETTINGS_SUCCESS: 'GET_NOTIFICATION_SETTINGS_SUCCESS',
  GET_NOTIFICATION_SETTINGS_FAIL: 'GET_NOTIFICATION_SETTINGS_FAIL',
  
  UPDATE_NOTIFICATION_SETTING_REQUEST: 'UPDATE_NOTIFICATION_SETTING_REQUEST',
  UPDATE_NOTIFICATION_SETTING_SUCCESS: 'UPDATE_NOTIFICATION_SETTING_SUCCESS',
  UPDATE_NOTIFICATION_SETTING_FAIL: 'UPDATE_NOTIFICATION_SETTING_FAIL',
  
  DELETE_NOTIFICATION_SETTING_REQUEST: 'DELETE_NOTIFICATION_SETTING_REQUEST',
  DELETE_NOTIFICATION_SETTING_SUCCESS: 'DELETE_NOTIFICATION_SETTING_SUCCESS',
  DELETE_NOTIFICATION_SETTING_FAIL: 'DELETE_NOTIFICATION_SETTING_FAIL',
  
  RESET_NOTIFICATION_STATE: 'RESET_NOTIFICATION_STATE'
};



// Action Types
export const PAYMENT_ACTION_TYPES = {
  // Razorpay Payment Settings
  CREATE_RAZORPAY_SETTING_REQUEST: 'CREATE_RAZORPAY_SETTING_REQUEST',
  CREATE_RAZORPAY_SETTING_SUCCESS: 'CREATE_RAZORPAY_SETTING_SUCCESS',
  CREATE_RAZORPAY_SETTING_FAIL: 'CREATE_RAZORPAY_SETTING_FAIL',
  
  GET_RAZORPAY_SETTINGS_REQUEST: 'GET_RAZORPAY_SETTINGS_REQUEST',
  GET_RAZORPAY_SETTINGS_SUCCESS: 'GET_RAZORPAY_SETTINGS_SUCCESS',
  GET_RAZORPAY_SETTINGS_FAIL: 'GET_RAZORPAY_SETTINGS_FAIL',
  
  UPDATE_RAZORPAY_SETTING_REQUEST: 'UPDATE_RAZORPAY_SETTING_REQUEST',
  UPDATE_RAZORPAY_SETTING_SUCCESS: 'UPDATE_RAZORPAY_SETTING_SUCCESS',
  UPDATE_RAZORPAY_SETTING_FAIL: 'UPDATE_RAZORPAY_SETTING_FAIL',

  // CCAvenue Settings
  CREATE_CCAVENUE_SETTING_REQUEST: 'CREATE_CCAVENUE_SETTING_REQUEST',
  CREATE_CCAVENUE_SETTING_SUCCESS: 'CREATE_CCAVENUE_SETTING_SUCCESS',
  CREATE_CCAVENUE_SETTING_FAIL: 'CREATE_CCAVENUE_SETTING_FAIL',
  
  GET_CCAVENUE_SETTINGS_REQUEST: 'GET_CCAVENUE_SETTINGS_REQUEST',
  GET_CCAVENUE_SETTINGS_SUCCESS: 'GET_CCAVENUE_SETTINGS_SUCCESS',
  GET_CCAVENUE_SETTINGS_FAIL: 'GET_CCAVENUE_SETTINGS_FAIL',
  
  UPDATE_CCAVENUE_SETTING_REQUEST: 'UPDATE_CCAVENUE_SETTING_REQUEST',
  UPDATE_CCAVENUE_SETTING_SUCCESS: 'UPDATE_CCAVENUE_SETTING_SUCCESS',
  UPDATE_CCAVENUE_SETTING_FAIL: 'UPDATE_CCAVENUE_SETTING_FAIL',

  // Cashfree Payment Settings
  CREATE_CASHFREE_SETTING_REQUEST: 'CREATE_CASHFREE_SETTING_REQUEST',
  CREATE_CASHFREE_SETTING_SUCCESS: 'CREATE_CASHFREE_SETTING_SUCCESS',
  CREATE_CASHFREE_SETTING_FAIL: 'CREATE_CASHFREE_SETTING_FAIL',
  
  GET_CASHFREE_SETTINGS_REQUEST: 'GET_CASHFREE_SETTINGS_REQUEST',
  GET_CASHFREE_SETTINGS_SUCCESS: 'GET_CASHFREE_SETTINGS_SUCCESS',
  GET_CASHFREE_SETTINGS_FAIL: 'GET_CASHFREE_SETTINGS_FAIL',
  
  UPDATE_CASHFREE_SETTING_REQUEST: 'UPDATE_CASHFREE_SETTING_REQUEST',
  UPDATE_CASHFREE_SETTING_SUCCESS: 'UPDATE_CASHFREE_SETTING_SUCCESS',
  UPDATE_CASHFREE_SETTING_FAIL: 'UPDATE_CASHFREE_SETTING_FAIL',

  // Cashfree Payout Settings
  CREATE_CASHFREE_PAYOUT_SETTING_REQUEST: 'CREATE_CASHFREE_PAYOUT_SETTING_REQUEST',
  CREATE_CASHFREE_PAYOUT_SETTING_SUCCESS: 'CREATE_CASHFREE_PAYOUT_SETTING_SUCCESS',
  CREATE_CASHFREE_PAYOUT_SETTING_FAIL: 'CREATE_CASHFREE_PAYOUT_SETTING_FAIL',
  
  GET_CASHFREE_PAYOUT_SETTINGS_REQUEST: 'GET_CASHFREE_PAYOUT_SETTINGS_REQUEST',
  GET_CASHFREE_PAYOUT_SETTINGS_SUCCESS: 'GET_CASHFREE_PAYOUT_SETTINGS_SUCCESS',
  GET_CASHFREE_PAYOUT_SETTINGS_FAIL: 'GET_CASHFREE_PAYOUT_SETTINGS_FAIL',
  
  UPDATE_CASHFREE_PAYOUT_SETTING_REQUEST: 'UPDATE_CASHFREE_PAYOUT_SETTING_REQUEST',
  UPDATE_CASHFREE_PAYOUT_SETTING_SUCCESS: 'UPDATE_CASHFREE_PAYOUT_SETTING_SUCCESS',
  UPDATE_CASHFREE_PAYOUT_SETTING_FAIL: 'UPDATE_CASHFREE_PAYOUT_SETTING_FAIL',

  // Razorpay Payout Settings
  CREATE_RAZORPAY_PAYOUT_SETTING_REQUEST: 'CREATE_RAZORPAY_PAYOUT_SETTING_REQUEST',
  CREATE_RAZORPAY_PAYOUT_SETTING_SUCCESS: 'CREATE_RAZORPAY_PAYOUT_SETTING_SUCCESS',
  CREATE_RAZORPAY_PAYOUT_SETTING_FAIL: 'CREATE_RAZORPAY_PAYOUT_SETTING_FAIL',
  
  GET_RAZORPAY_PAYOUT_SETTINGS_REQUEST: 'GET_RAZORPAY_PAYOUT_SETTINGS_REQUEST',
  GET_RAZORPAY_PAYOUT_SETTINGS_SUCCESS: 'GET_RAZORPAY_PAYOUT_SETTINGS_SUCCESS',
  GET_RAZORPAY_PAYOUT_SETTINGS_FAIL: 'GET_RAZORPAY_PAYOUT_SETTINGS_FAIL',
  
  UPDATE_RAZORPAY_PAYOUT_SETTING_REQUEST: 'UPDATE_RAZORPAY_PAYOUT_SETTING_REQUEST',
  UPDATE_RAZORPAY_PAYOUT_SETTING_SUCCESS: 'UPDATE_RAZORPAY_PAYOUT_SETTING_SUCCESS',
  UPDATE_RAZORPAY_PAYOUT_SETTING_FAIL: 'UPDATE_RAZORPAY_PAYOUT_SETTING_FAIL',

  // Reset State
  RESET_PAYMENT_STATE: 'RESET_PAYMENT_STATE'
};

// Payment Gateway Types
export const PAYMENT_GATEWAYS = {
  RAZORPAY: 'razorpay',
  CCAVENUE: 'ccavenue',
  CASHFREE: 'cashfree',
  CASHFREE_PAYOUT: 'cashfree_payout',
  RAZORPAY_PAYOUT: 'razorpay_payout'
};

export const PAYMENT_STATUS = {
  DISABLED: '0',
  ENABLED: '1'
};


export const VIDEO_ACTION_TYPES = {  
  // Video Settings
  CREATE_VIDEO_SETTING_REQUEST: 'CREATE_VIDEO_SETTING_REQUEST',
  CREATE_VIDEO_SETTING_SUCCESS: 'CREATE_VIDEO_SETTING_SUCCESS',
  CREATE_VIDEO_SETTING_FAIL: 'CREATE_VIDEO_SETTING_FAIL',
  
  GET_VIDEO_SETTINGS_REQUEST: 'GET_VIDEO_SETTINGS_REQUEST',
  GET_VIDEO_SETTINGS_SUCCESS: 'GET_VIDEO_SETTING_SUCCESS',
  GET_VIDEO_SETTINGS_FAIL: 'GET_VIDEO_SETTING_FAIL',
  
  UPDATE_VIDEO_SETTING_REQUEST: 'UPDATE_VIDEO_SETTING_REQUEST',
  UPDATE_VIDEO_SETTING_SUCCESS: 'UPDATE_VIDEO_SETTING_SUCCESS',
  UPDATE_VIDEO_SETTING_FAIL: 'UPDATE_VIDEO_SETTING_FAIL',
  
  // ...
};


export const GETHOSPITALBYID = "GETHOSPITALBYID";
export const CREATENOTIFICATION = "CREATENOTIFICATION";
export const GETNOTIFICATION = "GETNOTIFICATION";
export const UPDATENOTIFICATION = "UPDATENOTIFICATION";
export const DELETENOTIFICATION = "DELETENOTIFICATION";
export const CREATESMS1 = "CREATESMS1";
export const GETSMS1 = "GETSMS1";
export const UPDATESMS1 = "UPDATESMS1";
export const GETSMS2 = "GETSMS2";
export const UPDATESMS2 = "UPDATESMS2";
export const GETSMS3 = "GETSMS3";
export const UPDATESMS3 = "UPDATESMS3";
export const GETSMS4 = "GETSMS4";
export const UPDATESMS4 = "UPDATESMS4";
export const GETSMS5 = "GETSMS5";
export const UPDATESMS5 = "UPDATESMS5";
export const GETSMS6 = "GETSMS6";
export const UPDATESMS6 = "UPDATESMS6";
export const GETSMS7 = "GETSMS7";
export const UPDATESMS7 = "UPDATESMS7";
export const DELETESMS1 = "DELETESMS1";
export const DELETESMS2 = "DELETESMS2";
export const DELETESMS3 = "DELETESMS3";
export const DELETESMS4 = "DELETESMS4";
export const DELETESMS5 = "DELETESMS5";
export const DELETESMS6 = "DELETESMS6";
export const DELETESMS7 = "DELETESMS7";
export const CREATESMS2 = "CREATESMS2";
export const CREATESMS3 = "CREATESMS3";
export const CREATESMS4 = "CREATESMS4";
export const CREATESMS5 = "CREATESMS5";
export const CREATESMS6 = "CREATESMS6";
export const CREATESMS7 = "CREATESMS7";
export const CREATEEMAIL = "CREATEEMAIL";
export const GETEMAIL = "GETEMAIL";
export const DELETEEMAIL = "DELETEEMAIL";
export const UPDATEEMAIL = "UPDATEEMAIL";
export const UPDATEPAYMENT1 = "UPDATEPAYMENT1";
export const GETPAYMENT1 = "GETPAYMENT1";
export const UPDATEPAYMENT2 = "UPDATEPAYMENT2";
export const GETPAYMENT2 = "GETPAYMENT2";
export const UPDATEPAYMENT3 = "UPDATEPAYMENT3";
export const GETPAYMENT3 = "GETPAYMENT3";
export const UPDATEPAYMENT4 = "UPDATEPAYMENT4";
export const GETPAYMENT4 = "GETPAYMENT4";
export const UPDATEPAYMENT5 = "UPDATEPAYMENT5";
export const GETPAYMENT5 = "GETPAYMENT5";
export const UPDATEPAYMENT6 = "UPDATEPAYMENT6";
export const GETPAYMENT6 = "GETPAYMENT6";
export const UPDATEPAYMENT7 = "UPDATEPAYMENT7";
export const GETPAYMENT7 = "GETPAYMENT7";
export const UPDATEPAYMENT8 = "UPDATEPAYMENT8";
export const GETPAYMENT8 = "GETPAYMENT8";
export const UPDATEPAYMENT9 = "UPDATEPAYMENT9";
export const GETPAYMENT9 = "GETPAYMENT9";
export const UPDATEPAYMENT10 = "UPDATEPAYMENT10";
export const GETPAYMENT10 = "GETPAYMENT10";
export const UPDATEPAYMENT11 = "UPDATEPAYMENT11";
export const GETPAYMENT11 = "GETPAYMENT11";
export const UPDATEPAYMENT12 = "UPDATEPAYMENT12";
export const GETPAYMENT12 = "GETPAYMENT12";
export const UPDATEPAYMENT13 = "UPDATEPAYMENT13";
export const GETPAYMENT13 = "GETPAYMENT13";
export const UPDATEPAYMENT14 = "UPDATEPAYMENT14";
export const GETPAYMENT14 = "GETPAYMENT14";
export const UPDATEPAYMENT15 = "UPDATEPAYMENT15";
export const GETPAYMENT15 = "GETPAYMENT15";
export const UPDATEPAYMENT16 = "UPDATEPAYMENT16";
export const GETPAYMENT16 = "GETPAYMENT16";
export const DELETEPAYMENT1 = "DELETEPAYMENT1";
export const DELETEPAYMENT2 = "DELETEPAYMENT2";
export const DELETEPAYMENT3 = "DELETEPAYMENT3";
export const DELETEPAYMENT4 = "DELETEPAYMENT4";
export const DELETEPAYMENT5 = "DELETEPAYMENT5";
export const DELETEPAYMENT6 = "DELETEPAYMENT6";
export const DELETEPAYMENT7 = "DELETEPAYMENT7";
export const DELETEPAYMENT8 = "DELETEPAYMENT8";
export const DELETEPAYMENT9 = "DELETEPAYMENT9";
export const DELETEPAYMENT10 = "DELETEPAYMENT10";
export const DELETEPAYMENT11 = "DELETEPAYMENT11";
export const DELETEPAYMENT12 = "DELETEPAYMENT12";
export const DELETEPAYMENT13 = "DELETEPAYMENT13";
export const DELETEPAYMENT14 = "DELETEPAYMENT14";
export const DELETEPAYMENT15 = "DELETEPAYMENT15";
export const DELETEPAYMENT16 = "DELETEPAYMENT16";
export const CREATEPAYMENT1 = "CREATEPAYMENT1";
export const CREATEPAYMENT2 = "CREATEPAYMENT2";
export const CREATEPAYMENT3 = "CREATEPAYMENT3";
export const CREATEPAYMENT4 = "CREATEPAYMENT4";
export const CREATEPAYMENT5 = "CREATEPAYMENT5";
export const CREATEPAYMENT6 = "CREATEPAYMENT6";
export const CREATEPAYMENT7 = "CREATEPAYMENT7";
export const CREATEPAYMENT8 = "CREATEPAYMENT8";
export const CREATEPAYMENT9 = "CREATEPAYMENT9";
export const CREATEPAYMENT10 = "CREATEPAYMENT10";
export const CREATEPAYMENT11 = "CREATEPAYMENT11";
export const CREATEPAYMENT12 = "CREATEPAYMENT12";
export const CREATEPAYMENT13 = "CREATEPAYMENT13";
export const CREATEPAYMENT14 = "CREATEPAYMENT14";
export const CREATEPAYMENT15 = "CREATEPAYMENT15";
export const CREATEPAYMENT16 = "CREATEPAYMENT16";
export const CREATEPREFIX = "CREATEPREFIX";
export const GETPREFIX = "GETPREFIX";
export const DELETEPREFIX = "DELETEPREFIX";
export const UPDATEPREFIX = "UPDATEPREFIX";
export const CREATEROLE = "CREATEROLE";
export const GETROLE = "GETROLE";
export const DELETEROLE = "DELETEROLE";
export const UPDATEROLE = "UPDATEROLE";
export const CREATEBACKUP = "CREATEBACKUP";
export const GETBACKUP = "GETBACKUP";
export const DELETEBACKUP = "DELETEBACKUP";
export const UPDATEBACKUP = "UPDATEBACKUP";
export const CREATELANGUAGE = "CREATELANGUAGE";
export const GETLANGUAGE = "GETLANGUAGE";
export const DELETELANGUAGE = "DELETELANGUAGE";
export const UPDATELANGUAGE = "UPDATELANGUAGE";
export const CREATEPATIENT = "CREATEPATIENT";
export const GETPATIENT = "GETPATIENT";
export const DELETEPATIENT = "DELETEPATIENT";
export const UPDATEPATIENT = "UPDATEPATIENT";
export const CREATESTAFF = "CREATESTAFF";
export const GETSTAFF = "GETSTAFF";
export const DELETESTAFF = "DELETESTAFF";
export const UPDATESTAFF = "UPDATESTAFF";
export const CREATECAPTCHA = "CREATECAPTCHA";
export const GETCAPTCHA = "GETCAPTCHA";
export const DELETECAPTCHA = "DELETECAPTCHA";
export const UPDATECAPTCHA = "UPDATECAPTCHA";
export const CREATEMODULE = "CREATEMODULE";
export const GETMODULE = "GETMODULE";
export const GETMODULEADMIN = "GETMODULEADMIN";
export const DELETEMODULE = "DELETEMODULE";
export const UPDATEMODULE = "UPDATEMODULE";
export const CREATECHILDRENMODULE = "CREATECHILDRENMODULE";
export const GETCHILDRENMODULE = "GETCHILDRENMODULE";
export const GETCHILDRENMODULEADMIN = "GETCHILDRENMODULEADMIN";
export const DELETECHILDRENMODULE = "DELETECHILDRENMODULE";
export const UPDATECHILDRENMODULE = "UPDATECHILDRENMODULE";
export const GETALLCHILDRENMODULE = "GETALLCHILDRENMODULE";

export const CREATEUNIT = "CREATEUNIT";
export const GETUNIT = "GETUNIT";
export const DELETEUNIT = "DELETEUNIT";
export const UPDATEUNIT = "UPDATEUNIT";
export const CREATETAX = "CREATETAX";
export const GETTAX = "GETTAX";
export const DELETETAX = "DELETETAX";
export const UPDATETAX = "UPDATETAX";
export const CREATECHARGESTYPE = "CREATECHARGESTYPE";
export const GETCHARGESTYPE = "GETCHARGESTYPE";
export const DELETECHARGESTYPE = "DELETECHARGESTYPE";
export const UPDATECHARGESTYPE = "UPDATETECHARGEDTYPE";
export const CREATECHARGESCHATEGORY = "CREATECHARGESCHATEGORY";
export const GETCHARGESCHATEGORY = "GETCHARGESCHATEGORY";
export const DELETECHARGESCHATEGORY = "DELETECHARGESCHATEGORY";
export const UPDATECHARGESCHATEGORY = "UPDATETECHARGESCHATEGORY";
export const CREATECHARGE = "CREATECHARGE";
export const GETCHARGE = "GETCHARGE";
export const DELETECHARGE = "DELETECHARGE";
export const UPDATECHARGE = "UPDATETECHARGE";
export const CREATELEAVETYPE = "CREATELEAVETYPE";
export const GETLEAVETYPE = "GETLEAVETYPE";
export const DELETELEAVETYPE = "DELETELEAVETYPE";
export const UPDATELEAVETYPE = "UPDATELEAVETYPE";
export const CREATEDEPARTMENT = "CREATEDEPARTMENT";
export const GETDEPARTMENT = "GETDEPARTMENT";
export const DELETEDEPARTMENT = "DELETEDEPARTMENT";
export const UPDATEDEPARTMENT = "UPDATEDEPARTMENT";
export const CREATEDESIGNATION = "CREATEDESIGNATION";
export const GETDESIGNATION = "GETDESIGNATION";
export const DELETEDESIGNATION = "DELETEDESIGNATION";
export const UPDATEDESIGNATION = "UPDATEDESIGNATION";
export const CREATESPECIALITY = "CREATESPECIALITY";
export const GETSPECIALITY = "GETSPECIALITY";
export const GETAllSPECIALITY = "GETALLSPECIALITY";
export const DELETESPECIALITY = "DELETESPECIALITY";
export const UPDATESPECIALITY = "UPDATESPECIALITY";
export const CREATEPAYROLLTYPE = "CREATEPAYROLLTYPE";
export const GETPAYROLLTYPE = "GETPAYROLLTYPE";
export const DELETEPAYROLLTYPE = "DELETEPAYROLLTYPE";
export const UPDATEPAYROLLTYPE = "UPDATEPAYROLLTYPE";
export const CREATEPAYROLL = "CREATEPAYROLL";
export const GETPAYROLL = "GETPAYROLL";
export const DELETEPAYROLL = "DELETEPAYROLL";
export const UPDATEPAYROLL = "UPDATEPAYROLL";
export const CREATEFLOOR = "CREATEFLOOR";
export const GETFLOOR = "GETFLOOR";
export const DELETEFLOOR = "DELETEFLOOR";
export const UPDATEFLOOR = "UPDATEFLOOR";
export const CREATEBEDGROUP = "CREATEBEDGROUP";
export const GETBEDGROUP = "GETBEDGROUP";
export const DELETEBEDGROUP = "DELETEBEDGROUP";
export const UPDATEBEDGROUP = "UPDATEBEDGROUP";
export const CREATEBEDTYPE = "CREATEBEDTYPE";
export const GETBEDTYPE = "GETBEDTYPE";
export const DELETEBEDTYPE = "DELETEBEDTYPE";
export const UPDATEBEDTYPE = "UPDATEBEDTYPE";
export const CREATEBED = "CREATEBED";
export const GETBED = "GETBED";
export const DELETEBED = "DELETEBED";
export const UPDATEBED = "UPDATEBED";
export const CREATEPUPOSE = "CREATEPURPOSE";
export const GETPURPOSE = "GETPURPOSE";
export const DELETEPURPOSE = "DELETEPURPOSE";
export const UPDATEPURPOSE = "UPDATEPURPOSE";
export const CREATECOMPLAINT = "CREATECOMPLAINT";
export const GETCOMPLAINT = "GETCOMPLAINT";
export const DELETECOMPLAINT = "DELETECOMPLAINT";
export const UPDATECOMPLAINT = "UPDATECOMPLAINT";
export const CREATESOURCE = "CREATESOURCE";
export const GETSOURCE = "GETSOURCE";
export const DELETESOURCE = "DELETESOURCE";
export const UPDATESOURCE = "UPDATESOURCE";
export const CREATEAPPOINTMENTPRIORITY = "CREATEAPPOINTMENTPRIORITY";
export const GETAPPOINTMENTPRIORITY = "GETAPPOINTMENTPRIORITY";
export const DELETEAPPOINTMENTPRIORITY = "DELETEAPPOINTMENTPRIORITY";
export const UPDATEAPPOINTMENTPRIORITY = "UPDATEAPPOINTMENTPRIORITY";
export const CREATEOPERATION = "CREATEOPERATION";
export const GETOPERATION = "GETOPERATION";
export const DELETEOPERATION = "DELETEOPERATION";
export const UPDATEOPERATION = "UPDATEOPERATION";
export const CREATEOPERATIONCATEGORY = "CREATEOPERATIONCATEGORY";
export const GETOPERATIONCATEGORY = "GETOPERATIONCATEGORY";
export const DELETEOPERATIONCATEGORY = "DELETEOPERATIONCATEGORY";
export const UPDATEOPERATIONCATEGORY = "UPDATEOPERATIONCATEGORY";
export const CREATEFINDINGCATEGORY = "CREATEFINDINGCATEGORY";
export const GETFINDINGCATEGORY = "GETFINDINGCATEGORY";
export const DELETEFINDINGCATEGORY = "DELETEFINDINGCATEGORY";
export const UPDATEFINDINGCATEGORY = "UPDATEFINDINGCATEGORY";
export const CREATEFINDING = "CREATEFINDING";
export const GETFINDING = "GETFINDING";
export const DELETEFINDING = "DELETEFINDING";
export const UPDATEFINDING = "UPDATEFINDING";
export const CREATESYMPTOMSTYPE = "CREATESYMPTOMSTYPE";
export const GETSYMPTOMSTYPE = "GETSYMPTOMSTYPE";
export const DELETESYMPTOMSTYPE = "DELETESYMPTOMSTYPE";
export const UPDATESYMPTOMSTYPE = "UPDATESYMPTOMSTYPE";
export const CREATESYMPTOMSHEAD = "CREATESYMPTOMSHEAD";
export const GETSYMPTOMSHEAD = "GETSYMPTOMSHEAD";
export const DELETESYMPTOMSHEAD = "DELETESYMPTOMSHEAD";
export const UPDATESYMPTOMSHEAD = "UPDATESYMPTOMSHEAD";
export const CREATECOMORBIDITYTYPE = "CREATECOMORBIDITYTYPE";
export const GETCOMORBIDITYTYPE = "GETCOMORBIDITYTYPE";
export const DELETECOMORBIDITYTYPE = "DELETECOMORBIDITYTYPE";
export const UPDATECOMORBIDITYTYPE = "UPDATECOMORBIDITYTYPE";
export const CREATECOMORBIDITYHEAD = "CREATECOMORBIDITYHEAD";
export const GETCOMORBIDITYHEAD = "GETCOMORBIDITYHEAD";
export const DELETECOMORBIDITYHEAD = "DELETECOMORBIDITYHEAD";
export const UPDATECOMORBIDITYHEAD = "UPDATECOMORBIDITYHEAD";
export const CREATEINCOMEHEAD = "CREATEINCOMEHEAD";
export const GETINCOMEHEAD = "GETINCOMEHEAD";
export const DELETEINCOMEHEAD = "DELETEINCOMEHEAD";
export const UPDATEINCOMEHEAD = "UPDATEINCOMEHEAD";
export const CREATEEXPENSEHEAD = "CREATEEXPENSEHEAD";
export const GETEXPENSEHEAD = "GETEXPENSEHEAD";
export const DELETEEXPENSEHEAD = "DELETEEXPENSEHEAD";
export const UPDATEEXPENSEHEAD = "UPDATEEXPENSEHEAD";
export const CREATEZOOMSETTING = "CREATEZOOMSETTING";
export const GETZOOMSETTING = "GETZOOMSETTING";
export const DELETEZOOMSETTING = "DELETEZOOMSETTING";
export const UPDATEZOOMSETTING = "UPDATEZOOMSETTING";
export const CREATEMEDICINCECATEGORY = "CREATEMEDICINCECATEGORY";
export const GETMEDICINCECATEGORY = "GETMEDICINCECATEGORY";
export const DELETEMEDICINCECATEGORY = "DELETEMEDICINCECATEGORY";
export const UPDATEMEDICINECATEGORY = "UPDATEMEDICINECATEGORY";
export const CREATESUPPLIER = "CREATESUPPLIER";
export const GETSUPPLIER = "GETSUPPLIER";
export const DELETESUPPLIER = "DELETESUPPLIER";
export const UPDATESUPPLIER = "UPDATESUPPLIER";
export const CREATEDOSEUNIT = "CREATEDOSEUNIT";
export const GETDOSEUNIT = "GETDOSEUNIT";
export const DELETEDOSEUNIT = "DELETEDOSEUNIT";
export const UPDATEDOSEUNIT = "UPDATEDOSEUNIT";
export const CREATEMEDICINCEDOSAGE = "CREATEMEDICINCEDOSAGE";
export const GETMEDICINCEDOSAGE = "GETMEDICINCEDOSAGE";
export const DELETEMEDICINCEDOSAGE = "DELETEMEDICINCEDOSAGE";
export const UPDATEMEDICINCEDOSAGE = "UPDATEMEDICINCEDOSAGE";
export const CREATEDOSEINTERVAL = "CREATEDOSEINTERVAL";
export const GETDOSEINTERVAL = "GETDOSEINTERVAL";
export const DELETEDOSEINTERVAL = "DELETEDOSEINTERVAL";
export const UPDATEDOSEINTERVAL = "UPDATEDOSEINTERVAL";
export const CREATEDOSEDURATION = "CREATEDOSEDURATION";
export const GETDOSEDURATION = "GETDOSEDURATION";
export const DELETEDOSEDURATION = "DELETEDOSEDURATION";
export const UPDATEDOSEDURATION = "UPDATEDOSEDURATION";
export const UPDATEPATHOLOGYCATEGORY = "UPDATEPATHOLOGYCATEGORY";
export const CREATEPATHOLOGYCATEGORY = "CREATEPATHOLOGYCATEGORY";
export const GETPATHOLOGYCATEGORY = "GETPATHOLOGYCATEGORY";
export const DELETEPATHOLOGYCATEGORY = "DELETEPATHOLOGYCATEGORY";
export const UPDATEPATHOLOGYUNIT = "UPDATEPATHOLOGYUNIT";
export const CREATEPATHOLOGYUNIT = "CREATEPATHOLOGYUNIT";
export const GETPATHOLOGYUNIT = "GETPATHOLOGYUNIT";
export const DELETEPATHOLOGYUNIT = "DELETEPATHOLOGYUNIT";
export const UPDATEPATHOLOGYPARAMETER = "UPDATEPATHOLOGYPARAMETER";
export const CREATEPATHOLOGYPARAMETER = "CREATEPATHOLOGYPARAMETER";
export const GETPATHOLOGYPARAMETER = "GETPATHOLOGYPARAMETER";
export const DELETEPATHOLOGYPARAMETER = "DELETEPATHOLOGYPARAMETER";
export const UPDATEPATHOLOGIST = "UPDATEPATHOLOGIST";
export const CREATEPATHOLOGIST = "CREATEPATHOLOGIST";
export const GETPATHOLOGIST = "GETPATHOLOGIST";
export const DELETEPATHOLOGIST = "DELETEPATHOLOGIST";
export const UPDATERADIOLOGYCATEGORY = "UPDATERADIOLOGYCATEGORY";
export const CREATERADIOLOGYCATEGORY = "CREATERADIOLOGYCATEGORY";
export const GETRADIOLOGYCATEGORY = "GETRADIOLOGYCATEGORY";
export const DELETERADIOLOGYCATEGORY = "DELETERADIOLOGYCATEGORY";
export const UPDATERADIOLOGYUNIT = "UPDATERADIOLOGYUNIT";
export const CREATERADIOLOGYUNIT = "CREATERADIOLOGYUNIT";
export const GETRADIOLOGYUNIT = "GETRADIOLOGYUNIT";
export const DELETERADIOLOGYUNIT = "DELETERADIOLOGYUNIT";
export const UPDATERADIOLOGYPARAMETER = "UPDATERADIOLOGYPARAMETER";
export const CREATERADIOLOGYPARAMETER = "CREATERADIOLOGYPARAMETER";
export const GETRADIOLOGYPARAMETER = "GETRADIOLOGYPARAMETER";
export const DELETERADIOLOGYPARAMETER = "DELETERADIOLOGYPARAMETER";
export const UPDATERADIOLOGIST = "UPDATERADIOLOGIST";
export const CREATERADIOLOGIST = "CREATERADIOLOGIST";
export const GETRADIOLOGIST = "GETRADIOLOGIST";
export const DELETERADIOLOGIST = "DELETERADIOLOGIST";
export const UPDATERADIOLOGYCENTER = "UPDATERADIOLOGYCENTER";
export const CREATERADIOLOGYCENTER = "CREATERADIOLOGYCENTER";
export const GETRADIOLOGYCENTER = "GETRADIOLOGYCENTER";
export const DELETERADIOLOGYCENTER = "DELETERADIOLOGYCENTER";
export const UPDATEPATHOLOGYCENTER = "UPDATEPATHOLOGYCENTER";
export const CREATEPATHOLOGYCENTER = "CREATEPATHOLOGYCENTER";
export const GETPATHOLOGYCENTER = "GETPATHOLOGYCENTER";
export const DELETEPATHOLOGYCENTER = "DELETEPATHOLOGYCENTER";
export const UPDATEBLOODBANKPRODUCT = "UPDATEBLOODBANKPRODUCT";
export const CREATEBLOODBANKPRODUCT = "CREATEBLOODBANKPRODUCT";
export const GETBLOODBANKPRODUCT = "GETBLOODBANKPRODUCT";
export const DELETEBLOODBANKPRODUCT = "DELETEBLOODBANKPRODUCT";
export const UPDATEBLOODBANKTYPE = "UPDATEBLOODBANKTYPE";
export const CREATEBLOODBANKTYPE = "CREATEBLOODBANKTYPE";
export const GETBLOODBANKTYPE = "GETBLOODBANKTYPE";
export const DELETEBLOODBANKTYPE = "DELETEBLOODBANKTYPE";
export const UPDATEREFERRALCATEGORY = "UPDATEREFERRALCATEGORY";
export const CREATEREFERRALCATEGORY = "CREATEREFERRALCATEGORY";
export const GETREFERRALCATEGORY = "GETREFERRALCATEGORY";
export const DELETEREFERRALCATEGORY = "DELETEREFERRALCATEGORY";
export const UPDATEREFERRALCOMMITION = "UPDATEREFERRALCOMMITION";
export const CREATEREFERRALCOMMITION = "CREATEREFERRALCOMMITION";
export const GETREFERRALCOMMITION = "GETREFERRALCOMMITION";
export const DELETEREFERRALCOMMITION = "DELETEREFERRALCOMMITION";
export const UPDATEREFERRALMODULECOMMITION = "UPDATEREFERRALMODULECOMMITION";
export const CREATEREFERRALMODULECOMMITION = "CREATEREFERRALMODULECOMMITION";
export const GETREFERRALMODULECOMMITION = "GETREFERRALMODULECOMMITION";
export const DELETEREFERRALMODULECOMMITION = "DELETEREFERRALMODULECOMMITION";
export const UPDATEINVENTORYITEMCATEGORY = "UPDATEINVENTORYITEMCATEGORY";
export const CREATEINVENTORYITEMCATEGORY = "CREATEINVENTORYITEMCATEGORY";
export const GETINVENTORYITEMCATEGORY = "GETINVENTORYITEMCATEGORY";
export const DELETEINVENTORYITEMCATEGORY = "DELETEINVENTORYITEMCATEGORY";
export const UPDATEINVENTORYITEMSTORE = "UPDATEINVENTORYITEMSTORE";
export const CREATEINVENTORYITEMSTORE = "CREATEINVENTORYITEMSTORE";
export const GETINVENTORYITEMSTORE = "GETINVENTORYITEMSTORE";
export const DELETEINVENTORYITEMSTORE = "DELETEINVENTORYITEMSTORE";
export const UPDATEINVENTORYITEMSUPPLIER = "UPDATEINVENTORYITEMSUPPLIER";
export const CREATEINVENTORYITEMSUPPLIER = "CREATEINVENTORYITEMSUPPLIER";
export const GETINVENTORYITEMSUPPLIER = "GETINVENTORYITEMSUPPLIER";
export const DELETEINVENTORYITEMSUPPLIER = "DELETEINVENTORYITEMSUPPLIER";
export const UPDATEHRSTAFFBASICINFORMATION = "UPDATEHRSTAFFBASICINFORMATION";
export const UPDATEHRSTAFFBASICINFORMATION1 = "UPDATEHRSTAFFBASICINFORMATION1";
export const CREATEHRSTAFFBASICINFORMATION = "CREATEHRSTAFFBASICINFORMATION";
export const GETHRSTAFFBASICINFORMATION = "GETHRSTAFFBASICINFORMATION";
export const GETHRSTAFFBASICINFORMATIONBYID = "GETHRSTAFFBASICINFORMATIONBYID";
export const GETHRSTAFFBASICINFORMATIONBYROLL =
  "GETHRSTAFFBASICINFORMATIONBYROLL";

export const GETHRSTAFFPAYROLLINFORMATIONBYID =
  "GETHRSTAFFPAYROLLINFORMATIONBYID";
export const GETHRSTAFFLEAVEINFORMATIONBYID = "GETHRSTAFFLEAVEINFORMATIONBYID";
export const GETHRSTAFFBANKINFORMATIONBYID = "GETHRSTAFFBANKINFORMATIONBYID";
export const GETHRSTAFFMEDIAINFORMATIONBYID = "GETHRSTAFFMEDIAINFORMATIONBYID";
export const GETHRSTAFFDOCUMENTINFORMATIONBYID =
  "GETHRSTAFFDOCUMENTINFORMATIONBYID";

export const DELETEHRSTAFFBASICINFORMATION = "DELETEHRSTAFFBASICINFORMATION";
export const UPDATEHRSTAFFPAYROLLINFORMATION =
  "UPDATEHRSTAFFPAYROLLINFORMATION";
export const CREATEHRSTAFFPAYROLLINFORMATION =
  "CREATEHRSTAFFPAYROLLINFORMATION";
export const GETHRSTAFFPAYROLLINFORMATION = "GETHRSTAFFPAYROLLINFORMATION";
export const DELETEHRSTAFFPAYROLLINFORMATION =
  "DELETEHRSTAFFPAYROLLINFORMATION";
export const UPDATEHRSTAFFLEAVEINFORMATION = "UPDATEHRSTAFFLEAVEINFORMATION";
export const CREATEHRSTAFFLEAVEINFORMATION = "CREATEHRSTAFFLEAVEINFORMATION";
export const GETHRSTAFFLEAVEINFORMATION = "GETHRSTAFFLEAVEINFORMATION";
export const DELETEHRSTAFFLEAVEINFORMATION = "DELETEHRSTAFFLEAVEINFORMATION";
export const UPDATEHRSTAFFBANKINFORMATION = "UPDATEHRSTAFFBANKINFORMATION";
export const CREATEHRSTAFFBANKINFORMATION = "CREATEHRSTAFFBANKINFORMATION";
export const GETHRSTAFFBANKINFORMATION = "GETHRSTAFFBANKINFORMATION";
export const DELETEHRSTAFFBANKINFORMATION = "DELETEHRSTAFFBANKINFORMATION";
export const UPDATEHRSTAFFMEDIAINFORMATION = "UPDATEHRSTAFFMEDIAINFORMATION";
export const CREATEHRSTAFFMEDIAINFORMATION = "CREATEHRSTAFFMEDIAINFORMATION";
export const GETHRSTAFFMEDIAINFORMATION = "GETHRSTAFFMEDIAINFORMATION";
export const DELETEHRSTAFFMEDIAINFORMATION = "DELETEHRSTAFFMEDIAINFORMATION";
export const UPDATEHRSTAFFDOCUMENTINFORMATION =
  "UPDATEHRSTAFFDOCUMENTINFORMATION";
export const CREATEHRSTAFFDOCUMENTINFORMATION =
  "CREATEHRSTAFFDOCUMENTINFORMATION";
export const GETHRSTAFFDOCUMENTINFORMATION = "GETHRSTAFFDOCUMENTINFORMATION";
export const DELETEHRSTAFFDOCUMENTINFORMATION =
  "DELETEHRSTAFFDOCUMENTINFORMATION";

export const CREATEHOSPITALEAPPOINMENTSHIFT = "CREATEHOSPITALEAPPOINMENTSHIFT";
export const GETHOSPITALEAPPOINMENTSHIFT = "GETHOSPITALEAPPOINMENTSHIFT";
export const DELETEHOSPITALEAPPOINMENTSHIFT = "DELETEHOSPITALEAPPOINMENTSHIFT";
export const UPDATEHOSPITALAPPOINMENTSHIFT = "UPDATEHOSPITALAPPOINMENTSHIFT";
export const CREATEHOSPITALEAPPOINMENTSLOT = "CREATEHOSPITALEAPPOINMENTSLOT";
export const GETHOSPITALEAPPOINMENTSLOT = "GETHOSPITALEAPPOINMENTSLOT";
export const GETHOSPITALEAPPOINMENTSLOTBYDOCTOR =
  "GETHOSPITALEAPPOINMENTSLOTBYDOCTOR";

export const DELETEHOSPITALEAPPOINMENTSLOT = "DELETEHOSPITALEAPPOINMENTSLOT";
export const UPDATEHOSPITALAPPOINMENTSLOT = "UPDATEHOSPITALAPPOINMENTSLOT";

export const SERCHCHARG = "SERCHCHARG";

export const CREATEOPDPRESCRIPTION = "CREATEOPDPRESCRIPTION";
export const GETOPDPRESCRIPTION = "GETOPDPRESCRIPTION";
export const DELETEOPDPRESCRIPTION = "DELETEOPDPRESCRIPTION";
export const UPDATEOPDPRESCRIPTION = "UPDATEOPDPRESCRIPTION";
export const CREATEOPDBILL = "CREATEOPDBILL";
export const GETOPDBILL = "GETOPDBILL";
export const DELETEOPDBILL = "DELETEOPDBILL";
export const UPDATEOPDBILL = "UPDATEOPDBILL";
export const CREATEOPDIMANGING = "CREATEOPDIMANGING";
export const GETOPDIMANGING = "GETOPDIMANGING";
export const DELETEOPDIMANGING = "DELETEOPDIMANGING";
export const UPDATEOPDIMANGING = "UPDATEOPDIMANGING";
export const CREATEIPDPRESCRIPTION = "CREATEIPDPRESCRIPTION";
export const GETIPDPRESCRIPTION = "GETIPDPRESCRIPTION";
export const DELETEIPDPRESCRIPTION = "DELETEIPDPRESCRIPTION";
export const UPDATEIPDPRESCRIPTION = "UPDATEIPDPRESCRIPTION";
export const CREATEIPDBILL = "CREATEIPDBILL";
export const GETIPDBILL = "GETIPDBILL";
export const DELETEIPDBILL = "DELETEIPDBILL";
export const UPDATEIPDBILL = "UPDATEIPDBILL";
export const CREATEBILL = "CREATEIPDBILL";
export const GETBILL = "GETBILL";
export const DELETEBILL = "DELETEBILL";
export const UPDATEBILL = "UPDATEBILL";
export const CREATEPHARMACYBILLL = "CREATEPHARMACYBILLL";
export const GETPHARMACYBILLL = "GETPHARMACYBILLL";
export const DELETEPHARMACYBILLL = "DELETEPHARMACYBILLL";
export const UPDATEPHARMACYBILLL = "UPDATEPHARMACYBILLL";
export const CREATEPAYSLIP = "CREATEIPDPAYSLIP";
export const GETPAYSLIP = "GETPAYSLIP";
export const DELETEPAYSLIP = "DELETEPAYSLIP";
export const UPDATEPAYSLIP = "UPDATEPAYSLIP";
export const CREATEPAYMENTRECEIPT = "CREATEIPDPAYMENTRECEIPT";
export const GETPAYMENTRECEIPT = "GETPAYMENTRECEIPT";
export const DELETEPAYMENTRECEIPT = "DELETEPAYMENTRECEIPT";
export const UPDATEPAYMENTRECEIPT = "UPDATEPAYMENTRECEIPT";
export const CREATEBIRTHRECORD = "CREATEIPDBIRTHRECORD";
export const GETBIRTHRECORD = "GETBIRTHRECORD";
export const DELETEBIRTHRECORD = "DELETEBIRTHRECORD";
export const UPDATEBIRTHRECORD = "UPDATEBIRTHRECORD";
export const CREATEDEATHRECORD = "CREATEIPDDEATHRECORD";
export const GETDEATHRECORD = "GETDEATHRECORD";
export const DELETEDEATHRECORD = "DELETEDEATHRECORD";
export const UPDATEDEATHRECORD = "UPDATEDEATHRECORD";
export const CREATEPATHOLOGY = "CREATEIPDPATHOLOGY";
export const GETPATHOLOGY = "GETPATHOLOGY";
export const DELETEPATHOLOGY = "DELETEPATHOLOGY";
export const UPDATEPATHOLOGY = "UPDATEPATHOLOGY";
export const CREATERADIOLOGY = "CREATEIPDRADIOLOGY";
export const GETRADIOLOGY = "GETRADIOLOGY";
export const DELETERADIOLOGY = "DELETERADIOLOGY";
export const UPDATERADIOLOGY = "UPDATERADIOLOGY";
export const CREATEPRINTOPERATION = "CREATEIPDPRINTOPERATION";
export const GETPRINTOPERATION = "GETPRINTOPERATION";
export const DELETEPRINTOPERATION = "DELETEPRINTOPERATION";
export const UPDATEPRINTOPERATION = "UPDATEPRINTOPERATION";
export const CREATEPRINTBLOODBANK = "CREATEIPDPRINTBLOODBANK";
export const GETPRINTBLOODBANK = "GETPRINTBLOODBANK";
export const DELETEPRINTBLOODBANK = "DELETEPRINTBLOODBANK";
export const UPDATEPRINTBLOODBANK = "UPDATEPRINTBLOODBANK";
export const CREATEPRINTAMBULANCE = "CREATEIPDPRINTAMBULANCE";
export const GETPRINTAMBULANCE = "GETPRINTAMBULANCE";
export const DELETEPRINTAMBULANCE = "DELETEPRINTAMBULANCE";
export const UPDATEPRINTAMBULANCE = "UPDATEPRINTAMBULANCE";
export const CREATEPRINTDISCHARGE = "CREATEIPDPRINTDISCHARGE";
export const GETPRINTDISCHARGE = "GETPRINTDISCHARGE";
export const DELETEPRINTDISCHARGE = "DELETEPRINTDISCHARGE";
export const UPDATEPRINTDISCHARGE = "UPDATEPRINTDISCHARGE";
export const CREATEAPPOINTMENTPATIENT = "CREATEIPDAPPOINTMENTPATIENT";
export const GETALLAPPOINTMENT = "GETALLAPPOINTMENT";

export const GETAPPOINTMENTPATIENT = "GETAPPOINTMENTPATIENT";
export const GETAPPOINTMENTPATIENTLIKE = "GETAPPOINTMENTPATIENTLIKE";

export const GETAPPOINTMENTPATIENTBYID = "GETAPPOINTMENTPATIENTBYID";
export const DELETEAPPOINTMENTPATIENT = "DELETEAPPOINTMENTPATIENT";
export const UPDATEAPPOINTMENTPATIENT = "UPDATEAPPOINTMENTPATIENT";
export const UPDATEAPPOINTMENTPATIENTACTION = "UPDATEAPPOINTMENTPATIENTACTION";

export const CREATEAPPOINTMENTVISITER = "CREATEIPDAPPOINTMENTVISITER";
export const GETAPPOINTMENTVISITER = "GETAPPOINTMENTVISITER";
export const DELETEAPPOINTMENTVISITER = "DELETEAPPOINTMENTVISITER";
export const UPDATEAPPOINTMENTVISITER = "UPDATEAPPOINTMENTVISITER";

export const CREATEOPDVISITS = "CREATEIPDOPDVISITS";
export const GETOPDVISITS = "GETOPDVISITS";
export const GETALLOPDVISITS = "GETALLOPDVISITS";
export const DELETEOPDVISITS = "DELETEOPDVISITS";
export const UPDATEOPDVISITS = "UPDATEOPDVISITS";
export const DETAILSOPDVISITS = "DETAILSOPDVISITS";
export const DETAILSOPDPRESCRIPTION = "DETAILSOPDPRESCRIPTION";

export const CREATEOPDOUTBILL = "CREATEIPDOPDOUTBILL";
export const GETOPDOUTBILL = "GETOPDOUTBILL";
export const GETALLOPDOUTBILL = "GETALLOPDOUTBILL";
export const DELETEOPDOUTBILL = "DELETEOPDOUTBILL";
export const UPDATEOPDOUTBILL = "UPDATEOPDOUTBILL";
export const CREATEOPDOUTSYMPTOMS = "CREATEIPDOPDOUTSYMPTOMS";
export const GETOPDOUTSYMPTOMS = "GETOPDOUTSYMPTOMS";
export const GETALLOPDOUTSYMPTOMS = "GETALLOPDOUTSYMPTOMS";
export const DELETEOPDOUTSYMPTOMS = "DELETEOPDOUTSYMPTOMS";
export const UPDATEOPDOUTSYMPTOMS = "UPDATEOPDOUTSYMPTOMS";
export const CREATEOPDOUTCOBORBIDITY = "CREATEIPDOPDOUTCOBORBIDITY";
export const GETOPDOUTCOBORBIDITY = "GETOPDOUTCOBORBIDITY";
export const GETALLOPDOUTCOBORBIDITY = "GETALLOPDOUTCOBORBIDITY";
export const DELETEOPDOUTCOBORBIDITY = "DELETEOPDOUTCOBORBIDITY";
export const UPDATEOPDOUTCOBORBIDITY = "UPDATEOPDOUTCOBORBIDITY";
export const CREATEOPDOUTINVESTIGATION = "CREATEIPDOPDOUTINVESTIGATION";
export const GETOPDOUTINVESTIGATION = "GETOPDOUTINVESTIGATION";
export const GETALLOPDOUTINVESTIGATION = "GETALLOPDOUTINVESTIGATION";
export const DELETEOPDOUTINVESTIGATION = "DELETEOPDOUTINVESTIGATION";
export const UPDATEOPDOUTINVESTIGATION = "UPDATEOPDOUTINVESTIGATION";
export const CREATEPRESCRIPTION = "CREATEIPDPRESCRIPTION";
export const GETPRESCRIPTION = "GETPRESCRIPTION";
export const GETALLPRESCRIPTION = "GETALLPRESCRIPTION";
export const DELETEPRESCRIPTION = "DELETEPRESCRIPTION";
export const UPDATEPRESCRIPTION = "UPDATEPRESCRIPTION";
export const CREATEPRESCRIPTIONMEDICINE = "CREATEIPDPRESCRIPTIONMEDICINE";
export const GETPRESCRIPTIONMEDICINE = "GETPRESCRIPTIONMEDICINE";
export const GETALLPRESCRIPTIONMEDICINE = "GETALLPRESCRIPTIONMEDICINE";
export const DELETEPRESCRIPTIONMEDICINE = "DELETEPRESCRIPTIONMEDICINE";
export const UPDATEPRESCRIPTIONMEDICINE = "UPDATEPRESCRIPTIONMEDICINE";
export const CREATEPRESCRIPTIONROLL = "CREATEIPDPRESCRIPTIONROLL";
export const GETPRESCRIPTIONROLL = "GETPRESCRIPTIONROLL";
export const GETALLPRESCRIPTIONROLL = "GETALLPRESCRIPTIONROLL";
export const DELETEPRESCRIPTIONROLL = "DELETEPRESCRIPTIONROLL";
export const UPDATEPRESCRIPTIONROLL = "UPDATEPRESCRIPTIONROLL";

export const CREATETPA = "CREATEIPDTPA";
export const GETTPA = "GETTPA";
export const GETALLTPA = "GETALLTPA";
export const DELETETPA = "DELETETPA";
export const UPDATETPA = "UPDATETPA";
export const CREATETPACHARGE = "CREATEIPDTPACHARGE";
export const GETTPACHARGE = "GETTPACHARGE";
export const GETALLTPACHARGE = "GETALLTPACHARGE";
export const DELETETPACHARGE = "DELETETPACHARGE";
export const UPDATETPACHARGE = "UPDATETPACHARGE";

export const CREATEREFERALPERSON = "CREATEIPDREFERALPERSON";
export const GETREFERALPERSON = "GETREFERALPERSON";
export const GETALLREFERALPERSON = "GETALLREFERALPERSON";
export const DELETEREFERALPERSON = "DELETEREFERALPERSON";
export const UPDATEREFERALPERSON = "UPDATEREFERALPERSON";
export const CREATEREFERALDEPARTMENTCOMMISSION =
  "CREATEIPDREFERALDEPARTMENTCOMMISSION";
export const GETREFERALDEPARTMENTCOMMISSION = "GETREFERALDEPARTMENTCOMMISSION";
export const GETALLREFERALDEPARTMENTCOMMISSION =
  "GETALLREFERALDEPARTMENTCOMMISSION";
export const DELETEREFERALDEPARTMENTCOMMISSION =
  "DELETEREFERALDEPARTMENTCOMMISSION";
export const UPDATEREFERALDEPARTMENTCOMMISSION =
  "UPDATEREFERALDEPARTMENTCOMMISSION";
export const CREATEREFERALPAYMENT = "CREATEIPDREFERALPAYMENT";
export const GETREFERALPAYMENT = "GETREFERALPAYMENT";
export const GETALLREFERALPAYMENT = "GETALLREFERALPAYMENT";
export const DELETEREFERALPAYMENT = "DELETEREFERALPAYMENT";
export const UPDATEREFERALPAYMENT = "UPDATEREFERALPAYMENT";
export const CREATETIMELINE = "CREATEIPDTIMELINE";
export const GETTIMELINE = "GETTIMELINE";
export const GETALLTIMELINE = "GETALLTIMELINE";
export const DELETETIMELINE = "DELETETIMELINE";
export const UPDATETIMELINE = "UPDATETIMELINE";

export const CREATEPAYMENT = "CREATEIPDPAYMENT";
export const GETPAYMENT = "GETPAYMENT";
export const GETALLPAYMENT = "GETALLPAYMENT";
export const DELETEPAYMENT = "DELETEPAYMENT";
export const UPDATEPAYMENT = "UPDATEPAYMENT";
export const CREATEOPDCHARGE = "CREATEIPDOPDCHARGE";
export const GETOPDCHARGE = "GETOPDCHARGE";
export const GETALLOPDCHARGE = "GETALLOPDCHARGE";
export const DELETEOPDCHARGE = "DELETEOPDCHARGE";
export const UPDATEOPDCHARGE = "UPDATEOPDCHARGE";

export const CREATEOPDOPERATION = "CREATEIPDOPDOPERATION";
export const GETOPDOPERATION = "GETOPDOPERATION";
export const GETALLOPDOPERATION = "GETALLOPDOPERATION";
export const DELETEOPDOPERATION = "DELETEOPDOPERATION";
export const UPDATEOPDOPERATION = "UPDATEOPDOPERATION";

export const CREATEPHARMACYMEDICINE = "CREATEIPDPHARMACYMEDICINE";
export const GETPHARMACYMEDICINE = "GETPHARMACYMEDICINE";
export const GETALLPHARMACYMEDICINE = "GETALLPHARMACYMEDICINE";
export const DELETEPHARMACYMEDICINE = "DELETEPHARMACYMEDICINE";
export const UPDATEPHARMACYMEDICINE = "UPDATEPHARMACYMEDICINE";
export const GETALLPHARMACYMEDICINEQTY = "GETALLPHARMACYMEDICINEQTY";
export const CREATEPURCHESEMEDICINE = "CREATEIPDPURCHESEMEDICINE";
export const GETPURCHESEMEDICINE = "GETPURCHESEMEDICINE";
export const GETPURCHESEMEDICINEAVIQTY = "GETPURCHESEMEDICINEAVLQTY";

export const GETALLPURCHESEMEDICINE = "GETALLPURCHESEMEDICINE";
export const DELETEPURCHESEMEDICINE = "DELETEPURCHESEMEDICINE";
export const UPDATEPURCHESEMEDICINE = "UPDATEPURCHESEMEDICINE";
export const CREATEPURCHESEMEDICINESHOW = "CREATEIPDPURCHESEMEDICINESHOW";
export const GETPURCHESEMEDICINESHOW = "GETPURCHESEMEDICINESHOW";
export const GETALLPURCHESEMEDICINESHOW = "GETALLPURCHESEMEDICINESHOW";
export const DELETEPURCHESEMEDICINESHOW = "DELETEPURCHESEMEDICINESHOW";
export const UPDATEPURCHESEMEDICINESHOW = "UPDATEPURCHESEMEDICINESHOW";
export const UPDATEAVAILQTY = "UPDATEAVAILQTY";

export const RESERVE_STOCK_SUCCESS = "RESERVE_STOCK_SUCCESS";
export const RESERVE_STOCK_FAILURE = "RESERVE_STOCK_FAILURE";
export const RESTORE_RESERVED_STOCK_SUCCESS = "RESTORE_RESERVED_STOCK_SUCCESS";
export const RESTORE_RESERVED_STOCK_FAILURE = "RESTORE_RESERVED_STOCK_FAILURE";

export const CREATEPURCHESEMEDICINEBILL = "CREATEIPDPURCHESEMEDICINEBILL";
export const GETPURCHESEMEDICINEBILL = "GETPURCHESEMEDICINEBILL";
export const GETALLPURCHESEMEDICINEBILL = "GETALLPURCHESEMEDICINEBILL";
export const DELETEPURCHESEMEDICINEBILL = "DELETEPURCHESEMEDICINEBILL";
export const UPDATEPURCHESEMEDICINEBILL = "UPDATEPURCHESEMEDICINEBILL";
export const CREATEPURCHESEMEDICINEBILLTRANSACTION =
  "CREATEIPDPURCHESEMEDICINEBILLTRANSACTION";
export const GETPURCHESEMEDICINEBILLTRANSACTION =
  "GETPURCHESEMEDICINEBILLTRANSACTION";
export const GETALLPURCHESEMEDICINEBILLTRANSACTION =
  "GETALLPURCHESEMEDICINEBILLTRANSACTION";
export const DELETEPURCHESEMEDICINEBILLTRANSACTION =
  "DELETEPURCHESEMEDICINEBILLTRANSACTION";
export const UPDATEPURCHESEMEDICINEBILLTRANSACTION =
  "UPDATEPURCHESEMEDICINEBILLTRANSACTION";
export const CREATEPHARMACYBILL = "CREATEIPDPHARMACYBILL";
export const GETPHARMACYBILL = "GETPHARMACYBILL";
export const GETALLPHARMACYBILL = "GETALLPHARMACYBILL";
export const DELETEPHARMACYBILL = "DELETEPHARMACYBILL";
export const UPDATEPHARMACYBILL = "UPDATEPHARMACYBILL";
export const CREATEPHARMACYBILLMEDICINE = "CREATEIPDPHARMACYBILLMEDICINE";
export const GETPHARMACYBILLMEDICINE = "GETPHARMACYBILLMEDICINE";
export const GETALLPHARMACYBILLMEDICINE = "GETALLPHARMACYBILLMEDICINE";
export const DELETEPHARMACYBILLMEDICINE = "DELETEPHARMACYBILLMEDICINE";
export const UPDATEPHARMACYBILLMEDICINE = "UPDATEPHARMACYBILLMEDICINE";

export const CREATEPHARMACYBADSTOCK = "CREATEIPDPHARMACYBADSTOCK";
export const GETPHARMACYBADSTOCK = "GETPHARMACYBADSTOCK";
export const GETALLPHARMACYBADSTOCK = "GETALLPHARMACYBADSTOCK";
export const DELETEPHARMACYBADSTOCK = "DELETEPHARMACYBADSTOCK";
export const UPDATEPHARMACYBADSTOCK = "UPDATEPHARMACYBADSTOCK";

export const CREATEPATHOLOGYTEST = "CREATEIPDPATHOLOGYTEST";
export const GETPATHOLOGYTEST = "GETPATHOLOGYTEST";
export const GETALLPATHOLOGYTEST = "GETALLPATHOLOGYTEST";
export const DELETEPATHOLOGYTEST = "DELETEPATHOLOGYTEST";
export const UPDATEPATHOLOGYTEST = "UPDATEPATHOLOGYTEST";
export const CREATEPATHOLOGYTESTPARAMETER = "CREATEIPDPATHOLOGYTESTPARAMETER";
export const GETPATHOLOGYTESTPARAMETER = "GETPATHOLOGYTESTPARAMETER";
export const GETALLPATHOLOGYTESTPARAMETER = "GETALLPATHOLOGYTESTPARAMETER";
export const DELETEPATHOLOGYTESTPARAMETER = "DELETEPATHOLOGYTESTPARAMETER";
export const UPDATEPATHOLOGYTESTPARAMETER = "UPDATEPATHOLOGYTESTPARAMETER";

export const CREATEPATHOLOGYBILL = "CREATEIPDPATHOLOGYBILL";
export const GETPATHOLOGYBILL = "GETPATHOLOGYBILL";
export const GETALLPATHOLOGYBILL = "GETALLPATHOLOGYBILL";
export const DELETEPATHOLOGYBILL = "DELETEPATHOLOGYBILL";
export const UPDATEPATHOLOGYBILL = "UPDATEPATHOLOGYBILL";
export const CREATEPATHOLOGYBILLTEST = "CREATEIPDPATHOLOGYBILLTEST";
export const GETPATHOLOGYBILLTEST = "GETPATHOLOGYBILLTEST";
export const GETALLPATHOLOGYBILLTEST = "GETALLPATHOLOGYBILLTEST";
export const DELETEPATHOLOGYBILLTEST = "DELETEPATHOLOGYBILLTEST";
export const UPDATEPATHOLOGYBILLTEST = "UPDATEPATHOLOGYBILLTEST";
export const CREATEPATHOLOGYTESTCOLLECTER = "CREATEIPDPATHOLOGYTESTCOLLECTER";
export const GETPATHOLOGYTESTCOLLECTER = "GETPATHOLOGYTESTCOLLECTER";
export const GETALLPATHOLOGYTESTCOLLECTER = "GETALLPATHOLOGYTESTCOLLECTER";
export const DELETEPATHOLOGYTESTCOLLECTER = "DELETEPATHOLOGYTESTCOLLECTER";
export const UPDATEPATHOLOGYTESTCOLLECTER = "UPDATEPATHOLOGYTESTCOLLECTER";

export const CREATERADIOLOGYTEST = "CREATEIPDRADIOLOGYTEST";
export const GETRADIOLOGYTEST = "GETRADIOLOGYTEST";
export const GETALLRADIOLOGYTEST = "GETALLRADIOLOGYTEST";
export const DELETERADIOLOGYTEST = "DELETERADIOLOGYTEST";
export const UPDATERADIOLOGYTEST = "UPDATERADIOLOGYTEST";
export const CREATERADIOLOGYOPDTEST = "CREATEIPDRADIOLOGYOPDTEST";
export const GETRADIOLOGYOPDTEST = "GETRADIOLOGYOPDTEST";
export const GETALLRADIOLOGYOPDTEST = "GETALLRADIOLOGYOPDTEST";
export const DELETERADIOLOGYOPDTEST = "DELETERADIOLOGYOPDTEST";
export const UPDATERADIOLOGYOPDTEST = "UPDATERADIOLOGYOPDTEST";
export const CREATEPATHOLOGYOPDTEST = "CREATEIPDPATHOLOGYOPDTEST";
export const GETPATHOLOGYOPDTEST = "GETPATHOLOGYOPDTEST";
export const GETALLPATHOLOGYOPDTEST = "GETALLPATHOLOGYOPDTEST";
export const DELETEPATHOLOGYOPDTEST = "DELETEPATHOLOGYOPDTEST";
export const UPDATEPATHOLOGYOPDTEST = "UPDATEPATHOLOGYOPDTEST";
export const CREATERADIOLOGYTESTPARAMETER = "CREATEIPDRADIOLOGYTESTPARAMETER";
export const GETRADIOLOGYTESTPARAMETER = "GETRADIOLOGYTESTPARAMETER";
export const GETALLRADIOLOGYTESTPARAMETER = "GETALLRADIOLOGYTESTPARAMETER";
export const DELETERADIOLOGYTESTPARAMETER = "DELETERADIOLOGYTESTPARAMETER";
export const UPDATERADIOLOGYTESTPARAMETER = "UPDATERADIOLOGYTESTPARAMETER";
export const CREATERADIOLOGYTESTPARAMETERVALUE =
  "CREATEIPDRADIOLOGYTESTPARAMETERVALUE";
export const GETRADIOLOGYTESTPARAMETERVALUE = "GETRADIOLOGYTESTPARAMETERVALUE";
export const GETALLRADIOLOGYTESTPARAMETERVALUE =
  "GETALLRADIOLOGYTESTPARAMETERVALUE";
export const DELETERADIOLOGYTESTPARAMETERVALUE =
  "DELETERADIOLOGYTESTPARAMETERVALUE";
export const UPDATERADIOLOGYTESTPARAMETERVALUE =
  "UPDATERADIOLOGYTESTPARAMETERVALUE";
export const CREATEPATHOLOGYTESTPARAMETERVALUE =
  "CREATEIPDPATHOLOGYTESTPARAMETERVALUE";
export const GETPATHOLOGYTESTPARAMETERVALUE = "GETPATHOLOGYTESTPARAMETERVALUE";
export const GETALLPATHOLOGYTESTPARAMETERVALUE =
  "GETALLPATHOLOGYTESTPARAMETERVALUE";
export const DELETEPATHOLOGYTESTPARAMETERVALUE =
  "DELETEPATHOLOGYTESTPARAMETERVALUE";
export const UPDATEPATHOLOGYTESTPARAMETERVALUE =
  "UPDATEPATHOLOGYTESTPARAMETERVALUE";
export const CREATERADIOLOGYBILL = "CREATEIPDRADIOLOGYBILL";
export const GETRADIOLOGYBILL = "GETRADIOLOGYBILL";
export const GETALLRADIOLOGYBILL = "GETALLRADIOLOGYBILL";
export const DELETERADIOLOGYBILL = "DELETERADIOLOGYBILL";
export const UPDATERADIOLOGYBILL = "UPDATERADIOLOGYBILL";
export const CREATERADIOLOGYBILLTEST = "CREATEIPDRADIOLOGYBILLTEST";
export const GETRADIOLOGYBILLTEST = "GETRADIOLOGYBILLTEST";
export const GETALLRADIOLOGYBILLTEST = "GETALLRADIOLOGYBILLTEST";
export const DELETERADIOLOGYBILLTEST = "DELETERADIOLOGYBILLTEST";
export const UPDATERADIOLOGYBILLTEST = "UPDATERADIOLOGYBILLTEST";
export const CREATERADIOLOGYTESTCOLLECTER = "CREATEIPDRADIOLOGYTESTCOLLECTER";
export const GETRADIOLOGYTESTCOLLECTER = "GETRADIOLOGYTESTCOLLECTER";
export const GETALLRADIOLOGYTESTCOLLECTER = "GETALLRADIOLOGYTESTCOLLECTER";
export const DELETERADIOLOGYTESTCOLLECTER = "DELETERADIOLOGYTESTCOLLECTER";
export const UPDATERADIOLOGYTESTCOLLECTER = "UPDATERADIOLOGYTESTCOLLECTER";
export const CREATERADIOLOGYBILLTRANSACTION =
  "CREATEIPDRADIOLOGYBILLTRANSACTION";
export const GETRADIOLOGYBILLTRANSACTION = "GETRADIOLOGYBILLTRANSACTION";
export const GETALLRADIOLOGYBILLTRANSACTION = "GETALLRADIOLOGYBILLTRANSACTION";
export const DELETERADIOLOGYBILLTRANSACTION = "DELETERADIOLOGYBILLTRANSACTION";
export const UPDATERADIOLOGYBILLTRANSACTION = "UPDATERADIOLOGYBILLTRANSACTION";
export const CREATEPATHOLOGYBILLTRANSACTION =
  "CREATEIPDPATHOLOGYBILLTRANSACTION";
export const GETPATHOLOGYBILLTRANSACTION = "GETPATHOLOGYBILLTRANSACTION";

export const GETALLPATHOLOGYBILLTRANSACTION = "GETALLPATHOLOGYBILLTRANSACTION";
export const DELETEPATHOLOGYBILLTRANSACTION = "DELETEPATHOLOGYBILLTRANSACTION";
export const UPDATEPATHOLOGYBILLTRANSACTION = "UPDATEPATHOLOGYBILLTRANSACTION";
export const CREATEBLOODBANKDONAR = "CREATEIPDBLOODBANKDONAR";
export const GETBLOODBANKDONAR = "GETBLOODBANKDONAR";
export const GETALLBLOODBANKDONAR = "GETALLBLOODBANKDONAR";
export const DELETEBLOODBANKDONAR = "DELETEBLOODBANKDONAR";
export const UPDATEBLOODBANKDONAR = "UPDATEBLOODBANKDONAR";
export const CREATEBLOODBANKBAGRECEIVE = "CREATEIPDBLOODBANKBAGRECEIVE";
export const GETBLOODBANKBAGRECEIVE = "GETBLOODBANKBAGRECEIVE";
export const GETALLBLOODBANKBAGRECEIVE = "GETALLBLOODBANKBAGRECEIVE";
export const DELETEBLOODBANKBAGRECEIVE = "DELETEBLOODBANKBAGRECEIVE";
export const UPDATEBLOODBANKBAGRECEIVE = "UPDATEBLOODBANKBAGRECEIVE";
export const CREATEBLOODBANKBAGRECEIVETRANSACTION =
  "CREATEIPDBLOODBANKBAGRECEIVETRANSACTION";
export const GETBLOODBANKBAGRECEIVETRANSACTION =
  "GETBLOODBANKBAGRECEIVETRANSACTION";
export const GETALLBLOODBANKBAGRECEIVETRANSACTION =
  "GETALLBLOODBANKBAGRECEIVETRANSACTION";
export const DELETEBLOODBANKBAGRECEIVETRANSACTION =
  "DELETEBLOODBANKBAGRECEIVETRANSACTION";
export const UPDATEBLOODBANKBAGRECEIVETRANSACTION =
  "UPDATEBLOODBANKBAGRECEIVETRANSACTION";
export const CREATEBLOODBANKCOMPONENT = "CREATEIPDBLOODBANKCOMPONENT";
export const GETBLOODBANKCOMPONENT = "GETBLOODBANKCOMPONENT";
export const GETALLBLOODBANKCOMPONENT = "GETALLBLOODBANKCOMPONENT";
export const DELETEBLOODBANKCOMPONENT = "DELETEBLOODBANKCOMPONENT";
export const UPDATEBLOODBANKCOMPONENT = "UPDATEBLOODBANKCOMPONENT";
export const CREATEPHARMACYBILLTRANSACTION = "CREATEIPDPHARMACYBILLTRANSACTION";
export const GETPHARMACYBILLTRANSACTION = "GETPHARMACYBILLTRANSACTION";
export const GETALLPHARMACYBILLTRANSACTION = "GETALLPHARMACYBILLTRANSACTION";
export const DELETEPHARMACYBILLTRANSACTION = "DELETEPHARMACYBILLTRANSACTION";
export const UPDATEPHARMACYBILLTRANSACTION = "UPDATEPHARMACYBILLTRANSACTION";

export const CREATEBLOODBANKBAGISSUE = "CREATEIPDBLOODBANKBAGISSUE";
export const GETBLOODBANKBAGISSUE = "GETBLOODBANKBAGISSUE";
export const GETALLBLOODBANKBAGISSUE = "GETALLBLOODBANKBAGISSUE";
export const DELETEBLOODBANKBAGISSUE = "DELETEBLOODBANKBAGISSUE";
export const UPDATEBLOODBANKBAGISSUE = "UPDATEBLOODBANKBAGISSUE";
export const CREATEBLOODBANKBAGISSUETRANSACTION =
  "CREATEIPDBLOODBANKBAGISSUETRANSACTION";
export const GETBLOODBANKBAGISSUETRANSACTION =
  "GETBLOODBANKBAGISSUETRANSACTION";
export const GETALLBLOODBANKBAGISSUETRANSACTION =
  "GETALLBLOODBANKBAGISSUETRANSACTION";
export const DELETEBLOODBANKBAGISSUETRANSACTION =
  "DELETEBLOODBANKBAGISSUETRANSACTION";
export const UPDATEBLOODBANKBAGISSUETRANSACTION =
  "UPDATEBLOODBANKBAGISSUETRANSACTION";
export const CREATEBLOODBANKCOMPONENTISSUE = "CREATEIPDBLOODBANKCOMPONENTISSUE";
export const GETBLOODBANKCOMPONENTISSUE = "GETBLOODBANKCOMPONENTISSUE";
export const GETALLBLOODBANKCOMPONENTISSUE = "GETALLBLOODBANKCOMPONENTISSUE";
export const DELETEBLOODBANKCOMPONENTISSUE = "DELETEBLOODBANKCOMPONENTISSUE";
export const UPDATEBLOODBANKCOMPONENTISSUE = "UPDATEBLOODBANKCOMPONENTISSUE";
export const CREATEBLOODBANKCOMPONENTISSUETRANSACTION =
  "CREATEIPDBLOODBANKCOMPONENTISSUETRANSACTION";
export const GETBLOODBANKCOMPONENTISSUETRANSACTION =
  "GETBLOODBANKCOMPONENTISSUETRANSACTION";
export const GETALLBLOODBANKCOMPONENTISSUETRANSACTION =
  "GETALLBLOODBANKCOMPONENTISSUETRANSACTION";
export const DELETEBLOODBANKCOMPONENTISSUETRANSACTION =
  "DELETEBLOODBANKCOMPONENTISSUETRANSACTION";
export const UPDATEBLOODBANKCOMPONENTISSUETRANSACTION =
  "UPDATEBLOODBANKCOMPONENTISSUETRANSACTION";

export const CREATEAMBULANCE = "CREATEIPDAMBULANCE";
export const GETAMBULANCE = "GETAMBULANCE";
export const GETALLAMBULANCE = "GETALLAMBULANCE";
export const DELETEAMBULANCE = "DELETEAMBULANCE";
export const UPDATEAMBULANCE = "UPDATEAMBULANCE";
export const CREATEAMBULANCECALL = "CREATEIPDAMBULANCECALL";
export const GETAMBULANCECALL = "GETAMBULANCECALL";
export const GETALLAMBULANCECALL = "GETALLAMBULANCECALL";
export const DELETEAMBULANCECALL = "DELETEAMBULANCECALL";
export const UPDATEAMBULANCECALL = "UPDATEAMBULANCECALL";
export const CREATEAMBULANCECALLTRANSACTION =
  "CREATEIPDAMBULANCECALLTRANSACTION";
export const GETAMBULANCECALLTRANSACTION = "GETAMBULANCECALLTRANSACTION";
export const GETALLAMBULANCECALLTRANSACTION = "GETALLAMBULANCECALLTRANSACTION";
export const DELETEAMBULANCECALLTRANSACTION = "DELETEAMBULANCECALLTRANSACTION";
export const UPDATEAMBULANCECALLTRANSACTION = "UPDATEAMBULANCECALLTRANSACTION";

export const CREATEFRONTOFFICEPHONECALLLOG = "CREATEIPDFRONTOFFICEPHONECALLLOG";
export const GETFRONTOFFICEPHONECALLLOG = "GETFRONTOFFICEPHONECALLLOG";
export const GETALLFRONTOFFICEPHONECALLLOG = "GETALLFRONTOFFICEPHONECALLLOG";
export const DELETEFRONTOFFICEPHONECALLLOG = "DELETEFRONTOFFICEPHONECALLLOG";
export const UPDATEFRONTOFFICEPHONECALLLOG = "UPDATEFRONTOFFICEPHONECALLLOG";
export const CREATEFRONTOFFICEVISITOR = "CREATEIPDFRONTOFFICEVISITOR";
export const GETFRONTOFFICEVISITOR = "GETFRONTOFFICEVISITOR";
export const GETALLFRONTOFFICEVISITOR = "GETALLFRONTOFFICEVISITOR";
export const DELETEFRONTOFFICEVISITOR = "DELETEFRONTOFFICEVISITOR";
export const UPDATEFRONTOFFICEVISITOR = "UPDATEFRONTOFFICEVISITOR";
export const CREATEFRONTOFFICEPOSTAL = "CREATEIPDFRONTOFFICEPOSTAL";
export const GETFRONTOFFICEPOSTAL = "GETFRONTOFFICEPOSTAL";
export const GETALLFRONTOFFICEPOSTAL = "GETALLFRONTOFFICEPOSTAL";
export const DELETEFRONTOFFICEPOSTAL = "DELETEFRONTOFFICEPOSTAL";
export const UPDATEFRONTOFFICEPOSTAL = "UPDATEFRONTOFFICEPOSTAL";
export const CREATEFRONTOFFICEPOSTALDISPATCH =
  "CREATEIPDFRONTOFFICEPOSTALDISPATCH";
export const GETFRONTOFFICEPOSTALDISPATCH = "GETFRONTOFFICEPOSTALDISPATCH";
export const GETALLFRONTOFFICEPOSTALDISPATCH =
  "GETALLFRONTOFFICEPOSTALDISPATCH";
export const DELETEFRONTOFFICEPOSTALDISPATCH =
  "DELETEFRONTOFFICEPOSTALDISPATCH";
export const UPDATEFRONTOFFICEPOSTALDISPATCH =
  "UPDATEFRONTOFFICEPOSTALDISPATCH";
export const CREATEFRONTOFFICECOMPLAIN = "CREATEIPDFRONTOFFICECOMPLAIN";
export const GETFRONTOFFICECOMPLAIN = "GETFRONTOFFICECOMPLAIN";
export const GETALLFRONTOFFICECOMPLAIN = "GETALLFRONTOFFICECOMPLAIN";
export const DELETEFRONTOFFICECOMPLAIN = "DELETEFRONTOFFICECOMPLAIN";
export const UPDATEFRONTOFFICECOMPLAIN = "UPDATEFRONTOFFICECOMPLAIN";

export const CREATEIPDPATIENT = "CREATEIPDIPDPATIENT";
export const GETALLIPD = "GETALLIPD";

export const GETIPDPATIENT = "GETIPDPATIENT";
export const GETIPDPATIENTLIKE = "GETIPDPATIENTLIKE";

export const GETIPDPATIENTBYID = "GETIPDPATIENTBYID";
export const DELETEIPDPATIENT = "DELETEIPDPATIENT";
export const UPDATEIPDPATIENT = "UPDATEIPDPATIENT";
export const UPDATEIPDPATIENTACTION = "UPDATEIPDPATIENTACTION";
export const CREATEIPDVISITS = "CREATEIPDIPDVISITS";
export const GETIPDVISITS = "GETIPDVISITS";
export const GETALLIPDVISITS = "GETALLIPDVISITS";
export const DELETEIPDVISITS = "DELETEIPDVISITS";
export const UPDATEIPDVISITS = "UPDATEIPDVISITS";
export const CREATEIPDOUTBILL = "CREATEIPDIPDOUTBILL";
export const GETIPDOUTBILL = "GETIPDOUTBILL";
export const GETALLIPDOUTBILL = "GETALLIPDOUTBILL";
export const DELETEIPDOUTBILL = "DELETEIPDOUTBILL";
export const UPDATEIPDOUTBILL = "UPDATEIPDOUTBILL";
export const CREATEHOSPITALEBIRTHRECORD = "CREATEIPDHOSPITALEBIRTHRECORD";
export const GETHOSPITALEBIRTHRECORD = "GETHOSPITALEBIRTHRECORD";
export const GETALLHOSPITALEBIRTHRECORD = "GETALLHOSPITALEBIRTHRECORD";
export const DELETEHOSPITALEBIRTHRECORD = "DELETEHOSPITALEBIRTHRECORD";
export const UPDATEHOSPITALEBIRTHRECORD = "UPDATEHOSPITALEBIRTHRECORD";
export const CREATEHOSPITALEDEATHRECORD = "CREATEIPDHOSPITALEDEATHRECORD";
export const GETHOSPITALEDEATHRECORD = "GETHOSPITALEDEATHRECORD";
export const GETALLHOSPITALEDEATHRECORD = "GETALLHOSPITALEDEATHRECORD";
export const DELETEHOSPITALEDEATHRECORD = "DELETEHOSPITALEDEATHRECORD";
export const UPDATEHOSPITALEDEATHRECORD = "UPDATEHOSPITALEDEATHRECORD";
export const CREATEHOSPITALEINCOME = "CREATEIPDHOSPITALEINCOME";
export const GETHOSPITALEINCOME = "GETHOSPITALEINCOME";
export const GETALLHOSPITALEINCOME = "GETALLHOSPITALEINCOME";
export const DELETEHOSPITALEINCOME = "DELETEHOSPITALEINCOME";
export const UPDATEHOSPITALEINCOME = "UPDATEHOSPITALEINCOME";
export const CREATEHOSPITALEEXPENSE = "CREATEIPDHOSPITALEEXPENSE";
export const GETHOSPITALEEXPENSE = "GETHOSPITALEEXPENSE";
export const GETALLHOSPITALEEXPENSE = "GETALLHOSPITALEEXPENSE";
export const DELETEHOSPITALEEXPENSE = "DELETEHOSPITALEEXPENSE";
export const UPDATEHOSPITALEEXPENSE = "UPDATEHOSPITALEEXPENSE";
export const CREATEHOSPITALEINVENTORYITEM = "CREATEIPDHOSPITALEINVENTORYITEM";
export const GETHOSPITALEINVENTORYITEM = "GETHOSPITALEINVENTORYITEM";
export const GETALLHOSPITALEINVENTORYITEM = "GETALLHOSPITALEINVENTORYITEM";
export const DELETEHOSPITALEINVENTORYITEM = "DELETEHOSPITALEINVENTORYITEM";
export const UPDATEHOSPITALEINVENTORYITEM = "UPDATEHOSPITALEINVENTORYITEM";
export const CREATEHOSPITALEINVENTORYSTOCK = "CREATEIPDHOSPITALEINVENTORYSTOCK";
export const GETHOSPITALEINVENTORYSTOCK = "GETHOSPITALEINVENTORYSTOCK";
export const GETALLHOSPITALEINVENTORYSTOCK = "GETALLHOSPITALEINVENTORYSTOCK";
export const DELETEHOSPITALEINVENTORYSTOCK = "DELETEHOSPITALEINVENTORYSTOCK";
export const UPDATEHOSPITALEINVENTORYSTOCK = "UPDATEHOSPITALEINVENTORYSTOCK";
export const CREATEHOSPITALEINVENTORYITEMISSUE =
  "CREATEIPDHOSPITALEINVENTORYITEMISSUE";
export const GETHOSPITALEINVENTORYITEMISSUE = "GETHOSPITALEINVENTORYITEMISSUE";
export const GETALLHOSPITALEINVENTORYITEMISSUE =
  "GETALLHOSPITALEINVENTORYITEMISSUE";
export const DELETEHOSPITALEINVENTORYITEMISSUE =
  "DELETEHOSPITALEINVENTORYITEMISSUE";
export const UPDATEHOSPITALEINVENTORYITEMISSUE =
  "UPDATEHOSPITALEINVENTORYITEMISSUE";
export const CREATEHOSPITALEDOWNLOAD = "CREATEIPDHOSPITALEDOWNLOAD";
export const GETHOSPITALEDOWNLOAD = "GETHOSPITALEDOWNLOAD";
export const GETALLHOSPITALEDOWNLOAD = "GETALLHOSPITALEDOWNLOAD";
export const DELETEHOSPITALEDOWNLOAD = "DELETEHOSPITALEDOWNLOAD";
export const UPDATEHOSPITALEDOWNLOAD = "UPDATEHOSPITALEDOWNLOAD";
export const CREATEHOSPITALEMESSAGE = "CREATEIPDHOSPITALEMESSAGE";
export const GETHOSPITALEMESSAGE = "GETHOSPITALEMESSAGE";
export const GETALLHOSPITALEMESSAGE = "GETALLHOSPITALEMESSAGE";
export const DELETEHOSPITALEMESSAGE = "DELETEHOSPITALEMESSAGE";
export const UPDATEHOSPITALEMESSAGE = "UPDATEHOSPITALEMESSAGE";
export const CREATEHOSPITALESENDMESSAGE = "CREATEIPDHOSPITALESENDMESSAGE";
export const GETHOSPITALESENDMESSAGE = "GETHOSPITALESENDMESSAGE";
export const GETALLHOSPITALESENDMESSAGE = "GETALLHOSPITALESENDMESSAGE";
export const DELETEHOSPITALESENDMESSAGE = "DELETEHOSPITALESENDMESSAGE";
export const UPDATEHOSPITALESENDMESSAGE = "UPDATEHOSPITALESENDMESSAGE";
export const CREATEHOSPITALESENDEMAIL = "CREATEIPDHOSPITALESENDEMAIL";
export const GETHOSPITALESENDEMAIL = "GETHOSPITALESENDEMAIL";
export const GETALLHOSPITALESENDEMAIL = "GETALLHOSPITALESENDEMAIL";
export const DELETEHOSPITALESENDEMAIL = "DELETEHOSPITALESENDEMAIL";
export const UPDATEHOSPITALESENDEMAIL = "UPDATEHOSPITALESENDEMAIL";
export const CREATEHRSTAFFATTENDANCE = "CREATEIPDHRSTAFFATTENDANCE";
export const GETHRSTAFFATTENDANCE = "GETHRSTAFFATTENDANCE";
export const GETALLHRSTAFFATTENDANCE = "GETALLHRSTAFFATTENDANCE";
export const DELETEHRSTAFFATTENDANCE = "DELETEHRSTAFFATTENDANCE";
export const UPDATEHRSTAFFATTENDANCE = "UPDATEHRSTAFFATTENDANCE";
export const CREATEHRSTAFFPAYROLLDEDUCTION = "CREATEIPDHRSTAFFPAYROLLDEDUCTION";
export const GETHRSTAFFPAYROLLDEDUCTION = "GETHRSTAFFPAYROLLDEDUCTION";
export const GETALLHRSTAFFPAYROLLDEDUCTION = "GETALLHRSTAFFPAYROLLDEDUCTION";
export const DELETEHRSTAFFPAYROLLDEDUCTION = "DELETEHRSTAFFPAYROLLDEDUCTION";
export const UPDATEHRSTAFFPAYROLLDEDUCTION = "UPDATEHRSTAFFPAYROLLDEDUCTION";
export const CREATEHRSTAFFPAYROLLINFO = "CREATEIPDHRSTAFFPAYROLLINFO";
export const GETHRSTAFFPAYROLLINFO = "GETHRSTAFFPAYROLLINFO";
export const GETALLHRSTAFFPAYROLLINFO = "GETALLHRSTAFFPAYROLLINFO";
export const DELETEHRSTAFFPAYROLLINFO = "DELETEHRSTAFFPAYROLLINFO";
export const UPDATEHRSTAFFPAYROLLINFO = "UPDATEHRSTAFFPAYROLLINFO";
export const CREATEHRSTAFFPAYROLLPAYMENT = "CREATEIPDHRSTAFFPAYROLLPAYMENT";
export const GETHRSTAFFPAYROLLPAYMENT = "GETHRSTAFFPAYROLLPAYMENT";
export const GETALLHRSTAFFPAYROLLPAYMENT = "GETALLHRSTAFFPAYROLLPAYMENT";
export const DELETEHRSTAFFPAYROLLPAYMENT = "DELETEHRSTAFFPAYROLLPAYMENT";
export const UPDATEHRSTAFFPAYROLLPAYMENT = "UPDATEHRSTAFFPAYROLLPAYMENT";
export const CREATEHRSTAFFLEAVE = "CREATEIPDHRSTAFFLEAVE";
export const GETHRSTAFFLEAVE = "GETHRSTAFFLEAVE";
export const GETALLHRSTAFFLEAVE = "GETALLHRSTAFFLEAVE";
export const DELETEHRSTAFFLEAVE = "DELETEHRSTAFFLEAVE";
export const UPDATEHRSTAFFLEAVE = "UPDATEHRSTAFFLEAVE";
export const CREATEHRSTAFFLEAVEAPPROVE = "CREATEIPDHRSTAFFLEAVEAPPROVE";
export const GETHRSTAFFLEAVEAPPROVE = "GETHRSTAFFLEAVEAPPROVE";
export const GETALLHRSTAFFLEAVEAPPROVE = "GETALLHRSTAFFLEAVEAPPROVE";
export const DELETEHRSTAFFLEAVEAPPROVE = "DELETEHRSTAFFLEAVEAPPROVE";
export const UPDATEHRSTAFFLEAVEAPPROVE = "UPDATEHRSTAFFLEAVEAPPROVE";
export const CREATEPROJECT = "CREATEPROJECT";
export const GETPROJECT = "GETPROJECT";
export const DELETEPROJECT = "DELETEPROJECT";
export const UPDATEPROJECT = "UPDATEPROJECT";
export const GETALLMODULE = "GETALLMODULE";
export const CREATEPROJECTMODULE = "CREATEPROJECTMODULE";
export const GETPROJECTMODULE = "GETPROJECTMODULE";
export const DELETEPROJECTMODULE = "DELETEPROJECTMODULE";
export const UPDATEPROJECTMODULE = "UPDATEPROJECTMODULE";
export const CREATEPROJECTGROUP = "CREATEPROJECTGROUP";
export const GETPROJECTGROUP = "GETPROJECTGROUP";
export const DELETEPROJECTGROUP = "DELETEPROJECTGROUP";
export const UPDATEPROJECTGROUP = "UPDATEPROJECTGROUP";
export const CREATEPROJECTTASK = "CREATEPROJECTTASK";
export const GETPROJECTTASK = "GETPROJECTTASK";
export const GETALLPROJECTTASK = "GETALLPROJECTTASK";
export const DELETEPROJECTTASK = "DELETEPROJECTTASK";
export const UPDATEPROJECTTASK = "UPDATEPROJECTTASK";
export const CREATEPROJECTISSUE = "CREATEPROJECTISSUE";
export const GETPROJECTISSUE = "GETPROJECTISSUE";
export const GETALLPROJECTISSUE = "GETALLPROJECTISSUE";
export const DELETEPROJECTISSUE = "DELETEPROJECTISSUE";
export const UPDATEPROJECTISSUE = "UPDATEPROJECTISSUE";
export const CREATECONSALTATION = "CREATECONSALTATION";
export const GETCONSALTATION = "GETCONSALTATION";
export const UPDATECONSALTATION = "UPDATECONSALTATION";
export const DELETECONSALTATION = "DELETECONSALTATION";

export const CREATEMEETING = "CREATEMEETING";
export const GETMEETING = "GETMEETING";
export const GETALLMEETING = "GETALLMEETING";
export const UPDATEMEETING = "UPDATEMEETING";
export const DELETEMEETING = "DELETEMEETING";

export const CREATEMEETINGSTAFF = "CREATEMEETINGSTAFF";
export const GETMEETINGSTAFF = "GETMEETINGSTAFF";
export const UPDATEMEETINGSTAFF = "UPDATEMEETINGSTAFF";
export const DELETEMEETINGSTAFF = "DELETEMEETINGSTAFF";

export const CREATEPRODUCTGROUP = "CREATEPRODUCTGROUP";
export const GETPRODUCTGROUP = "GETPRODUCTGROUP";
export const DELETEPRODUCTGROUP = "DELETEPRODUCTGROUP";
export const UPDATEPRODUCTGROUP = "UPDATEPRODUCTGROUP";
export const CREATEPRODUCT = "CREATEPRODUCT";
export const GETPRODUCT = "GETPRODUCT";
export const DELETEPRODUCT = "DELETEPRODUCT";
export const UPDATEPRODUCT = "UPDATEPRODUCT";
export const CREATECONTACTDOMAIN = "CREATECONTACTDOMAIN";
export const GETCONTACTDOMAIN = "GETCONTACTDOMAIN";
export const DELETECONTACTDOMAIN = "DELETECONTACTDOMAIN";
export const UPDATECONTACTDOMAIN = "UPDATECONTACTDOMAIN";
export const CREATECONTACT = "CREATECONTACT";
export const GETCONTACT = "GETCONTACT";
export const DELETECONTACT = "DELETECONTACT";
export const UPDATECONTACT = "UPDATECONTACT";
export const CREATEACCOUNTPERSONAL = "CREATEACCOUNTPERSONAL";
export const GETACCOUNTPERSONAL = "GETACCOUNTPERSONAL";
export const DELETEACCOUNTPERSONAL = "DELETEACCOUNTPERSONAL";
export const UPDATEACCOUNTPERSONAL = "UPDATEACCOUNTPERSONAL";

export const CREATELEAD = "CREATELEAD";
export const GETLEAD = "GETLEAD";
export const DELETELEAD = "DELETELEAD";
export const UPDATELEAD = "UPDATELEAD";

export const CREATELEADTASK = "CREATELEADTASK";
export const GETLEADTASK = "GETLEADTASK";
export const DELETELEADTASK = "DELETELEADTASK";
export const UPDATELEADTASK = "UPDATELEADTASK";

export const CREATELEADCASE = "CREATELEADCASE";
export const GETLEADCASE = "GETLEADCASE";
export const DELETELEADCASE = "DELETELEADCASE";
export const UPDATELEADCASE = "UPDATELEADCASE";

export const CREATEBANK = "CREATEBANK";
export const GETBANK = "GETBANK";
export const DELETEBANK = "DELETEBANK";
export const UPDATEBANK = "UPDATEBANK";

export const CREATECARD = "CREATECARD";
export const GETCARD = "GETCARD";
export const DELETECARD = "DELETECARD";
export const UPDATECARD = "UPDATECARD";

export const CREATEORDERS = "CREATEORDERS";
export const GETORDERS = "GETORDERS";
export const DELETEORDERS = "DELETEORDERS";
export const UPDATEORDERS = "UPDATEORDERS";

export const CREATEPRODUCTORDERS = "CREATEPRODUCTORDERS";
export const GETPRODUCTORDERS = "GETPRODUCTORDERS";
export const DELETEPRODUCTORDERS = "DELETEPRODUCTORDERS";
export const UPDATEPRODUCTORDERS = "UPDATEPRODUCTORDERS";

export const CREATEQUOTES = "CREATEQUOTES";
export const GETQUOTES = "GETQUOTES";
export const DELETEQUOTES = "DELETEQUOTES";
export const UPDATEQUOTES = "UPDATEQUOTES";

export const CREATESALESORDERS = "CREATESALESORDERS";
export const GETSALESORDERS = "GETSALESORDERS";
export const DELETESALESORDERS = "DELETESALESORDERS";
export const UPDATESALESORDERS = "UPDATESALESORDERS";

export const CREATETEAM = "CREATETEAM";
export const GETTEAM = "GETTEAM";
export const DELETETEAM = "DELETETEAM";
export const UPDATETEAM = "UPDATETEAM";

export const CREATETEAMMEMBER = "CREATETEAMMEMBER";
export const GETTEAMMEMBER = "GETTEAMMEMBER";
export const DELETETEAMMEMBER = "DELETETEAMMEMBER";
export const UPDATETEAMMEMBER = "UPDATETEAMMEMBER";

export const CREATEFORECAST = "CREATEFORECAST";
export const GETFORECAST = "GETFORECAST";
export const DELETEFORECAST = "DELETEFORECAST";
export const UPDATEFORECAST = "UPDATEFORECAST";

export const CREATEQUOTATION = "CREATEQUOTATION";
export const GETQUOTATION = "GETQUOTATION";
export const DELETEQUOTATION = "DELETEQUOTATION";
export const UPDATEQUOTATION = "UPDATEQUOTATION";

export const CREATEINVOICE = "CREATEINVOICE";
export const GETINVOICE = "GETINVOICE";
export const DELETEINVOICE = "DELETEINVOICE";
export const UPDATEINVOICE = "UPDATEINVOICE";
export const CREATETIMELINETYPE = "CREATETIMELINETYPE";
export const GETTIMELINETYPE = "GETTIMELINETYPE";
export const DELETETIMELINETYPE = "DELETETIMELINETYPE";
export const UPDATETIMELINETYPE = "UPDATETIMELINETYPE";

export const CREATEIPDINSYMPTOMS = "CREATEIPDIPDINSYMPTOMS";
export const GETIPDINSYMPTOMS = "GETIPDINSYMPTOMS";
export const GETALLIPDINSYMPTOMS = "GETALLIPDINSYMPTOMS";
export const DELETEIPDINSYMPTOMS = "DELETEIPDINSYMPTOMS";
export const UPDATEIPDINSYMPTOMS = "UPDATEIPDINSYMPTOMS";
export const CREATEIPDINCOBORBIDITY = "CREATEIPDIPDINCOBORBIDITY";
export const GETIPDINCOBORBIDITY = "GETIPDINCOBORBIDITY";
export const GETALLIPDINCOBORBIDITY = "GETALLIPDINCOBORBIDITY";
export const DELETEIPDINCOBORBIDITY = "DELETEIPDINCOBORBIDITY";
export const UPDATEIPDINCOBORBIDITY = "UPDATEIPDINCOBORBIDITY";
export const CREATEIPDININVESTIGATION = "CREATEIPDIPDININVESTIGATION";
export const GETIPDININVESTIGATION = "GETIPDININVESTIGATION";
export const GETALLIPDININVESTIGATION = "GETALLIPDININVESTIGATION";
export const DELETEIPDININVESTIGATION = "DELETEIPDININVESTIGATION";
export const UPDATEIPDININVESTIGATION = "UPDATEIPDININVESTIGATION";

export const CREATEPATIENTCARDTEMPLATE = "CREATEPATIENTCARDTEMPLATE";
export const GETPATIENTCARDTEMPLATE = "GETPATIENTCARDTEMPLATE";
export const DELETEPATIENTCARDTEMPLATE = "DELETEPATIENTCARDTEMPLATE";
export const UPDATEPATIENTCARDTEMPLATE = "UPDATEPATIENTCARDTEMPLATE";
export const CREATEIPDNURSENOTE = "CREATEIPDIPDNURSENOTE";
export const GETIPDNURSENOTE = "GETIPDNURSENOTE";
export const GETALLIPDNURSENOTE = "GETALLIPDNURSENOTE";
export const DELETEIPDNURSENOTE = "DELETEIPDNURSENOTE";
export const UPDATEIPDNURSENOTE = "UPDATEIPDNURSENOTE";
export const CREATEIPDMEDICATION = "CREATEIPDIPDMEDICATION";
export const GETIPDMEDICATION = "GETIPDMEDICATION";
export const GETALLIPDMEDICATION = "GETALLIPDMEDICATION";
export const DELETEIPDMEDICATION = "DELETEIPDMEDICATION";
export const UPDATEIPDMEDICATION = "UPDATEIPDMEDICATION";
export const CREATEIPDDISCHARGE = "CREATEIPDIPDDISCHARGE";
export const GETIPDDISCHARGE = "GETIPDDISCHARGE";
export const GETALLIPDDISCHARGE = "GETALLIPDDISCHARGE";
export const DELETEIPDDISCHARGE = "DELETEIPDDISCHARGE";
export const UPDATEIPDDISCHARGE = "UPDATEIPDDISCHARGE";
export const CREATEIPDPAYMENT = "CREATEIPDIPDPAYMENT";
export const GETIPDPAYMENT = "GETIPDPAYMENT";
export const GETALLIPDPAYMENT = "GETALLIPDPAYMENT";
export const DELETEIPDPAYMENT = "DELETEIPDPAYMENT";
export const UPDATEIPDPAYMENT = "UPDATEIPDPAYMENT";
export const CREATEIPDBEDHISTORY = "CREATEIPDIPDBEDHISTORY";
export const GETIPDBEDHISTORY = "GETIPDBEDHISTORY";
export const GETALLIPDBEDHISTORY = "GETALLIPDBEDHISTORY";
export const DELETEIPDBEDHISTORY = "DELETEIPDBEDHISTORY";
export const UPDATEIPDBEDHISTORY = "UPDATEIPDBEDHISTORY";
export const CREATEIPDCONSULTANTREGISTER = "CREATEIPDIPDCONSULTANTREGISTER";
export const GETIPDCONSULTANTREGISTER = "GETIPDCONSULTANTREGISTER";
export const GETALLIPDCONSULTANTREGISTER = "GETALLIPDCONSULTANTREGISTER";
export const DELETEIPDCONSULTANTREGISTER = "DELETEIPDCONSULTANTREGISTER";
export const UPDATEIPDCONSULTANTREGISTER = "UPDATEIPDCONSULTANTREGISTER";
export const CREATESTAFFCARDTEMPLATE = "CREATESTAFFCARDTEMPLATE";
export const GETSTAFFCARDTEMPLATE = "GETSTAFFCARDTEMPLATE";
export const DELETESTAFFCARDTEMPLATE = "DELETESTAFFCARDTEMPLATE";
export const UPDATESTAFFCARDTEMPLATE = "UPDATESTAFFCARDTEMPLATE";
export const CREATEIPDOPERATION = "CREATEIPDIPDOPERATION";
export const GETIPDOPERATION = "GETIPDOPERATION";
export const GETALLIPDOPERATION = "GETALLIPDOPERATION";
export const DELETEIPDOPERATION = "DELETEIPDOPERATION";
export const UPDATEIPDOPERATION = "UPDATEIPDOPERATION";
export const CREATECERTIFICATETEMPLATE = "CREATECERTIFICATETEMPLATE";
export const GETCERTIFICATETEMPLATE = "GETCERTIFICATETEMPLATE";
export const DELETECERTIFICATETEMPLATE = "DELETECERTIFICATETEMPLATE";
export const UPDATECERTIFICATETEMPLATE = "UPDATECERTIFICATETEMPLATE";
export const CREATEIPDPRESCRIPTIONDATA = "CREATEIPDIPDPRESCRIPTION";
export const GETIPDPRESCRIPTIONDATA = "GETIPDPRESCRIPTIONDATA";
export const GETALLIPDPRESCRIPTIONDATA = "GETALLIPDPRESCRIPTIONDATA";
export const DELETEIPDPRESCRIPTIONDATA = "DELETEIPDPRESCRIPTIONDATA";
export const UPDATEIPDPRESCRIPTIONDATA = "UPDATEIPDPRESCRIPTIONDATA";
export const CREATEIPDPRESCRIPTIONMEDICINE = "CREATEIPDIPDPRESCRIPTIONMEDICINE";
export const GETIPDPRESCRIPTIONMEDICINE = "GETIPDPRESCRIPTIONMEDICINE";
export const GETALLIPDPRESCRIPTIONMEDICINE = "GETALLIPDPRESCRIPTIONMEDICINE";
export const DELETEIPDPRESCRIPTIONMEDICINE = "DELETEIPDPRESCRIPTIONMEDICINE";
export const UPDATEIPDPRESCRIPTIONMEDICINE = "UPDATEIPDPRESCRIPTIONMEDICINE";

export const CREATEHOLIDAYDATE = "CREATEHOLIDAYDATE";
export const GETHOLIDAYDATE = "GETHOLIDAYDATE";
export const DELETEHOLIDAYDATE = "DELETEHOLIDAYDATE";
export const UPDATEHOLIDAYDATE = "UPDATEHOLIDAYDATE";

export const CREATEACTIVITY = "CREATEACTIVITY";
export const GETACTIVITY = "GETACTIVITY";
export const DELETEACTIVITY = "DELETEACTIVITY";
export const UPDATEACTIVITY = "UPDATEACTIVITY";

export const CREATEVACATION = "CREATEVACATION";
export const GETVACATION = "GETVACATION";
export const DELETEVACATION = "DELETEVACATION";
export const UPDATEVACATION = "UPDATEVACATION";
export const CREATEIPDOBSTETRIC = "CREATEIPDIPDOBSTETRIC";
export const GETIPDOBSTETRIC = "GETIPDOBSTETRIC";
export const GETALLIPDOBSTETRIC = "GETALLIPDOBSTETRIC";
export const DELETEIPDOBSTETRIC = "DELETEIPDOBSTETRIC";
export const UPDATEIPDOBSTETRIC = "UPDATEIPDOBSTETRIC";

export const CREATETASK = "CREATETASK";
export const GETTASK = "GETTASK";
export const DELETETASK = "DELETETASK";
export const UPDATETASK = "UPDATETASK";

export const CREATENOTE = "CREATENOTE";
export const GETNOTE = "GETNOTE";
export const DELETENOTE = "DELETENOTE";
export const UPDATENOTE = "UPDATENOTE";

export const CREATEIPDPOSTNATAL = "CREATEIPDIPDPOSTNATAL";
export const GETIPDPOSTNATAL = "GETIPDPOSTNATAL";
export const GETALLIPDPOSTNATAL = "GETALLIPDPOSTNATAL";
export const DELETEIPDPOSTNATAL = "DELETEIPDPOSTNATAL";
export const UPDATEIPDPOSTNATAL = "UPDATEIPDPOSTNATAL";
export const CREATEIPDANTENATAL = "CREATEIPDIPDANTENATAL";
export const GETIPDANTENATAL = "GETIPDANTENATAL";
export const GETALLIPDANTENATAL = "GETALLIPDANTENATAL";
export const DELETEIPDANTENATAL = "DELETEIPDANTENATAL";
export const UPDATEIPDANTENATAL = "UPDATEIPDANTENATAL";
export const CREATEIPDVITAL = "CREATEIPDIPDVITAL";
export const GETIPDVITAL = "GETIPDVITAL";
export const GETALLIPDVITAL = "GETALLIPDVITAL";
export const DELETEIPDVITAL = "DELETEIPDVITAL";
export const UPDATEIPDVITAL = "UPDATEIPDVITAL";
export const CREATECONSULTANTSYMPTOMS = "CREATEIPDCONSULTANTSYMPTOMS";
export const GETCONSULTANTSYMPTOMS = "GETCONSULTANTSYMPTOMS";
export const GETALLCONSULTANTSYMPTOMS = "GETALLCONSULTANTSYMPTOMS";
export const DELETECONSULTANTSYMPTOMS = "DELETECONSULTANTSYMPTOMS";
export const UPDATECONSULTANTSYMPTOMS = "UPDATECONSULTANTSYMPTOMS";
export const CREATEIPDTIMELINEHISTORY = "CREATEIPDIPDTIMELINEHISTORY";
export const GETIPDTIMELINEHISTORY = "GETIPDTIMELINEHISTORY";
export const GETALLIPDTIMELINEHISTORY = "GETALLIPDTIMELINEHISTORY";
export const DELETEIPDTIMELINEHISTORY = "DELETEIPDTIMELINEHISTORY";
export const UPDATEIPDTIMELINEHISTORY = "UPDATEIPDTIMELINEHISTORY";
export const CREATEAYURVEDICTYPE = "CREATEAYURVEDICTYPE";
export const GETAYURVEDICTYPE = "GETAYURVEDICTYPE";
export const DELETEAYURVEDICTYPE = "DELETEAYURVEDICTYPE";
export const UPDATEAYURVEDICTYPE = "UPDATEAYURVEDICTYPE";
export const CREATEAYURVEDICHEAD = "CREATEAYURVEDICHEAD";
export const GETAYURVEDICHEAD = "GETAYURVEDICHEAD";
export const DELETEAYURVEDICHEAD = "DELETEAYURVEDICHEAD";
export const UPDATEAYURVEDICHEAD = "UPDATEAYURVEDICHEAD";
export const CREATEEXERCISECHARTTYPE = "CREATEEXERCISECHARTTYPE";
export const GETEXERCISECHARTTYPE = "GETEXERCISECHARTTYPE";
export const DELETEEXERCISECHARTTYPE = "DELETEEXERCISECHARTTYPE";
export const UPDATEEXERCISECHARTTYPE = "UPDATEEXERCISECHARTTYPE";
export const CREATEEXERCISECHARTHEAD = "CREATEEXERCISECHARTHEAD";
export const GETEXERCISECHARTHEAD = "GETEXERCISECHARTHEAD";
export const DELETEEXERCISECHARTHEAD = "DELETEEXERCISECHARTHEAD";
export const UPDATEEXERCISECHARTHEAD = "UPDATEEXERCISECHARTHEAD";
export const CREATEIMMUNIZATIONNAME = "CREATEIMMUNIZATIONNAME";
export const GETIMMUNIZATIONNAME = "GETIMMUNIZATIONNAME";
export const DELETEIMMUNIZATIONNAME = "DELETEIMMUNIZATIONNAME";
export const UPDATEIMMUNIZATIONNAME = "UPDATEIMMUNIZATIONNAME";
export const CREATEIMMUNIZATIONAGEGROUP = "CREATEIMMUNIZATIONAGEGROUP";
export const GETIMMUNIZATIONAGEGROUP = "GETIMMUNIZATIONAGEGROUP";
export const DELETEIMMUNIZATIONAGEGROUP = "DELETEIMMUNIZATIONAGEGROUP";
export const UPDATEIMMUNIZATIONAGEGROUP = "UPDATEIMMUNIZATIONAGEGROUP";
export const CREATEDUTYROSTERSHIFT = "CREATEDUTYROSTERSHIFT";
export const GETDUTYROSTERSHIFT = "GETDUTYROSTERSHIFT";
export const DELETEDUTYROSTERSHIFT = "DELETEDUTYROSTERSHIFT";
export const UPDATEDUTYROSTERSHIFT = "UPDATEDUTYROSTERSHIFT";
export const CREATEDUTYROSTER = "CREATEDUTYROSTER";
export const GETDUTYROSTER = "GETDUTYROSTER";
export const DELETEDUTYROSTER = "DELETEDUTYROSTER";
export const UPDATEDUTYROSTER = "UPDATEDUTYROSTER";
export const CREATEDUTYROSTERASSIGN = "CREATEDUTYROSTERASSIGN";
export const GETDUTYROSTERASSIGN = "GETDUTYROSTERASSIGN";
export const DELETEDUTYROSTERASSIGN = "DELETEDUTYROSTERASSIGN";
export const UPDATEDUTYROSTERASSIGN = "UPDATEDUTYROSTERASSIGN";
export const CREATEOPDVACCINE = "CREATEOPDVACCINE";
export const GETOPDVACCINE = "GETOPDVACCINE";
export const DELETEOPDVACCINE = "DELETEOPDVACCINE";
export const UPDATEOPDVACCINE = "UPDATEOPDVACCINE";
export const CREATEGENERALPAINASSESSMENTSTATUS =
  "CREATEGENERALPAINASSESSMENTSTATUS";
export const GETGENERALPAINASSESSMENTSTATUS = "GETGENERALPAINASSESSMENTSTATUS";
export const DELETEGENERALPAINASSESSMENTSTATUS =
  "DELETEGENERALPAINASSESSMENTSTATUS";
export const UPDATEGENERALPAINASSESSMENTSTATUS =
  "UPDATEGENERALPAINASSESSMENTSTATUS";
export const CREATEGENERALPAINASSESSMENTSEVERITY =
  "CREATEGENERALPAINASSESSMENTSEVERITY";
export const GETGENERALPAINASSESSMENTSEVERITY =
  "GETGENERALPAINASSESSMENTSEVERITY";
export const DELETEGENERALPAINASSESSMENTSEVERITY =
  "DELETEGENERALPAINASSESSMENTSEVERITY";
export const UPDATEGENERALPAINASSESSMENTSEVERITY =
  "UPDATEGENERALPAINASSESSMENTSEVERITY";
export const CREATEGENERALPAINASSESSMENTPAINNATURE =
  "CREATEGENERALPAINASSESSMENTPAINNATURE";
export const GETGENERALPAINASSESSMENTPAINNATURE =
  "GETGENERALPAINASSESSMENTPAINNATURE";
export const DELETEGENERALPAINASSESSMENTPAINNATURE =
  "DELETEGENERALPAINASSESSMENTPAINNATURE";
export const UPDATEGENERALPAINASSESSMENTPAINNATURE =
  "UPDATEGENERALPAINASSESSMENTPAINNATURE";
export const CREATEGENERALPAINASSESSMENTPAINONSET =
  "CREATEGENERALPAINASSESSMENTPAINONSET";
export const GETGENERALPAINASSESSMENTPAINONSET =
  "GETGENERALPAINASSESSMENTPAINONSET";
export const DELETEGENERALPAINASSESSMENTPAINONSET =
  "DELETEGENERALPAINASSESSMENTPAINONSET";
export const UPDATEGENERALPAINASSESSMENTPAINONSET =
  "UPDATEGENERALPAINASSESSMENTPAINONSET";
export const CREATEGENERALPAINASSESSMENTPAINVARIATION =
  "CREATEGENERALPAINASSESSMENTPAINVARIATION";
export const GETGENERALPAINASSESSMENTPAINVARIATION =
  "GETGENERALPAINASSESSMENTPAINVARIATION";
export const DELETEGENERALPAINASSESSMENTPAINVARIATION =
  "DELETEGENERALPAINASSESSMENTPAINVARIATION";
export const UPDATEGENERALPAINASSESSMENTPAINVARIATION =
  "UPDATEGENERALPAINASSESSMENTPAINVARIATION";

export const GETGENERALCOMPLAINTCHILDILLNESS =
  "GETGENERALCOMPLAINTCHILDILLNESS";
export const CREATEGENERALCOMPLAINTCHILDILLNESS =
  "CREATEGENERALCOMPLAINTCHILDILLNESS";
export const DELETEGENERALCOMPLAINTCHILDILLNESS =
  "DELETEGENERALCOMPLAINTCHILDILLNESS";
export const UPDATEGENERALCOMPLAINTCHILDILLNESS =
  "UPDATEGENERALCOMPLAINTCHILDILLNESS";
export const GETGENERALCOMPLAINTADULTILLNESS =
  "GETGENERALCOMPLAINTADULTILLNESS";
export const CREATEGENERALCOMPLAINTADULTILLNESS =
  "CREATEGENERALCOMPLAINTADULTILLNESS";
export const DELETEGENERALCOMPLAINTADULTILLNESS =
  "DELETEGENERALCOMPLAINTADULTILLNESS";
export const UPDATEGENERALCOMPLAINTADULTILLNESS =
  "UPDATEGENERALCOMPLAINTADULTILLNESS";
export const GETGENERALCOMPLAINTHEALTHMAINT = "GETGENERALCOMPLAINTHEALTHMAINT";
export const CREATEGENERALCOMPLAINTHEALTHMAINT =
  "CREATEGENERALCOMPLAINTHEALTHMAINT";
export const DELETEGENERALCOMPLAINTHEALTHMAINT =
  "DELETEGENERALCOMPLAINTHEALTHMAINT";
export const UPDATEGENERALCOMPLAINTHEALTHMAINT =
  "UPDATEGENERALCOMPLAINTHEALTHMAINT";
export const GETGENERALCOMPLAINTRELATION = "GETGENERALCOMPLAINTRELATION";
export const CREATEGENERALCOMPLAINTRELATION = "CREATEGENERALCOMPLAINTRELATION";
export const DELETEGENERALCOMPLAINTRELATION = "DELETEGENERALCOMPLAINTRELATION";
export const UPDATEGENERALCOMPLAINTRELATION = "UPDATEGENERALCOMPLAINTRELATION";
export const GETGENERALCOMPLAINTAPPETITE = "GETGENERALCOMPLAINTAPPETITE";
export const CREATEGENERALCOMPLAINTAPPETITE = "CREATEGENERALCOMPLAINTAPPETITE";
export const UPDATEGENERALCOMPLAINTAPPETITE = "UPDATEGENERALCOMPLAINTAPPETITE";
export const DELETEGENERALCOMPLAINTAPPETITE = "DELETEGENERALCOMPLAINTAPPETITE";
export const GETGENERALCOMPLAINTDIGESTIVETRACT =
  "GETGENERALCOMPLAINTDIGESTIVETRACT";
export const CREATEGENERALCOMPLAINTDIGESTIVETRACT =
  "CREATEGENERALCOMPLAINTDIGESTIVETRACT";
export const UPDATEGENERALCOMPLAINTDIGESTIVETRACT =
  "UPDATEGENERALCOMPLAINTDIGESTIVETRACT";
export const DELETEGENERALCOMPLAINTDIGESTIVETRACT =
  "DELETEGENERALCOMPLAINTDIGESTIVETRACT";
export const GETGENERALCOMPLAINTBOWEL = "GETGENERALCOMPLAINTBOWEL";
export const CREATEGENERALCOMPLAINTBOWEL = "CREATEGENERALCOMPLAINTBOWEL";
export const UPDATEGENERALCOMPLAINTBOWEL = "UPDATEGENERALCOMPLAINTBOWEL";
export const DELETEGENERALCOMPLAINTBOWEL = "DELETEGENERALCOMPLAINTBOWEL";
export const GETGENERALCOMPLAINTSLEEP = "GETGENERALCOMPLAINTSLEEP";
export const CREATEGENERALCOMPLAINTSLEEP = "CREATEGENERALCOMPLAINTSLEEP";
export const UPDATEGENERALCOMPLAINTSLEEP = "UPDATEGENERALCOMPLAINTSLEEP";
export const DELETEGENERALCOMPLAINTSLEEP = "DELETEGENERALCOMPLAINTSLEEP";
export const GETGENERALCOMPLAINTADDICTIONS = "GETGENERALCOMPLAINTADDICTIONS";
export const CREATEGENERALCOMPLAINTADDICTIONS =
  "CREATEGENERALCOMPLAINTADDICTIONS";
export const UPDATEGENERALCOMPLAINTADDICTIONS =
  "UPDATEGENERALCOMPLAINTADDICTIONS";
export const DELETEGENERALCOMPLAINTADDICTIONS =
  "DELETEGENERALCOMPLAINTADDICTIONS";
export const GETGENERALCOMPLAINTHIGHRISK = "GETGENERALCOMPLAINTHIGHRISK";
export const CREATEGENERALCOMPLAINTHIGHRISK = "CREATEGENERALCOMPLAINTHIGHRISK";
export const UPDATEGENERALCOMPLAINTHIGHRISK = "UPDATEGENERALCOMPLAINTHIGHRISK";
export const DELETEGENERALCOMPLAINTHIGHRISK = "DELETEGENERALCOMPLAINTHIGHRISK";
export const GETGENERALCOMPLAINTWORKPOSITION =
  "GETGENERALCOMPLAINTWORKPOSITION";
export const CREATEGENERALCOMPLAINTWORKPOSITION =
  "CREATEGENERALCOMPLAINTWORKPOSITION";
export const UPDATEGENERALCOMPLAINTWORKPOSITION =
  "UPDATEGENERALCOMPLAINTWORKPOSITION";
export const DELETEGENERALCOMPLAINTWORKPOSITION =
  "DELETEGENERALCOMPLAINTWORKPOSITION";
export const GETGENERALCOMPLAINTWORKNATURE = "GETGENERALCOMPLAINTWORKNATURE";
export const CREATEGENERALCOMPLAINTWORKNATURE =
  "CREATEGENERALCOMPLAINTWORKNATURE";
export const UPDATEGENERALCOMPLAINTWORKNATURE =
  "UPDATEGENERALCOMPLAINTWORKNATURE";
export const DELETEGENERALCOMPLAINTWORKNATURE =
  "DELETEGENERALCOMPLAINTWORKNATURE";
export const GETGENERALCOMPLAINTALLOPATHICMEDI =
  "GETGENERALCOMPLAINTALLOPATHICMEDI";
export const CREATEGENERALCOMPLAINTALLOPATHICMEDI =
  "CREATEGENERALCOMPLAINTALLOPATHICMEDI";
export const UPDATEGENERALCOMPLAINTALLOPATHICMEDI =
  "UPDATEGENERALCOMPLAINTALLOPATHICMEDI";
export const DELETEGENERALCOMPLAINTALLOPATHICMEDI =
  "DELETEGENERALCOMPLAINTALLOPATHICMEDI";
export const GETGENERALCOMPLAINTAYURVEDAMEDI =
  "GETGENERALCOMPLAINTAYURVEDAMEDI";
export const CREATEGENERALCOMPLAINTAYURVEDAMEDI =
  "CREATEGENERALCOMPLAINTAYURVEDAMEDI";
export const UPDATEGENERALCOMPLAINTAYURVEDAMEDI =
  "UPDATEGENERALCOMPLAINTAYURVEDAMEDI";
export const DELETEGENERALCOMPLAINTAYURVEDAMEDI =
  "DELETEGENERALCOMPLAINTAYURVEDAMEDI";
export const GETGENERALCOMPLAINTHOMEOPATHICMEDI =
  "GETGENERALCOMPLAINTHOMEOPATHICMEDI";
export const CREATEGENERALCOMPLAINTHOMEOPATHICMEDI =
  "CREATEGENERALCOMPLAINTHOMEOPATHICMEDI";
export const UPDATEGENERALCOMPLAINTHOMEOPATHICMEDI =
  "UPDATEGENERALCOMPLAINTHOMEOPATHICMEDI";
export const DELETEGENERALCOMPLAINTHOMEOPATHICMEDI =
  "DELETEGENERALCOMPLAINTHOMEOPATHICMEDI";
export const GETGENERALCOMPLAINTOTHERMEDI = "GETGENERALCOMPLAINTOTHERMEDI";
export const CREATEGENERALCOMPLAINTOTHERMEDI =
  "CREATEGENERALCOMPLAINTOTHERMEDI";
export const UPDATEGENERALCOMPLAINTOTHERMEDI =
  "UPDATEGENERALCOMPLAINTOTHERMEDI";
export const DELETEGENERALCOMPLAINTOTHERMEDI =
  "DELETEGENERALCOMPLAINTOTHERMEDI";

export const GETGENERALCOMPLAINTANXIETY = "GETGENERALCOMPLAINTANXIETY";
export const CREATEGENERALCOMPLAINTANXIETY = "CREATEGENERALCOMPLAINTANXIETY";
export const UPDATEGENERALCOMPLAINTANXIETY = "UPDATEGENERALCOMPLAINTANXIETY";
export const DELETEGENERALCOMPLAINTANXIETY = "DELETEGENERALCOMPLAINTANXIETY";
export const GETGENERALCOMPLAINTDEPRESSION = "GETGENERALCOMPLAINTDEPRESSION";
export const CREATEGENERALCOMPLAINTDEPRESSION =
  "CREATEGENERALCOMPLAINTDEPRESSION";
export const UPDATEGENERALCOMPLAINTDEPRESSION =
  "UPDATEGENERALCOMPLAINTDEPRESSION";
export const DELETEGENERALCOMPLAINTDEPRESSION =
  "DELETEGENERALCOMPLAINTDEPRESSION";
export const GETGENERALCOMPLAINTIRRITABILITY =
  "GETGENERALCOMPLAINTIRRITABILITY";
export const CREATEGENERALCOMPLAINTIRRITABILITY =
  "CREATEGENERALCOMPLAINTIRRITABILITY";
export const UPDATEGENERALCOMPLAINTIRRITABILITY =
  "UPDATEGENERALCOMPLAINTIRRITABILITY";
export const DELETEGENERALCOMPLAINTIRRITABILITY =
  "DELETEGENERALCOMPLAINTIRRITABILITY";
export const GETGENERALCOMPLAINTEUPHORIA = "GETGENERALCOMPLAINTEUPHORIA";
export const CREATEGENERALCOMPLAINTEUPHORIA = "CREATEGENERALCOMPLAINTEUPHORIA";
export const UPDATEGENERALCOMPLAINTEUPHORIA = "UPDATEGENERALCOMPLAINTEUPHORIA";
export const DELETEGENERALCOMPLAINTEUPHORIA = "DELETEGENERALCOMPLAINTEUPHORIA";
export const GETGENERALCOMPLAINTOBSESSION = "GETGENERALCOMPLAINTOBSESSION";
export const CREATEGENERALCOMPLAINTOBSESSION =
  "CREATEGENERALCOMPLAINTOBSESSION";
export const UPDATEGENERALCOMPLAINTOBSESSION =
  "UPDATEGENERALCOMPLAINTOBSESSION";
export const DELETEGENERALCOMPLAINTOBSESSION =
  "DELETEGENERALCOMPLAINTOBSESSION";
export const GETGENERALCOMPLAINTNEUROSIS = "GETGENERALCOMPLAINTNEUROSIS";
export const CREATEGENERALCOMPLAINTNEUROSIS = "CREATEGENERALCOMPLAINTNEUROSIS";
export const UPDATEGENERALCOMPLAINTNEUROSIS = "UPDATEGENERALCOMPLAINTNEUROSIS";
export const DELETEGENERALCOMPLAINTNEUROSIS = "DELETEGENERALCOMPLAINTNEUROSIS";
export const GETGENERALCOMPLAINTDEPERSONALIZATION =
  "GETGENERALCOMPLAINTDEPERSONALIZATION";
export const CREATEGENERALCOMPLAINTDEPERSONALIZATION =
  "CREATEGENERALCOMPLAINTDEPERSONALIZATION";
export const UPDATEGENERALCOMPLAINTDEPERSONALIZATION =
  "UPDATEGENERALCOMPLAINTDEPERSONALIZATION";
export const DELETEGENERALCOMPLAINTDEPERSONALIZATION =
  "DELETEGENERALCOMPLAINTDEPERSONALIZATION";
export const GETGENERALCOMPLAINTMENSTRUALCYCLE =
  "GETGENERALCOMPLAINTMENSTRUALCYCLE";
export const CREATEGENERALCOMPLAINTMENSTRUALCYCLE =
  "CREATEGENERALCOMPLAINTMENSTRUALCYCLE";
export const UPDATEGENERALCOMPLAINTMENSTRUALCYCLE =
  "UPDATEGENERALCOMPLAINTMENSTRUALCYCLE";
export const DELETEGENERALCOMPLAINTMENSTRUALCYCLE =
  "DELETEGENERALCOMPLAINTMENSTRUALCYCLE";
export const GETGENERALCOMPLAINTNATUREOFDELIVERY =
  "GETGENERALCOMPLAINTNATUREOFDELIVERY";
export const CREATEGENERALCOMPLAINTNATUREOFDELIVERY =
  "CREATEGENERALCOMPLAINTNATUREOFDELIVERY";
export const UPDATEGENERALCOMPLAINTNATUREOFDELIVERY =
  "UPDATEGENERALCOMPLAINTNATUREOFDELIVERY";
export const DELETEGENERALCOMPLAINTNATUREOFDELIVERY =
  "DELETEGENERALCOMPLAINTNATUREOFDELIVERY";

export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS =
  "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";

export const CREATEAYURVEDICPAINASSESSMENTSEVERITY =
  "CREATEAYURVEDICPAINASSESSMENTSEVERITY";
export const GETAYURVEDICPAINASSESSMENTSEVERITY =
  "GETAYURVEDICPAINASSESSMENTSEVERITY";
export const DELETEAYURVEDICPAINASSESSMENTSEVERITY =
  "DELETEAYURVEDICPAINASSESSMENTSEVERITY";
export const UPDATEAYURVEDICPAINASSESSMENTSEVERITY =
  "UPDATEAYURVEDICPAINASSESSMENTSEVERITY";
export const CREATEAYURVEDICPAINASSESSMENTPAINNATURE =
  "CREATEAYURVEDICPAINASSESSMENTPAINNATURE";
export const GETAYURVEDICPAINASSESSMENTPAINNATURE =
  "GETAYURVEDICPAINASSESSMENTPAINNATURE";
export const DELETEAYURVEDICPAINASSESSMENTPAINNATURE =
  "DELETEAYURVEDICPAINASSESSMENTPAINNATURE";
export const UPDATEAYURVEDICPAINASSESSMENTPAINNATURE =
  "UPDATEAYURVEDICPAINASSESSMENTPAINNATURE";
export const CREATEAYURVEDICPAINASSESSMENTPAINONSET =
  "CREATEAYURVEDICPAINASSESSMENTPAINONSET";
export const GETAYURVEDICPAINASSESSMENTPAINONSET =
  "GETAYURVEDICPAINASSESSMENTPAINONSET";
export const DELETEAYURVEDICPAINASSESSMENTPAINONSET =
  "DELETEAYURVEDICPAINASSESSMENTPAINONSET";
export const UPDATEAYURVEDICPAINASSESSMENTPAINONSET =
  "UPDATEAYURVEDICPAINASSESSMENTPAINONSET";
export const CREATEAYURVEDICPAINASSESSMENTPAINVARIATION =
  "CREATEAYURVEDICPAINASSESSMENTPAINVARIATION";
export const GETAYURVEDICPAINASSESSMENTPAINVARIATION =
  "GETAYURVEDICPAINASSESSMENTPAINVARIATION";
export const DELETEAYURVEDICPAINASSESSMENTPAINVARIATION =
  "DELETEAYURVEDICPAINASSESSMENTPAINVARIATION";
export const UPDATEAYURVEDICPAINASSESSMENTPAINVARIATION =
  "UPDATEAYURVEDICPAINASSESSMENTPAINVARIATION";

export const GETSETUPAYURVEDICHEALTHMAINT = "GETSETUPAYURVEDICHEALTHMAINT";
export const CREATESETUPAYURVEDICHEALTHMAINT =
  "CREATESETUPAYURVEDICHEALTHMAINT";
export const UPDATESETUPAYURVEDICHEALTHMAINT =
  "UPDATESETUPAYURVEDICHEALTHMAINT";
export const DELETESETUPAYURVEDICHEALTHMAINT =
  "DELETESETUPAYURVEDICHEALTHMAINT";

export const GETSETUPAYURVEDICRELATIONLST = "GETSETUPAYURVEDICRELATIONLST";
export const CREATESETUPAYURVEDICRELATIONLST =
  "CREATESETUPAYURVEDICRELATIONLST";
export const UPDATESETUPAYURVEDICRELATIONLST =
  "UPDATESETUPAYURVEDICRELATIONLST";
export const DELETESETUPAYURVEDICRELATIONLST =
  "DELETESETUPAYURVEDICRELATIONLST";

export const GETSETUPAYURVEDICPERSONALHISTORY =
  "GETSETUPAYURVEDICPERSONALHISTORY";
export const CREATESETUPAYURVEDICPERSONALHISTORY =
  "CREATESETUPAYURVEDICPERSONALHISTORY";
export const UPDATESETUPAYURVEDICPERSONALHISTORY =
  "UPDATESETUPAYURVEDICPERSONALHISTORY";
export const DELETESETUPAYURVEDICPERSONALHISTORY =
  "DELETESETUPAYURVEDICPERSONALHISTORY";

export const GETSETUPAYURVEDICDIGESTIVETRACT =
  "GETSETUPAYURVEDICDIGESTIVETRACT";
export const CREATESETUPAYURVEDICDIGESTIVETRACT =
  "CREATESETUPAYURVEDICDIGESTIVETRACT";
export const UPDATESETUPAYURVEDICDIGESTIVETRACT =
  "UPDATESETUPAYURVEDICDIGESTIVETRACT";
export const DELETESETUPAYURVEDICDIGESTIVETRACT =
  "DELETESETUPAYURVEDICDIGESTIVETRACT";

export const GETSETUPAYURVEDICBOWEL = "GETSETUPAYURVEDICBOWEL";
export const CREATESETUPAYURVEDICBOWEL = "CREATESETUPAYURVEDICBOWEL";
export const UPDATESETUPAYURVEDICBOWEL = "UPDATESETUPAYURVEDICBOWEL";
export const DELETESETUPAYURVEDICBOWEL = "DELETESETUPAYURVEDICBOWEL";

export const GETSETUPAYURVEDICSLEEP = "GETSETUPAYURVEDICSLEEP";
export const CREATESETUPAYURVEDICSLEEP = "CREATESETUPAYURVEDICSLEEP";
export const UPDATESETUPAYURVEDICSLEEP = "UPDATESETUPAYURVEDICSLEEP";
export const DELETESETUPAYURVEDICSLEEP = "DELETESETUPAYURVEDICSLEEP";

export const GETSETUPAYURVEDICADDICTIONS = "GETSETUPAYURVEDICADDICTIONS";
export const CREATESETUPAYURVEDICADDICTIONS = "CREATESETUPAYURVEDICADDICTIONS";
export const UPDATESETUPAYURVEDICADDICTIONS = "UPDATESETUPAYURVEDICADDICTIONS";
export const DELETESETUPAYURVEDICADDICTIONS = "DELETESETUPAYURVEDICADDICTIONS";

export const GETSETUPAYURVEDICHIGHRISK = "GETSETUPAYURVEDICHIGHRISK";
export const CREATESETUPAYURVEDICHIGHRISK = "CREATESETUPAYURVEDICHIGHRISK";
export const UPDATESETUPAYURVEDICHIGHRISK = "UPDATESETUPAYURVEDICHIGHRISK";
export const DELETESETUPAYURVEDICHIGHRISK = "DELETESETUPAYURVEDICHIGHRISK";

export const GETSETUPAYURVEDICPOSITIONOFWORK =
  "GETSETUPAYURVEDICPOSITIONOFWORK";
export const CREATESETUPAYURVEDICPOSITIONOFWORK =
  "CREATESETUPAYURVEDICPOSITIONOFWORK";
export const UPDATESETUPAYURVEDICPOSITIONOFWORK =
  "UPDATESETUPAYURVEDICPOSITIONOFWORK";
export const DELETESETUPAYURVEDICPOSITIONOFWORK =
  "DELETESETUPAYURVEDICPOSITIONOFWORK";

export const GETSETUPAYURVEDICNATUREOFWORK = "GETSETUPAYURVEDICNATUREOFWORK";
export const CREATESETUPAYURVEDICNATUREOFWORK =
  "CREATESETUPAYURVEDICNATUREOFWORK";
export const UPDATESETUPAYURVEDICNATUREOFWORK =
  "UPDATESETUPAYURVEDICNATUREOFWORK";
export const DELETESETUPAYURVEDICNATUREOFWORK =
  "DELETESETUPAYURVEDICNATUREOFWORK";

export const GETSETUPAYURVEDICDEPRESSION = "GETSETUPAYURVEDICDEPRESSION";
export const CREATESETUPAYURVEDICDEPRESSION = "CREATESETUPAYURVEDICDEPRESSION";
export const UPDATESETUPAYURVEDICDEPRESSION = "UPDATESETUPAYURVEDICDEPRESSION";
export const DELETESETUPAYURVEDICDEPRESSION = "DELETESETUPAYURVEDICDEPRESSION";

export const GETSETUPAYURVEDICIRRITABILITY = "GETSETUPAYURVEDICIRRITABILITY";
export const CREATESETUPAYURVEDICIRRITABILITY =
  "CREATESETUPAYURVEDICIRRITABILITY";
export const UPDATESETUPAYURVEDICIRRITABILITY =
  "UPDATESETUPAYURVEDICIRRITABILITY";
export const DELETESETUPAYURVEDICIRRITABILITY =
  "DELETESETUPAYURVEDICIRRITABILITY";

export const GETSETUPAYURVEDICEUPHORIA = "GETSETUPAYURVEDICEUPHORIA";
export const CREATESETUPAYURVEDICEUPHORIA = "CREATESETUPAYURVEDICEUPHORIA";
export const UPDATESETUPAYURVEDICEUPHORIA = "UPDATESETUPAYURVEDICEUPHORIA";
export const DELETESETUPAYURVEDICEUPHORIA = "DELETESETUPAYURVEDICEUPHORIA";

export const GETSETUPAYURVEDICOBSESSION = "GETSETUPAYURVEDICOBSESSION";
export const CREATESETUPAYURVEDICOBSESSION = "CREATESETUPAYURVEDICOBSESSION";
export const UPDATESETUPAYURVEDICOBSESSION = "UPDATESETUPAYURVEDICOBSESSION";
export const DELETESETUPAYURVEDICOBSESSION = "DELETESETUPAYURVEDICOBSESSION";

export const GETSETUPAYURVEDICNEUROSIS = "GETSETUPAYURVEDICNEUROSIS";
export const CREATESETUPAYURVEDICNEUROSIS = "CREATESETUPAYURVEDICNEUROSIS";
export const UPDATESETUPAYURVEDICNEUROSIS = "UPDATESETUPAYURVEDICNEUROSIS";
export const DELETESETUPAYURVEDICNEUROSIS = "DELETESETUPAYURVEDICNEUROSIS";

export const GETSETUPAYURVEDICDEPERSONALIZATION =
  "GETSETUPAYURVEDICDEPERSONALIZATION";
export const CREATESETUPAYURVEDICDEPERSONALIZATION =
  "CREATESETUPAYURVEDICDEPERSONALIZATION";
export const UPDATESETUPAYURVEDICDEPERSONALIZATION =
  "UPDATESETUPAYURVEDICDEPERSONALIZATION";
export const DELETESETUPAYURVEDICDEPERSONALIZATION =
  "DELETESETUPAYURVEDICDEPERSONALIZATION";

export const GETSETUPAYURVEDICALLOPATHICMEDI =
  "GETSETUPAYURVEDICALLOPATHICMEDI";
export const CREATESETUPAYURVEDICALLOPATHICMEDI =
  "CREATESETUPAYURVEDICALLOPATHICMEDI";
export const UPDATESETUPAYURVEDICALLOPATHICMEDI =
  "UPDATESETUPAYURVEDICALLOPATHICMEDI";
export const DELETESETUPAYURVEDICALLOPATHICMEDI =
  "DELETESETUPAYURVEDICALLOPATHICMEDI";

export const GETSETUPAYURVEDICAYURVEDAMEDI = "GETSETUPAYURVEDICAYURVEDAMEDI";
export const CREATESETUPAYURVEDICAYURVEDAMEDI =
  "CREATESETUPAYURVEDICAYURVEDAMEDI";
export const UPDATESETUPAYURVEDICAYURVEDAMEDI =
  "UPDATESETUPAYURVEDICAYURVEDAMEDI";
export const DELETESETUPAYURVEDICAYURVEDAMEDI =
  "DELETESETUPAYURVEDICAYURVEDAMEDI";

export const GETSETUPAYURVEDICHOMEOPATHYMEDI =
  "GETSETUPAYURVEDICHOMEOPATHYMEDI";
export const CREATESETUPAYURVEDICHOMEOPATHYMEDI =
  "CREATESETUPAYURVEDICHOMEOPATHYMEDI";
export const UPDATESETUPAYURVEDICHOMEOPATHYMEDI =
  "UPDATESETUPAYURVEDICHOMEOPATHYMEDI";
export const DELETESETUPAYURVEDICHOMEOPATHYMEDI =
  "DELETESETUPAYURVEDICHOMEOPATHYMEDI";

export const GETSETUPAYURVEDICOTHERMEDI = "GETSETUPAYURVEDICOTHERMEDI";
export const CREATESETUPAYURVEDICOTHERMEDI = "CREATESETUPAYURVEDICOTHERMEDI";
export const UPDATESETUPAYURVEDICOTHERMEDI = "UPDATESETUPAYURVEDICOTHERMEDI";
export const DELETESETUPAYURVEDICOTHERMEDI = "DELETESETUPAYURVEDICOTHERMEDI";

export const GETSETUPAYURVEDICPSYCOLOGICALHIST =
  "GETSETUPAYURVEDICPSYCOLOGICALHIST";
export const CREATESETUPAYURVEDICPSYCOLOGICALHIST =
  "CREATESETUPAYURVEDICPSYCOLOGICALHIST";
export const UPDATESETUPAYURVEDICPSYCOLOGICALHIST =
  "UPDATESETUPAYURVEDICPSYCOLOGICALHIST";
export const DELETESETUPAYURVEDICPSYCOLOGICALHIST =
  "DELETESETUPAYURVEDICPSYCOLOGICALHIST";

export const GETSETUPAYURVEDICGYNECOLOGICAL = "GETSETUPAYURVEDICGYNECOLOGICAL";
export const CREATESETUPAYURVEDICGYNECOLOGICAL =
  "CREATESETUPAYURVEDICGYNECOLOGICAL";
export const UPDATESETUPAYURVEDICGYNECOLOGICAL =
  "UPDATESETUPAYURVEDICGYNECOLOGICAL";
export const DELETESETUPAYURVEDICGYNECOLOGICAL =
  "DELETESETUPAYURVEDICGYNECOLOGICAL";

export const GETSETUPAYURVEDICOBSTETRICALHIST =
  "GETSETUPAYURVEDICOBSTETRICALHIST";
export const CREATESETUPAYURVEDICOBSTETRICALHIST =
  "CREATESETUPAYURVEDICOBSTETRICALHIST";
export const UPDATESETUPAYURVEDICOBSTETRICALHIST =
  "UPDATESETUPAYURVEDICOBSTETRICALHIST";
export const DELETESETUPAYURVEDICOBSTETRICALHIST =
  "DELETESETUPAYURVEDICOBSTETRICALHIST";

export const GETSETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE =
  "GETSETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";
export const CREATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE =
  "CREATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";
export const UPDATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE =
  "UPDATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";
export const DELETESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE =
  "DELETESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";

export const GETSETUPAYURVEDICEXAMINATIONNUTRITION =
  "GETSETUPAYURVEDICEXAMINATIONNUTRITION";
export const CREATESETUPAYURVEDICEXAMINATIONNUTRITION =
  "CREATESETUPAYURVEDICEXAMINATIONNUTRITION";
export const UPDATESETUPAYURVEDICEXAMINATIONNUTRITION =
  "UPDATESETUPAYURVEDICEXAMINATIONNUTRITION";
export const DELETESETUPAYURVEDICEXAMINATIONNUTRITION =
  "DELETESETUPAYURVEDICEXAMINATIONNUTRITION";

export const GETSETUPAYURVEDICEXAMINATIONANAEMIA =
  "GETSETUPAYURVEDICEXAMINATIONANAEMIA";
export const CREATESETUPAYURVEDICEXAMINATIONANAEMIA =
  "CREATESETUPAYURVEDICEXAMINATIONANAEMIA";
export const UPDATESETUPAYURVEDICEXAMINATIONANAEMIA =
  "UPDATESETUPAYURVEDICEXAMINATIONANAEMIA";
export const DELETESETUPAYURVEDICEXAMINATIONANAEMIA =
  "DELETESETUPAYURVEDICEXAMINATIONANAEMIA";

export const GETSETUPAYURVEDICEXAMINATIONNECKVEIN =
  "GETSETUPAYURVEDICEXAMINATIONNECKVEIN";
export const CREATESETUPAYURVEDICEXAMINATIONNECKVEIN =
  "CREATESETUPAYURVEDICEXAMINATIONNECKVEIN";
export const UPDATESETUPAYURVEDICEXAMINATIONNECKVEIN =
  "UPDATESETUPAYURVEDICEXAMINATIONNECKVEIN";
export const DELETESETUPAYURVEDICEXAMINATIONNECKVEIN =
  "DELETESETUPAYURVEDICEXAMINATIONNECKVEIN";

export const GETSETUPAYURVEDICEXAMINATIONLYMPHNODES =
  "GETSETUPAYURVEDICEXAMINATIONLYMPHNODES";
export const CREATESETUPAYURVEDICEXAMINATIONLYMPHNODES =
  "CREATESETUPAYURVEDICEXAMINATIONLYMPHNODES";
export const UPDATESETUPAYURVEDICEXAMINATIONLYMPHNODES =
  "UPDATESETUPAYURVEDICEXAMINATIONLYMPHNODES";
export const DELETESETUPAYURVEDICEXAMINATIONLYMPHNODES =
  "DELETESETUPAYURVEDICEXAMINATIONLYMPHNODES";

export const GETSETUPAYURVEDICEXAMINATIONBUILD =
  "GETSETUPAYURVEDICEXAMINATIONBUILD";
export const CREATESETUPAYURVEDICEXAMINATIONBUILD =
  "CREATESETUPAYURVEDICEXAMINATIONBUILD";
export const UPDATESETUPAYURVEDICEXAMINATIONBUILD =
  "UPDATESETUPAYURVEDICEXAMINATIONBUILD";
export const DELETESETUPAYURVEDICEXAMINATIONBUILD =
  "DELETESETUPAYURVEDICEXAMINATIONBUILD";

export const GETSETUPAYURVEDICEXAMINATIONPULSE =
  "GETSETUPAYURVEDICEXAMINATIONPULSE";
export const CREATESETUPAYURVEDICEXAMINATIONPULSE =
  "CREATESETUPAYURVEDICEXAMINATIONPULSE";
export const UPDATESETUPAYURVEDICEXAMINATIONPULSE =
  "UPDATESETUPAYURVEDICEXAMINATIONPULSE";
export const DELETESETUPAYURVEDICEXAMINATIONPULSE =
  "DELETESETUPAYURVEDICEXAMINATIONPULSE";

export const GETSETUPAYURVEDICEXAMINATIONTONGUE =
  "GETSETUPAYURVEDICEXAMINATIONTONGUE";
export const CREATESETUPAYURVEDICEXAMINATIONTONGUE =
  "CREATESETUPAYURVEDICEXAMINATIONTONGUE";
export const UPDATESETUPAYURVEDICEXAMINATIONTONGUE =
  "UPDATESETUPAYURVEDICEXAMINATIONTONGUE";
export const DELETESETUPAYURVEDICEXAMINATIONTONGUE =
  "DELETESETUPAYURVEDICEXAMINATIONTONGUE";

export const GETSETUPAYURVEDICEXAMINATIONPOOP =
  "GETSETUPAYURVEDICEXAMINATIONPOOP";
export const CREATESETUPAYURVEDICEXAMINATIONPOOP =
  "CREATESETUPAYURVEDICEXAMINATIONPOOP";
export const UPDATESETUPAYURVEDICEXAMINATIONPOOP =
  "UPDATESETUPAYURVEDICEXAMINATIONPOOP";
export const DELETESETUPAYURVEDICEXAMINATIONPOOP =
  "DELETESETUPAYURVEDICEXAMINATIONPOOP";

export const GETSETUPAYURVEDICEXAMINATIONURINE =
  "GETSETUPAYURVEDICEXAMINATIONURINE";
export const CREATESETUPAYURVEDICEXAMINATIONURINE =
  "CREATESETUPAYURVEDICEXAMINATIONURINE";
export const UPDATESETUPAYURVEDICEXAMINATIONURINE =
  "UPDATESETUPAYURVEDICEXAMINATIONURINE";
export const DELETESETUPAYURVEDICEXAMINATIONURINE =
  "DELETESETUPAYURVEDICEXAMINATIONURINE";

export const GETSETUPAYURVEDICEXAMINATIONWORD =
  "GETSETUPAYURVEDICEXAMINATIONWORD";
export const CREATESETUPAYURVEDICEXAMINATIONWORD =
  "CREATESETUPAYURVEDICEXAMINATIONWORD";
export const UPDATESETUPAYURVEDICEXAMINATIONWORD =
  "UPDATESETUPAYURVEDICEXAMINATIONWORD";
export const DELETESETUPAYURVEDICEXAMINATIONWORD =
  "DELETESETUPAYURVEDICEXAMINATIONWORD";

export const GETSETUPAYURVEDICEXAMINATIONTOUCH =
  "GETSETUPAYURVEDICEXAMINATIONTOUCH";
export const CREATESETUPAYURVEDICEXAMINATIONTOUCH =
  "CREATESETUPAYURVEDICEXAMINATIONTOUCH";
export const UPDATESETUPAYURVEDICEXAMINATIONTOUCH =
  "UPDATESETUPAYURVEDICEXAMINATIONTOUCH";
export const DELETESETUPAYURVEDICEXAMINATIONTOUCH =
  "DELETESETUPAYURVEDICEXAMINATIONTOUCH";

export const GETSETUPAYURVEDICEXAMINATIONEYE =
  "GETSETUPAYURVEDICEXAMINATIONEYE";
export const CREATESETUPAYURVEDICEXAMINATIONEYE =
  "CREATESETUPAYURVEDICEXAMINATIONEYE";
export const UPDATESETUPAYURVEDICEXAMINATIONEYE =
  "UPDATESETUPAYURVEDICEXAMINATIONEYE";
export const DELETESETUPAYURVEDICEXAMINATIONEYE =
  "DELETESETUPAYURVEDICEXAMINATIONEYE";

export const GETSETUPAYURVEDICEXAMINATIONAKRITA =
  "GETSETUPAYURVEDICEXAMINATIONAKRITA";
export const CREATESETUPAYURVEDICEXAMINATIONAKRITA =
  "CREATESETUPAYURVEDICEXAMINATIONAKRITA";
export const UPDATESETUPAYURVEDICEXAMINATIONAKRITA =
  "UPDATESETUPAYURVEDICEXAMINATIONAKRITA";
export const DELETESETUPAYURVEDICEXAMINATIONAKRITA =
  "DELETESETUPAYURVEDICEXAMINATIONAKRITA";

export const GETSETUPAYURVEDICEXAMINATIONNATUREPHYSICAL =
  "GETSETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";
export const CREATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL =
  "CREATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";
export const UPDATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL =
  "UPDATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";
export const DELETESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL =
  "DELETESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";

export const GETSETUPAYURVEDICEXAMINATIONNATUREMENTAL =
  "GETSETUPAYURVEDICEXAMINATIONNATUREMENTAL";
export const CREATESETUPAYURVEDICEXAMINATIONNATUREMENTAL =
  "CREATESETUPAYURVEDICEXAMINATIONNATUREMENTAL";
export const UPDATESETUPAYURVEDICEXAMINATIONNATUREMENTAL =
  "UPDATESETUPAYURVEDICEXAMINATIONNATUREMENTAL";
export const DELETESETUPAYURVEDICEXAMINATIONNATUREMENTAL =
  "DELETESETUPAYURVEDICEXAMINATIONNATUREMENTAL";

export const GETSETUPAYURVEDICEXAMINATIONSUBSTANCE =
  "GETSETUPAYURVEDICEXAMINATIONSUBSTANCE";
export const CREATESETUPAYURVEDICEXAMINATIONSUBSTANCE =
  "CREATESETUPAYURVEDICEXAMINATIONSUBSTANCE";
export const UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCE =
  "UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCE";
export const DELETESETUPAYURVEDICEXAMINATIONSUBSTANCE =
  "DELETESETUPAYURVEDICEXAMINATIONSUBSTANCE";

export const GETSETUPAYURVEDICEXAMINATIONCOMPACTION =
  "GETSETUPAYURVEDICEXAMINATIONCOMPACTION";
export const CREATESETUPAYURVEDICEXAMINATIONCOMPACTION =
  "CREATESETUPAYURVEDICEXAMINATIONCOMPACTION";
export const UPDATESETUPAYURVEDICEXAMINATIONCOMPACTION =
  "UPDATESETUPAYURVEDICEXAMINATIONCOMPACTION";
export const DELETESETUPAYURVEDICEXAMINATIONCOMPACTION =
  "DELETESETUPAYURVEDICEXAMINATIONCOMPACTION";

export const GETSETUPAYURVEDICEXAMINATIONPERCEPTION =
  "GETSETUPAYURVEDICEXAMINATIONPERCEPTION";
export const CREATESETUPAYURVEDICEXAMINATIONPERCEPTION =
  "CREATESETUPAYURVEDICEXAMINATIONPERCEPTION";
export const UPDATESETUPAYURVEDICEXAMINATIONPERCEPTION =
  "UPDATESETUPAYURVEDICEXAMINATIONPERCEPTION";
export const DELETESETUPAYURVEDICEXAMINATIONPERCEPTION =
  "DELETESETUPAYURVEDICEXAMINATIONPERCEPTION";

export const GETSETUPAYURVEDICEXAMINATIONSUITABILITY =
  "GETSETUPAYURVEDICEXAMINATIONSUITABILITY";
export const CREATESETUPAYURVEDICEXAMINATIONSUITABILITY =
  "CREATESETUPAYURVEDICEXAMINATIONSUITABILITY";
export const UPDATESETUPAYURVEDICEXAMINATIONSUITABILITY =
  "UPDATESETUPAYURVEDICEXAMINATIONSUITABILITY";
export const DELETESETUPAYURVEDICEXAMINATIONSUITABILITY =
  "DELETESETUPAYURVEDICEXAMINATIONSUITABILITY";

export const GETSETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM =
  "GETSETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";
export const CREATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM =
  "CREATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";
export const UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM =
  "UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";
export const DELETESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM =
  "DELETESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";

export const GETSETUPAYURVEDICEXAMINATIONDIETCARRYPOWER =
  "GETSETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";
export const CREATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER =
  "CREATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";
export const UPDATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER =
  "UPDATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";
export const DELETESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER =
  "DELETESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";

export const GETSETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER =
  "GETSETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";
export const CREATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER =
  "CREATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";
export const UPDATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER =
  "UPDATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";
export const DELETESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER =
  "DELETESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";

export const GETSETUPAYURVEDICEXAMINATIONEXERCIZEPOWER =
  "GETSETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";
export const CREATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER =
  "CREATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";
export const UPDATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER =
  "UPDATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";
export const DELETESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER =
  "DELETESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";

export const GETSETUPAYURVEDICEXAMINATIONAGE =
  "GETSETUPAYURVEDICEXAMINATIONAGE";
export const CREATESETUPAYURVEDICEXAMINATIONAGE =
  "CREATESETUPAYURVEDICEXAMINATIONAGE";
export const UPDATESETUPAYURVEDICEXAMINATIONAGE =
  "UPDATESETUPAYURVEDICEXAMINATIONAGE";
export const DELETESETUPAYURVEDICEXAMINATIONAGE =
  "DELETESETUPAYURVEDICEXAMINATIONAGE";

export const GETSETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS =
  "GETSETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";

export const GETSETUPAYURVEDICEXAMINATIONANNAVAHSROTAS =
  "GETSETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";

export const GETSETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONRASAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS =
  "GETSETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS =
  "CREATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS =
  "UPDATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS =
  "DELETESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";

export const GETSETUPAYURVEDICEXAMINATIONTHEFAULT =
  "GETSETUPAYURVEDICEXAMINATIONTHEFAULT";
export const CREATESETUPAYURVEDICEXAMINATIONTHEFAULT =
  "CREATESETUPAYURVEDICEXAMINATIONTHEFAULT";
export const UPDATESETUPAYURVEDICEXAMINATIONTHEFAULT =
  "UPDATESETUPAYURVEDICEXAMINATIONTHEFAULT";
export const DELETESETUPAYURVEDICEXAMINATIONTHEFAULT =
  "DELETESETUPAYURVEDICEXAMINATIONTHEFAULT";

export const GETSETUPAYURVEDICEXAMINATIONDUSHYA =
  "GETSETUPAYURVEDICEXAMINATIONDUSHYA";
export const CREATESETUPAYURVEDICEXAMINATIONDUSHYA =
  "CREATESETUPAYURVEDICEXAMINATIONDUSHYA";
export const UPDATESETUPAYURVEDICEXAMINATIONDUSHYA =
  "UPDATESETUPAYURVEDICEXAMINATIONDUSHYA";
export const DELETESETUPAYURVEDICEXAMINATIONDUSHYA =
  "DELETESETUPAYURVEDICEXAMINATIONDUSHYA";

export const GETSETUPAYURVEDICEXAMINATIONFIRE =
  "GETSETUPAYURVEDICEXAMINATIONFIRE";
export const CREATESETUPAYURVEDICEXAMINATIONFIRE =
  "CREATESETUPAYURVEDICEXAMINATIONFIRE";
export const UPDATESETUPAYURVEDICEXAMINATIONFIRE =
  "UPDATESETUPAYURVEDICEXAMINATIONFIRE";
export const DELETESETUPAYURVEDICEXAMINATIONFIRE =
  "DELETESETUPAYURVEDICEXAMINATIONFIRE";

export const GETSETUPAYURVEDICEXAMINATIONAMA =
  "GETSETUPAYURVEDICEXAMINATIONAMA";
export const CREATESETUPAYURVEDICEXAMINATIONAMA =
  "CREATESETUPAYURVEDICEXAMINATIONAMA";
export const UPDATESETUPAYURVEDICEXAMINATIONAMA =
  "UPDATESETUPAYURVEDICEXAMINATIONAMA";
export const DELETESETUPAYURVEDICEXAMINATIONAMA =
  "DELETESETUPAYURVEDICEXAMINATIONAMA";

export const GETSETUPAYURVEDICEXAMINATIONSOURCES =
  "GETSETUPAYURVEDICEXAMINATIONSOURCES";
export const CREATESETUPAYURVEDICEXAMINATIONSOURCES =
  "CREATESETUPAYURVEDICEXAMINATIONSOURCES";
export const UPDATESETUPAYURVEDICEXAMINATIONSOURCES =
  "UPDATESETUPAYURVEDICEXAMINATIONSOURCES";
export const DELETESETUPAYURVEDICEXAMINATIONSOURCES =
  "DELETESETUPAYURVEDICEXAMINATIONSOURCES";

export const GETSETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE =
  "GETSETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";
export const CREATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE =
  "CREATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";
export const UPDATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE =
  "UPDATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";
export const DELETESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE =
  "DELETESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";

export const GETSETUPAYURVEDICEXAMINATIONPLACEOFORIGIN =
  "GETSETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";
export const CREATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN =
  "CREATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";
export const UPDATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN =
  "UPDATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";
export const DELETESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN =
  "DELETESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";

export const GETSETUPAYURVEDICOPDBODYCHART = "GETSETUPAYURVEDICOPDBODYCHART";
export const CREATESETUPAYURVEDICOPDBODYCHART =
  "CREATESETUPAYURVEDICOPDBODYCHART";
export const UPDATESETUPAYURVEDICOPDBODYCHART =
  "UPDATESETUPAYURVEDICOPDBODYCHART";
export const DELETESETUPAYURVEDICOPDBODYCHART =
  "DELETESETUPAYURVEDICOPDBODYCHART";

export const GETAYURVEDICOPDPAINASSESSMENT = "GETAYURVEDICOPDPAINASSESSMENT";
export const CREATEAYURVVEDICOPDPAINASSESSMENT =
  "CREATEAYURVVEDICOPDPAINASSESSMENT";
export const UPDATEAYURVEDICOPDPAINASSESSMENT =
  "UPDATEAYURVEDICOPDPAINASSESSMENT";
export const DELETEAYURVEDICOPDPAINASSESSMENT =
  "DELETEAYURVEDICOPDPAINASSESSMENT";

export const CREATEAYURVVEDICOPDCHIEFSYMTOMPS =
  "CREATEAYURVVEDICOPDCHIEFSYMTOMPS";
export const GETAYURVEDICOPDCHIEFSYMTOMPS = "GETAYURVEDICOPDCHIEFSYMTOMPS";
export const UPDATEAYURVEDICOPDCHIEFSYMTOMPS =
  "UPDATEAYURVEDICOPDCHIEFSYMTOMPS";
export const DELETEAYURVEDICOPDCHIEFSYMTOMPS =
  "DELETEAYURVEDICOPDCHIEFSYMTOMPS";

export const GETAYURVEDICOPDASSOCIATEDSYMTOMPS =
  "GETAYURVEDICOPDASSOCIATEDSYMTOMPS";
export const CREATEAYURVVEDICOPDASSOCIATEDSYMTOMPS =
  "CREATEAYURVVEDICOPDASSOCIATEDSYMTOMPS";
export const UPDATEAYURVEDICOPDASSOCIATEDSYMTOMPS =
  "UPDATEAYURVEDICOPDASSOCIATEDSYMTOMPS";
export const DELETEAYURVEDICOPDASSOCIATEDSYMTOMPS =
  "DELETEAYURVEDICOPDASSOCIATEDSYMTOMPS";

export const GETAYURVEDICOPDPRESENTILLCOMORBIDITY =
  "GETAYURVEDICOPDPRESENTILLCOMORBIDITY";
export const CREATEAYURVVEDICOPDPRESENTILLCOMORBIDITY =
  "CREATEAYURVVEDICOPDPRESENTILLCOMORBIDITY";
export const UPDATEAYURVEDICOPDPRESENTILLCOMORBIDITY =
  "UPDATEAYURVEDICOPDPRESENTILLCOMORBIDITY";
export const DELETEAYURVEDICOPDPRESENTILLCOMORBIDITY =
  "DELETEAYURVEDICOPDPRESENTILLCOMORBIDITY";

export const GETAYURVEDICOPDFAMILYSYMTOMPS = "GETAYURVEDICOPDFAMILYSYMTOMPS";
export const CREATEAYURVVEDICOPDFAMILYSYMTOMPS =
  "CREATEAYURVVEDICOPDFAMILYSYMTOMPS";
export const UPDATEAYURVEDICOPDFAMILYSYMTOMPS =
  "UPDATEAYURVEDICOPDFAMILYSYMTOMPS";
export const DELETEAYURVEDICOPDFAMILYSYMTOMPS =
  "DELETEAYURVEDICOPDFAMILYSYMTOMPS";

export const GETAYURVEDICOPDFAMILYCOMORBIDITY =
  "GETAYURVEDICOPDFAMILYCOMORBIDITY";
export const CREATEAYURVVEDICOPDFAMILYCOMORBIDITY =
  "CREATEAYURVVEDICOPDFAMILYCOMORBIDITY";
export const UPDATEAYURVEDICOPDFAMILYCOMORBIDITY =
  "UPDATEAYURVEDICOPDFAMILYCOMORBIDITY";
export const DELETEAYURVEDICOPDFAMILYCOMORBIDITY =
  "DELETEAYURVEDICOPDFAMILYCOMORBIDITY";

export const GETAYURVEDICOPDCHILDHOODILLNESS =
  "GETAYURVEDICOPDCHILDHOODILLNESS";
export const CREATEAYURVVEDICOPDCHILDHOODILLNESS =
  "CREATEAYURVVEDICOPDCHILDHOODILLNESS";
export const UPDATEAYURVEDICOPDCHILDHOODILLNESS =
  "UPDATEAYURVEDICOPDCHILDHOODILLNESS";
export const DELETEAYURVEDICOPDCHILDHOODILLNESS =
  "DELETEAYURVEDICOPDCHILDHOODILLNESS";

export const GETAYURVEDICOPDADULTILLNESS = "GETAYURVEDICOPDADULTILLNESS";
export const CREATEAYURVVEDICOPDADULTILLNESS =
  "CREATEAYURVVEDICOPDADULTILLNESS";
export const UPDATEAYURVEDICOPDADULTILLNESS = "UPDATEAYURVEDICOPDADULTILLNESS";
export const DELETEAYURVEDICOPDADULTILLNESS = "DELETEAYURVEDICOPDADULTILLNESS";

export const GETAYURVEDICOPDPRESENTCOMORILLNESS =
  "GETAYURVEDICOPDPRESENTCOMORILLNESS";
export const CREATEAYURVVEDICOPDPRESENTCOMORILLNESS =
  "CREATEAYURVVEDICOPDPRESENTCOMORILLNESS";
export const UPDATEAYURVEDICOPDPRESENTCOMORILLNESS =
  "UPDATEAYURVEDICOPDPRESENTCOMORILLNESS";
export const DELETEAYURVEDICOPDPRESENTCOMORILLNESS =
  "DELETEAYURVEDICOPDPRESENTCOMORILLNESS";

export const GETAYURVEDICOPDPASTILLNESS = "GETAYURVEDICOPDPASTILLNESS";
export const CREATEAYURVVEDICOPDPASTILLNESS = "CREATEAYURVVEDICOPDPASTILLNESS";
export const UPDATEAYURVEDICOPDPASTILLNESS = "UPDATEAYURVEDICOPDPASTILLNESS";
export const DELETEAYURVEDICOPDPASTILLNESS = "DELETEAYURVEDICOPDPASTILLNESS";

export const GETAYURVEDICOPDFAMILYILLNESS = "GETAYURVEDICOPDFAMILYILLNESS";
export const CREATEAYURVVEDICOPDFAMILYILLNESS =
  "CREATEAYURVVEDICOPDFAMILYILLNESS";
export const UPDATEAYURVEDICOPDFAMILYILLNESS =
  "UPDATEAYURVEDICOPDFAMILYILLNESS";
export const DELETEAYURVEDICOPDFAMILYILLNESS =
  "DELETEAYURVEDICOPDFAMILYILLNESS";

export const GETAYURVEDICOPDCOMPLAINTAPPETITE =
  "GETAYURVEDICOPDCOMPLAINTAPPETITE";
export const CREATEAYURVVEDICOPDCOMPLAINTAPPETITE =
  "CREATEAYURVVEDICOPDCOMPLAINTAPPETITE";
export const UPDATEAYURVEDICOPDCOMPLAINTAPPETITE =
  "UPDATEAYURVEDICOPDCOMPLAINTAPPETITE";
export const DELETEAYURVEDICOPDCOMPLAINTAPPETITE =
  "DELETEAYURVEDICOPDCOMPLAINTAPPETITE";
export const GETAYURVEDICOPDCOMPLAINTDIGESTIVETRACT =
  "GETAYURVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const CREATEAYURVVEDICOPDCOMPLAINTDIGESTIVETRACT =
  "CREATEAYURVVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const UPDATEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT =
  "UPDATEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const DELETEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT =
  "DELETEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const GETAYURVEDICOPDCOMPLAINTBOWEL = "GETAYURVEDICOPDCOMPLAINTBOWEL";
export const CREATEAYURVVEDICOPDCOMPLAINTBOWEL =
  "CREATEAYURVVEDICOPDCOMPLAINTBOWEL";
export const UPDATEAYURVEDICOPDCOMPLAINTBOWEL =
  "UPDATEAYURVEDICOPDCOMPLAINTBOWEL";
export const DELETEAYURVEDICOPDCOMPLAINTBOWEL =
  "DELETEAYURVEDICOPDCOMPLAINTBOWEL";
export const GETAYURVEDICOPDCOMPLAINTSLEEP = "GETAYURVEDICOPDCOMPLAINTSLEEP";
export const CREATEAYURVVEDICOPDCOMPLAINTSLEEP =
  "CREATEAYURVVEDICOPDCOMPLAINTSLEEP";
export const UPDATEAYURVEDICOPDCOMPLAINTSLEEP =
  "UPDATEAYURVEDICOPDCOMPLAINTSLEEP";
export const DELETEAYURVEDICOPDCOMPLAINTSLEEP =
  "DELETEAYURVEDICOPDCOMPLAINTSLEEP";
export const GETAYURVEDICOPDCOMPLAINTADDICTIONS =
  "GETAYURVEDICOPDCOMPLAINTADDICTIONS";
export const CREATEAYURVVEDICOPDCOMPLAINTADDICTIONS =
  "CREATEAYURVVEDICOPDCOMPLAINTADDICTIONS";
export const UPDATEAYURVEDICOPDCOMPLAINTADDICTIONS =
  "UPDATEAYURVEDICOPDCOMPLAINTADDICTIONS";
export const DELETEAYURVEDICOPDCOMPLAINTADDICTIONS =
  "DELETEAYURVEDICOPDCOMPLAINTADDICTIONS";
export const GETAYURVEDICOPDCOMPLAINTHIGHRISK =
  "GETAYURVEDICOPDCOMPLAINTHIGHRISK";
export const CREATEAYURVVEDICOPDCOMPLAINTHIGHRISK =
  "CREATEAYURVVEDICOPDCOMPLAINTHIGHRISK";
export const UPDATEAYURVEDICOPDCOMPLAINTHIGHRISK =
  "UPDATEAYURVEDICOPDCOMPLAINTHIGHRISK";
export const DELETEAYURVEDICOPDCOMPLAINTHIGHRISK =
  "DELETEAYURVEDICOPDCOMPLAINTHIGHRISK";
export const GETAYURVEDICOPDCOMPLAINTPOSITIONOFWORK =
  "GETAYURVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const CREATEAYURVVEDICOPDCOMPLAINTPOSITIONOFWORK =
  "CREATEAYURVVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const UPDATEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK =
  "UPDATEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const DELETEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK =
  "DELETEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const GETAYURVEDICOPDCOMPLAINTNATUREOFWORK =
  "GETAYURVEDICOPDCOMPLAINTNATUREOFWORK";
export const CREATEAYURVVEDICOPDCOMPLAINTNATUREOFWORK =
  "CREATEAYURVVEDICOPDCOMPLAINTNATUREOFWORK";
export const UPDATEAYURVEDICOPDCOMPLAINTNATUREOFWORK =
  "UPDATEAYURVEDICOPDCOMPLAINTNATUREOFWORK";
export const DELETEAYURVEDICOPDCOMPLAINTNATUREOFWORK =
  "DELETEAYURVEDICOPDCOMPLAINTNATUREOFWORK";
export const GETAYURVEDICOPDCOMPLAINTALLOPATHICMEDI =
  "GETAYURVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTALLOPATHICMEDI =
  "CREATEAYURVVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI =
  "UPDATEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI =
  "DELETEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const GETAYURVEDICOPDCOMPLAINTAYURVDAMEDI =
  "GETAYURVEDICOPDCOMPLAINTAYURVDAMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTAYURVDAMEDI =
  "CREATEAYURVVEDICOPDCOMPLAINTAYURVDAMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTAYURVDAMEDI =
  "UPDATEAYURVEDICOPDCOMPLAINTAYURVDAMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTAYURVDAMEDI =
  "DELETEAYURVEDICOPDCOMPLAINTAYURVDAMEDI";
export const GETAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI =
  "GETAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTHOMEOATHYMEDI =
  "CREATEAYURVVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI =
  "UPDATEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI =
  "DELETEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const GETAYURVEDICOPDCOMPLAINTOTHERMEDI =
  "GETAYURVEDICOPDCOMPLAINTOTHERMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTOTHERMEDI =
  "CREATEAYURVVEDICOPDCOMPLAINTOTHERMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTOTHERMEDI =
  "UPDATEAYURVEDICOPDCOMPLAINTOTHERMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTOTHERMEDI =
  "DELETEAYURVEDICOPDCOMPLAINTOTHERMEDI";
export const GETAYURVEDICOPDCOMPLAINTANXIETY =
  "GETAYURVEDICOPDCOMPLAINTANXIETY";
export const CREATEAYURVVEDICOPDCOMPLAINTANXIETY =
  "CREATEAYURVVEDICOPDCOMPLAINTANXIETY";
export const UPDATEAYURVEDICOPDCOMPLAINTANXIETY =
  "UPDATEAYURVEDICOPDCOMPLAINTANXIETY";
export const DELETEAYURVEDICOPDCOMPLAINTANXIETY =
  "DELETEAYURVEDICOPDCOMPLAINTANXIETY";
export const GETAYURVEDICOPDCOMPLAINTDEPRESSION =
  "GETAYURVEDICOPDCOMPLAINTDEPRESSION";
export const CREATEAYURVVEDICOPDCOMPLAINTDEPRESSION =
  "CREATEAYURVVEDICOPDCOMPLAINTDEPRESSION";
export const UPDATEAYURVEDICOPDCOMPLAINTDEPRESSION =
  "UPDATEAYURVEDICOPDCOMPLAINTDEPRESSION";
export const DELETEAYURVEDICOPDCOMPLAINTDEPRESSION =
  "DELETEAYURVEDICOPDCOMPLAINTDEPRESSION";
export const GETAYURVEDICOPDCOMPLAINTIRRITABIILTY =
  "GETAYURVEDICOPDCOMPLAINTIRRITABIILTY";
export const CREATEAYURVVEDICOPDCOMPLAINTIRRITABIILTY =
  "CREATEAYURVVEDICOPDCOMPLAINTIRRITABIILTY";
export const UPDATEAYURVEDICOPDCOMPLAINTIRRITABIILTY =
  "UPDATEAYURVEDICOPDCOMPLAINTIRRITABIILTY";
export const DELETEAYURVEDICOPDCOMPLAINTIRRITABIILTY =
  "DELETEAYURVEDICOPDCOMPLAINTIRRITABIILTY";
export const GETAYURVEDICOPDCOMPLAINTEUPHORIA =
  "GETAYURVEDICOPDCOMPLAINTEUPHORIA";
export const CREATEAYURVVEDICOPDCOMPLAINTEUPHORIA =
  "CREATEAYURVVEDICOPDCOMPLAINTEUPHORIA";
export const UPDATEAYURVEDICOPDCOMPLAINTEUPHORIA =
  "UPDATEAYURVEDICOPDCOMPLAINTEUPHORIA";
export const DELETEAYURVEDICOPDCOMPLAINTEUPHORIA =
  "DELETEAYURVEDICOPDCOMPLAINTEUPHORIA";
export const GETAYURVEDICOPDCOMPLAINTOBSESSION =
  "GETAYURVEDICOPDCOMPLAINTOBSESSION";
export const CREATEAYURVVEDICOPDCOMPLAINTOBSESSION =
  "CREATEAYURVVEDICOPDCOMPLAINTOBSESSION";
export const UPDATEAYURVEDICOPDCOMPLAINTOBSESSION =
  "UPDATEAYURVEDICOPDCOMPLAINTOBSESSION";
export const DELETEAYURVEDICOPDCOMPLAINTOBSESSION =
  "DELETEAYURVEDICOPDCOMPLAINTOBSESSION";
export const GETAYURVEDICOPDCOMPLAINTNEUROSIS =
  "GETAYURVEDICOPDCOMPLAINTNEUROSIS";
export const CREATEAYURVVEDICOPDCOMPLAINTNEUROSIS =
  "CREATEAYURVVEDICOPDCOMPLAINTNEUROSIS";
export const UPDATEAYURVEDICOPDCOMPLAINTNEUROSIS =
  "UPDATEAYURVEDICOPDCOMPLAINTNEUROSIS";
export const DELETEAYURVEDICOPDCOMPLAINTNEUROSIS =
  "DELETEAYURVEDICOPDCOMPLAINTNEUROSIS";
export const GETAYURVEDICOPDCOMPLAINTDEPERSONALIZATION =
  "GETAYURVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const CREATEAYURVVEDICOPDCOMPLAINTDEPERSONALIZATION =
  "CREATEAYURVVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const UPDATEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION =
  "UPDATEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const DELETEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION =
  "DELETEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const GETAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE =
  "GETAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const CREATEAYURVVEDICOPDCOMPLAINTMENSTRUALCYCLE =
  "CREATEAYURVVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const UPDATEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE =
  "UPDATEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const DELETEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE =
  "DELETEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const GETAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY =
  "GETAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY";
export const CREATEAYURVVEDICOPDCOMPLAINTNATUREOFDELIVERY =
  "CREATEAYURVVEDICOPDCOMPLAINTNATUREOFDELIVERY";
export const UPDATEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY =
  "UPDATEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY";
export const DELETEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY =
  "DELETEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY";

export const GETAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST =
  "GETAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST";
export const CREATEAYURVVEDICOPDCOMPLAINTOCCUPATIONALHIST =
  "CREATEAYURVVEDICOPDCOMPLAINTOCCUPATIONALHIST";
export const UPDATEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST =
  "UPDATEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST";
export const DELETEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST =
  "DELETEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST";

export const GETAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST =
  "GETAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST";
export const CREATEAYURVVEDICOPDCOMPLAINTGYNECOLOGICHIST =
  "CREATEAYURVVEDICOPDCOMPLAINTGYNECOLOGICHIST";
export const UPDATEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST =
  "UPDATEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST";
export const DELETEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST =
  "DELETEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST";

export const GETAYURVEDICOPDCOMPLAINTOBSTETRICALHIST =
  "GETAYURVEDICOPDCOMPLAINTOBSTETRICALHIST";
export const CREATEAYURVVEDICOPDCOMPLAINTOBSTETRICALHIST =
  "CREATEAYURVVEDICOPDCOMPLAINTOBSTETRICALHIST";
export const UPDATEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST =
  "UPDATEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST";
export const DELETEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST =
  "DELETEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST";

export const GETAYURVEDICOPDEXAMGENERALLOOKHIST =
  "GETAYURVEDICOPDEXAMGENERALLOOKHIST";
export const CREATEAYURVVEDICOPDEXAMGENERALLOOKHIST =
  "CREATEAYURVVEDICOPDEXAMGENERALLOOKHIST";
export const UPDATEAYURVEDICOPDEXAMGENERALLOOKHIST =
  "UPDATEAYURVEDICOPDEXAMGENERALLOOKHIST";
export const DELETEAYURVEDICOPDEXAMGENERALLOOKHIST =
  "DELETEAYURVEDICOPDEXAMGENERALLOOKHIST";
export const GETAYURVEDICOPDEXAMGENERALBUILD =
  "GETAYURVEDICOPDEXAMGENERALBUILD";
export const CREATEAYURVVEDICOPDEXAMGENERALBUILD =
  "CREATEAYURVVEDICOPDEXAMGENERALBUILD";
export const UPDATEAYURVEDICOPDEXAMGENERALBUILD =
  "UPDATEAYURVEDICOPDEXAMGENERALBUILD";
export const DELETEAYURVEDICOPDEXAMGENERALBUILD =
  "DELETEAYURVEDICOPDEXAMGENERALBUILD";
export const GETAYURVEDICOPDEXAMGENERALNUTRITION =
  "GETAYURVEDICOPDEXAMGENERALNUTRITION";
export const CREATEAYURVVEDICOPDEXAMGENERALNUTRITION =
  "CREATEAYURVVEDICOPDEXAMGENERALNUTRITION";
export const UPDATEAYURVEDICOPDEXAMGENERALNUTRITION =
  "UPDATEAYURVEDICOPDEXAMGENERALNUTRITION";
export const DELETEAYURVEDICOPDEXAMGENERALNUTRITION =
  "DELETEAYURVEDICOPDEXAMGENERALNUTRITION";
export const GETAYURVEDICOPDEXAMGENERALANAEMIA =
  "GETAYURVEDICOPDEXAMGENERALANAEMIA";
export const CREATEAYURVVEDICOPDEXAMGENERALANAEMIA =
  "CREATEAYURVVEDICOPDEXAMGENERALANAEMIA";
export const UPDATEAYURVEDICOPDEXAMGENERALANAEMIA =
  "UPDATEAYURVEDICOPDEXAMGENERALANAEMIA";
export const DELETEAYURVEDICOPDEXAMGENERALANAEMIA =
  "DELETEAYURVEDICOPDEXAMGENERALANAEMIA";
export const GETAYURVEDICOPDEXAMGENERALNECKVEIN =
  "GETAYURVEDICOPDEXAMGENERALNECKVEIN";
export const CREATEAYURVVEDICOPDEXAMGENERALNECKVEIN =
  "CREATEAYURVVEDICOPDEXAMGENERALNECKVEIN";
export const UPDATEAYURVEDICOPDEXAMGENERALNECKVEIN =
  "UPDATEAYURVEDICOPDEXAMGENERALNECKVEIN";
export const DELETEAYURVEDICOPDEXAMGENERALNECKVEIN =
  "DELETEAYURVEDICOPDEXAMGENERALNECKVEIN";
export const GETAYURVEDICOPDEXAMGENERALLYMPHNODE =
  "GETAYURVEDICOPDEXAMGENERALLYMPHNODE";
export const CREATEAYURVVEDICOPDEXAMGENERALLYMPHNODE =
  "CREATEAYURVVEDICOPDEXAMGENERALLYMPHNODE";
export const UPDATEAYURVEDICOPDEXAMGENERALLYMPHNODE =
  "UPDATEAYURVEDICOPDEXAMGENERALLYMPHNODE";
export const DELETEAYURVEDICOPDEXAMGENERALLYMPHNODE =
  "DELETEAYURVEDICOPDEXAMGENERALLYMPHNODE";
export const GETAYURVEDICOPDEXAMGENERALOTHERFIELDS =
  "GETAYURVEDICOPDEXAMGENERALOTHERFIELDS";
export const CREATEAYURVVEDICOPDEXAMGENERALOTHERFIELDS =
  "CREATEAYURVVEDICOPDEXAMGENERALOTHERFIELDS";
export const UPDATEAYURVEDICOPDEXAMGENERALOTHERFIELDS =
  "UPDATEAYURVEDICOPDEXAMGENERALOTHERFIELDS";
export const DELETEAYURVEDICOPDEXAMGENERALOTHERFIELDS =
  "DELETEAYURVEDICOPDEXAMGENERALOTHERFIELDS";
export const GETAYURVEDICOPDEXAMASHTAVIDAPULSE =
  "GETAYURVEDICOPDEXAMASHTAVIDAPULSE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAPULSE =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAPULSE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAPULSE =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAPULSE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAPULSE =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAPULSE";
export const GETAYURVEDICOPDEXAMASHTAVIDATONGUE =
  "GETAYURVEDICOPDEXAMASHTAVIDATONGUE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDATONGUE =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDATONGUE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDATONGUE =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDATONGUE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDATONGUE =
  "DELETEAYURVEDICOPDEXAMASHTAVIDATONGUE";
export const GETAYURVEDICOPDEXAMASHTAVIDAPOOP =
  "GETAYURVEDICOPDEXAMASHTAVIDAPOOP";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAPOOP =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAPOOP";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAPOOP =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAPOOP";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAPOOP =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAPOOP";
export const GETAYURVEDICOPDEXAMASHTAVIDAURINE =
  "GETAYURVEDICOPDEXAMASHTAVIDAURINE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAURINE =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAURINE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAURINE =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAURINE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAURINE =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAURINE";
export const GETAYURVEDICOPDEXAMASHTAVIDAWORD =
  "GETAYURVEDICOPDEXAMASHTAVIDAWORD";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAWORD =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAWORD";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAWORD =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAWORD";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAWORD =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAWORD";
export const GETAYURVEDICOPDEXAMASHTAVIDATOUCH =
  "GETAYURVEDICOPDEXAMASHTAVIDATOUCH";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDATOUCH =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDATOUCH";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDATOUCH =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDATOUCH";
export const DELETEAYURVEDICOPDEXAMASHTAVIDATOUCH =
  "DELETEAYURVEDICOPDEXAMASHTAVIDATOUCH";
export const GETAYURVEDICOPDEXAMASHTAVIDAEYE =
  "GETAYURVEDICOPDEXAMASHTAVIDAEYE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAEYE =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAEYE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAEYE =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAEYE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAEYE =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAEYE";
export const GETAYURVEDICOPDEXAMASHTAVIDAAKRITA =
  "GETAYURVEDICOPDEXAMASHTAVIDAAKRITA";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAAKRITA =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAAKRITA";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAAKRITA =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAAKRITA";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAAKRITA =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAAKRITA";
export const GETAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA =
  "GETAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAOTHHERFILEDA =
  "CREATEAYURVVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA =
  "UPDATEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA =
  "DELETEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const GETAYURVEDICOPDEXAMDASHVIDAPHYSICAL =
  "GETAYURVEDICOPDEXAMDASHVIDAPHYSICAL";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAPHYSICAL =
  "CREATEAYURVVEDICOPDEXAMDASHVIDAPHYSICAL";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAPHYSICAL =
  "UPDATEAYURVEDICOPDEXAMDASHVIDAPHYSICAL";
export const DELETEAYURVEDICOPDEXAMDASHVIDAPHYSICAL =
  "DELETEAYURVEDICOPDEXAMDASHVIDAPHYSICAL";
export const GETAYURVEDICOPDEXAMDASHVIDAMENTAL =
  "GETAYURVEDICOPDEXAMDASHVIDAMENTAL";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAMENTAL =
  "CREATEAYURVVEDICOPDEXAMDASHVIDAMENTAL";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAMENTAL =
  "UPDATEAYURVEDICOPDEXAMDASHVIDAMENTAL";
export const DELETEAYURVEDICOPDEXAMDASHVIDAMENTAL =
  "DELETEAYURVEDICOPDEXAMDASHVIDAMENTAL";
export const GETAYURVEDICOPDEXAMDASHVIDASUBSTANCE =
  "GETAYURVEDICOPDEXAMDASHVIDASUBSTANCE";
export const CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCE =
  "CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCE";
export const UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCE =
  "UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCE";
export const DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCE =
  "DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCE";
export const GETAYURVEDICOPDEXAMDASHVIDACOMPACTION =
  "GETAYURVEDICOPDEXAMDASHVIDACOMPACTION";
export const CREATEAYURVVEDICOPDEXAMDASHVIDACOMPACTION =
  "CREATEAYURVVEDICOPDEXAMDASHVIDACOMPACTION";
export const UPDATEAYURVEDICOPDEXAMDASHVIDACOMPACTION =
  "UPDATEAYURVEDICOPDEXAMDASHVIDACOMPACTION";
export const DELETEAYURVEDICOPDEXAMDASHVIDACOMPACTION =
  "DELETEAYURVEDICOPDEXAMDASHVIDACOMPACTION";
export const GETAYURVEDICOPDEXAMDASHVIDAPERCEPTION =
  "GETAYURVEDICOPDEXAMDASHVIDAPERCEPTION";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAPERCEPTION =
  "CREATEAYURVVEDICOPDEXAMDASHVIDAPERCEPTION";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAPERCEPTION =
  "UPDATEAYURVEDICOPDEXAMDASHVIDAPERCEPTION";
export const DELETEAYURVEDICOPDEXAMDASHVIDAPERCEPTION =
  "DELETEAYURVEDICOPDEXAMDASHVIDAPERCEPTION";
export const GETAYURVEDICOPDEXAMDASHVIDASUITABILITY =
  "GETAYURVEDICOPDEXAMDASHVIDASUITABILITY";
export const CREATEAYURVVEDICOPDEXAMDASHVIDASUITABILITY =
  "CREATEAYURVVEDICOPDEXAMDASHVIDASUITABILITY";
export const UPDATEAYURVEDICOPDEXAMDASHVIDASUITABILITY =
  "UPDATEAYURVEDICOPDEXAMDASHVIDASUITABILITY";
export const DELETEAYURVEDICOPDEXAMDASHVIDASUITABILITY =
  "DELETEAYURVEDICOPDEXAMDASHVIDASUITABILITY";
export const GETAYURVEDICOPDEXAMDASHVIDASUBSTANCEE =
  "GETAYURVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCEE =
  "CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE =
  "UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE =
  "DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const GETAYURVEDICOPDEXAMDASHVIDADIETCARRY =
  "GETAYURVEDICOPDEXAMDASHVIDADIETCARRY";
export const CREATEAYURVVEDICOPDEXAMDASHVIDADIETCARRY =
  "CREATEAYURVVEDICOPDEXAMDASHVIDADIETCARRY";
export const UPDATEAYURVEDICOPDEXAMDASHVIDADIETCARRY =
  "UPDATEAYURVEDICOPDEXAMDASHVIDADIETCARRY";
export const DELETEAYURVEDICOPDEXAMDASHVIDADIETCARRY =
  "DELETEAYURVEDICOPDEXAMDASHVIDADIETCARRY";
export const GETAYURVEDICOPDEXAMDASHVIDADIETBURNING =
  "GETAYURVEDICOPDEXAMDASHVIDADIETBURNING";
export const CREATEAYURVVEDICOPDEXAMDASHVIDADIETBURNING =
  "CREATEAYURVVEDICOPDEXAMDASHVIDADIETBURNING";
export const UPDATEAYURVEDICOPDEXAMDASHVIDADIETBURNING =
  "UPDATEAYURVEDICOPDEXAMDASHVIDADIETBURNING";
export const DELETEAYURVEDICOPDEXAMDASHVIDADIETBURNING =
  "DELETEAYURVEDICOPDEXAMDASHVIDADIETBURNING";
export const GETAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER =
  "GETAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEPOWER =
  "CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER =
  "UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER =
  "DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const GETAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE =
  "GETAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEAGEE =
  "CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE =
  "UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE =
  "DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const GETAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS =
  "GETAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAOTHERFIELDS =
  "CREATEAYURVVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS =
  "UPDATEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const DELETEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS =
  "DELETEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const GETAYURVEDICOPDEXAMSROTASPRANAVAHA =
  "GETAYURVEDICOPDEXAMSROTASPRANAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASPRANAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASPRANAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASPRANAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASPRANAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASPRANAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASPRANAVAHA";
export const GETAYURVEDICOPDEXAMSROTASANNAVAHA =
  "GETAYURVEDICOPDEXAMSROTASANNAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASANNAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASANNAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASANNAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASANNAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASANNAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASANNAVAHA";
export const GETAYURVEDICOPDEXAMSROTASUDAKVAHA =
  "GETAYURVEDICOPDEXAMSROTASUDAKVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASUDAKVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASUDAKVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASUDAKVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASUDAKVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASUDAKVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASUDAKVAHA";
export const GETAYURVEDICOPDEXAMSROTASRASAVAHA =
  "GETAYURVEDICOPDEXAMSROTASRASAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASRASAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASRASAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASRASAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASRASAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASRASAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASRASAVAHA";
export const GETAYURVEDICOPDEXAMSROTASRAKTAVAHA =
  "GETAYURVEDICOPDEXAMSROTASRAKTAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASRAKTAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASRAKTAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASRAKTAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASRAKTAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASRAKTAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASRAKTAVAHA";
export const GETAYURVEDICOPDEXAMSROTASMAMSAVAHA =
  "GETAYURVEDICOPDEXAMSROTASMAMSAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMAMSAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASMAMSAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMAMSAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASMAMSAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMAMSAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASMAMSAVAHA";
export const GETAYURVEDICOPDEXAMSROTASMEDOVAHA =
  "GETAYURVEDICOPDEXAMSROTASMEDOVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMEDOVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASMEDOVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMEDOVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASMEDOVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMEDOVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASMEDOVAHA";
export const GETAYURVEDICOPDEXAMSROTASASTHIVAHA =
  "GETAYURVEDICOPDEXAMSROTASASTHIVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASASTHIVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASASTHIVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASASTHIVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASASTHIVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASASTHIVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASASTHIVAHA";
export const GETAYURVEDICOPDEXAMSROTASMAJJAVAHA =
  "GETAYURVEDICOPDEXAMSROTASMAJJAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMAJJAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASMAJJAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMAJJAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASMAJJAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMAJJAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASMAJJAVAHA";
export const GETAYURVEDICOPDEXAMSROTASSUKRAVAHA =
  "GETAYURVEDICOPDEXAMSROTASSUKRAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASSUKRAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASSUKRAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASSUKRAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASSUKRAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASSUKRAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASSUKRAVAHA";
export const GETAYURVEDICOPDEXAMSROTASMOOTRAVAHA =
  "GETAYURVEDICOPDEXAMSROTASMOOTRAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMOOTRAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASMOOTRAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMOOTRAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASMOOTRAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMOOTRAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASMOOTRAVAHA";
export const GETAYURVEDICOPDEXAMSROTASPURESHVAHA =
  "GETAYURVEDICOPDEXAMSROTASPURESHVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASPURESHVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASPURESHVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASPURESHVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASPURESHVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASPURESHVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASPURESHVAHA";
export const GETAYURVEDICOPDEXAMSROTASSWEDAVAHA =
  "GETAYURVEDICOPDEXAMSROTASSWEDAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASSWEDAVAHA =
  "CREATEAYURVVEDICOPDEXAMSROTASSWEDAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASSWEDAVAHA =
  "UPDATEAYURVEDICOPDEXAMSROTASSWEDAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASSWEDAVAHA =
  "DELETEAYURVEDICOPDEXAMSROTASSWEDAVAHA";
export const GETAYURVEDICOPDEXAMVIKRUTHIFIELDS =
  "GETAYURVEDICOPDEXAMVIKRUTHIFIELDS";
export const CREATEAYURVVEDICOPDEXAMVIKRUTHIFIELDS =
  "CREATEAYURVVEDICOPDEXAMVIKRUTHIFIELDS";
export const UPDATEAYURVEDICOPDEXAMVIKRUTHIFIELDS =
  "UPDATEAYURVEDICOPDEXAMVIKRUTHIFIELDS";
export const DELETEAYURVEDICOPDEXAMVIKRUTHIFIELDS =
  "DELETEAYURVEDICOPDEXAMVIKRUTHIFIELDS";
export const GETAYURVEDICOPDEXAMWEALTHFAULT = "GETAYURVEDICOPDEXAMWEALTHFAULT";
export const CREATEAYURVVEDICOPDEXAMWEALTHFAULT =
  "CREATEAYURVVEDICOPDEXAMWEALTHFAULT";
export const UPDATEAYURVEDICOPDEXAMWEALTHFAULT =
  "UPDATEAYURVEDICOPDEXAMWEALTHFAULT";
export const DELETEAYURVEDICOPDEXAMWEALTHFAULT =
  "DELETEAYURVEDICOPDEXAMWEALTHFAULT";
export const GETAYURVEDICOPDEXAMWEALTHDUSHYA =
  "GETAYURVEDICOPDEXAMWEALTHDUSHYA";
export const CREATEAYURVVEDICOPDEXAMWEALTHDUSHYA =
  "CREATEAYURVVEDICOPDEXAMWEALTHDUSHYA";
export const UPDATEAYURVEDICOPDEXAMWEALTHDUSHYA =
  "UPDATEAYURVEDICOPDEXAMWEALTHDUSHYA";
export const DELETEAYURVEDICOPDEXAMWEALTHDUSHYA =
  "DELETEAYURVEDICOPDEXAMWEALTHDUSHYA";
export const GETAYURVEDICOPDEXAMWEALTHFIRE = "GETAYURVEDICOPDEXAMWEALTHFIRE";
export const CREATEAYURVVEDICOPDEXAMWEALTHFIRE =
  "CREATEAYURVVEDICOPDEXAMWEALTHFIRE";
export const UPDATEAYURVEDICOPDEXAMWEALTHFIRE =
  "UPDATEAYURVEDICOPDEXAMWEALTHFIRE";
export const DELETEAYURVEDICOPDEXAMWEALTHFIRE =
  "DELETEAYURVEDICOPDEXAMWEALTHFIRE";
export const GETAYURVEDICOPDEXAMWEALTHAMA = "GETAYURVEDICOPDEXAMWEALTHAMA";
export const CREATEAYURVVEDICOPDEXAMWEALTHAMA =
  "CREATEAYURVVEDICOPDEXAMWEALTHAMA";
export const UPDATEAYURVEDICOPDEXAMWEALTHAMA =
  "UPDATEAYURVEDICOPDEXAMWEALTHAMA";
export const DELETEAYURVEDICOPDEXAMWEALTHAMA =
  "DELETEAYURVEDICOPDEXAMWEALTHAMA";
export const GETAYURVEDICOPDEXAMWEALTHSOURCES =
  "GETAYURVEDICOPDEXAMWEALTHSOURCES";
export const CREATEAYURVVEDICOPDEXAMWEALTHSOURCES =
  "CREATEAYURVVEDICOPDEXAMWEALTHSOURCES";
export const UPDATEAYURVEDICOPDEXAMWEALTHSOURCES =
  "UPDATEAYURVEDICOPDEXAMWEALTHSOURCES";
export const DELETEAYURVEDICOPDEXAMWEALTHSOURCES =
  "DELETEAYURVEDICOPDEXAMWEALTHSOURCES";
export const GETAYURVEDICOPDEXAMWEALTHFAULTYSOURCES =
  "GETAYURVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const CREATEAYURVVEDICOPDEXAMWEALTHFAULTYSOURCES =
  "CREATEAYURVVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const UPDATEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES =
  "UPDATEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const DELETEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES =
  "DELETEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const GETAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN =
  "GETAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const CREATEAYURVVEDICOPDEXAMWEALTHPLACEOFORIGIN =
  "CREATEAYURVVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const UPDATEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN =
  "UPDATEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const DELETEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN =
  "DELETEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const GETAYURVEDICOPDEXAMWEALTHFACTOR =
  "GETAYURVEDICOPDEXAMWEALTHFACTOR";
export const CREATEAYURVVEDICOPDEXAMWEALTHFACTOR =
  "CREATEAYURVVEDICOPDEXAMWEALTHFACTOR";
export const UPDATEAYURVEDICOPDEXAMWEALTHFACTOR =
  "UPDATEAYURVEDICOPDEXAMWEALTHFACTOR";
export const DELETEAYURVEDICOPDEXAMWEALTHFACTOR =
  "DELETEAYURVEDICOPDEXAMWEALTHFACTOR";

export const GETAYURVEDICOPDPANCHAKRMA = "GETAYURVEDICOPDPANCHAKRMA";
export const CREATEAYURVVEDICOPDPANCHAKRMA = "CREATEAYURVVEDICOPDPANCHAKRMA";
export const UPDATEAYURVEDICOPDPANCHAKRMA = "UPDATEAYURVEDICOPDPANCHAKRMA";
export const DELETEAYURVEDICOPDPANCHAKRMA = "DELETEAYURVEDICOPDPANCHAKRMA";

export const GETPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS =
  "GETPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS =
  "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS =
  "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY =
  "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY =
  "GETPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY =
  "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY =
  "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE =
  "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE =
  "GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE =
  "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE =
  "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET =
  "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET =
  "GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET =
  "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET =
  "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION =
  "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION =
  "GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION =
  "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION =
  "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY =
  "GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE =
  "GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY =
  "GETPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY =
  "GETPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE =
  "CREATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const GETPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE =
  "GETPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE =
  "DELETEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE =
  "UPDATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE =
  "GETPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY =
  "GETPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const GETPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM =
  "GETPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const GETPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES =
  "GETPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const GETPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT =
  "GETPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP =
  "GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONE =
  "GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const GETPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES =
  "GETPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const CREATEPEDIATRICCOMPLAINTPASTSYMPTOMS =
  "CREATEPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const GETPEDIATRICCOMPLAINTPASTSYMPTOMS =
  "GETPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const DELETEPEDIATRICCOMPLAINTPASTSYMPTOMS =
  "DELETEPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const UPDATEPEDIATRICCOMPLAINTPASTSYMPTOMS =
  "UPDATEPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const CREATEPEDIATRICCOMPLAINTPASTCOMORBIDITY =
  "CREATEPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const GETPEDIATRICCOMPLAINTPASTCOMORBIDITY =
  "GETPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const DELETEPEDIATRICCOMPLAINTPASTCOMORBIDITY =
  "DELETEPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const UPDATEPEDIATRICCOMPLAINTPASTCOMORBIDITY =
  "UPDATEPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTDIET =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const GETPEDIATRICOPDSETTINGCOMPLAINTDIET =
  "GETPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTDIET =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIET =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTAPPETITE =
  "GETPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const GETPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT =
  "GETPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const GETPEDIATRICOPDSETTINGCOMPLAINTBOWEL =
  "GETPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTBOWEL =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSLIP =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSLIP =
  "GETPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSLIP =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSLIP =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const GETPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK =
  "GETPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTNATURE =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTNATURE =
  "GETPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTNATURE =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTNATURE =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTRELETION =
  "CREATEPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const GETPEDIATRICOPDSETTINGCOMPLAINTRELETION =
  "GETPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTRELETION =
  "DELETEPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTRELETION =
  "UPDATEPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENT =
  "GETPEDIATRICOPDSETTINGPAINASSESSMENT";
export const GETALLPEDIATRICOPDSETTINGCOMPLAINT =
  "GETALLPEDIATRICOPDSETTINGCOMPLAINT";
export const GETALLPEDIATRICOPDSETTINGINVESTIGATION =
  "GETALLPEDIATRICOPDSETTINGINVESTIGATION";
export const CREATEPEDIATRICPAINASSESSMENTOPD =
  "CREATEPEDIATRICPAINASSESSMENTOPD";
export const GETPEDIATRICPAINASSESSMENTOPD = "GETPEDIATRICPAINASSESSMENTOPD";
export const DELETEPEDIATRICPAINASSESSMENTOPD =
  "DELETEPEDIATRICPAINASSESSMENTOPD";
export const UPDATEPEDIATRICPAINASSESSMENTOPD =
  "UPDATEPEDIATRICPAINASSESSMENTOPD";
export const CREATEPEDIATRICPAINASSESSMENTBODYCHARTOPD =
  "CREATEPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const GETPEDIATRICPAINASSESSMENTBODYCHARTOPD =
  "GETPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const DELETEPEDIATRICPAINASSESSMENTBODYCHARTOPD =
  "DELETEPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const UPDATEPEDIATRICPAINASSESSMENTBODYCHARTOPD =
  "UPDATEPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const CREATEPRESENTCOPLAINTSSYMTOMS = "CREATEPRESENTCOPLAINTSSYMTOMS";
export const GETPRESENTCOPLAINTSSYMTOMS = "GETPRESENTCOPLAINTSSYMTOMS";
export const DELETEPRESENTCOPLAINTSSYMTOMS = "DELETEPRESENTCOPLAINTSSYMTOMS";
export const UPDATEPRESENTCOPLAINTSSYMTOMS = "UPDATEPRESENTCOPLAINTSSYMTOMS";
export const CREATEPRESENTCOPLAINTSCOMORBIDITY =
  "CREATEPRESENTCOPLAINTSCOMORBIDITY";
export const GETPRESENTCOPLAINTSCOMORBIDITY = "GETPRESENTCOPLAINTSCOMORBIDITY";
export const DELETEPRESENTCOPLAINTSCOMORBIDITY =
  "DELETEPRESENTCOPLAINTSCOMORBIDITY";
export const UPDATEPRESENTCOPLAINTSCOMORBIDITY =
  "UPDATEPRESENTCOPLAINTSCOMORBIDITY";
export const CREATEPEDIATRICCOMPLAINTGENERALENQUIRY =
  "CREATEPEDIATRICCOMPLAINTGENERALENQUIRY";
export const GETPEDIATRICCOMPLAINTGENERALENQUIRY =
  "GETPEDIATRICCOMPLAINTGENERALENQUIRY";
export const DELETEPEDIATRICCOMPLAINTGENERALENQUIRY =
  "DELETEPEDIATRICCOMPLAINTGENERALENQUIRY";
export const UPDATEPEDIATRICCOMPLAINTGENERALENQUIRY =
  "UPDATEPEDIATRICCOMPLAINTGENERALENQUIRY";
export const CREATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY =
  "CREATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const GETPEDIATRICCOMPLAINTSYSTEMICENQUIRY =
  "GETPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const DELETEPEDIATRICCOMPLAINTSYSTEMICENQUIRY =
  "DELETEPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const UPDATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY =
  "UPDATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const CREATEPEDIATRICCOMPLAINTANTENATALILLNESS =
  "CREATEPEDIATRICCOMPLAINTANTENATALILLNESS";
export const GETPEDIATRICCOMPLAINTANTENATALILLNESS =
  "GETPEDIATRICCOMPLAINTANTENATALILLNESS";
export const DELETEPEDIATRICCOMPLAINTANTENATALILLNESS =
  "DELETEPEDIATRICCOMPLAINTANTENATALILLNESS";
export const UPDATEPEDIATRICCOMPLAINTANTENATALILLNESS =
  "UPDATEPEDIATRICCOMPLAINTANTENATALILLNESS";
export const CREATEPEDIATRICCOMPLAINTANTENATALINFECTIONS =
  "CREATEPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const GETPEDIATRICCOMPLAINTANTENATALINFECTIONS =
  "GETPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const DELETEPEDIATRICCOMPLAINTANTENATALINFECTIONS =
  "DELETEPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const UPDATEPEDIATRICCOMPLAINTANTENATALINFECTIONS =
  "UPDATEPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const CREATEPEDIATRICCOMPLAINTANTENATALPREGANANCY =
  "CREATEPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const GETPEDIATRICCOMPLAINTANTENATALPREGANANCY =
  "GETPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const DELETEPEDIATRICCOMPLAINTANTENATALPREGANANCY =
  "DELETEPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const UPDATEPEDIATRICCOMPLAINTANTENATALPREGANANCY =
  "UPDATEPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const CREATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE =
  "CREATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const GETPEDIATRICCOMPLAINTNATALDELIVERYTYPE =
  "GETPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const DELETEPEDIATRICCOMPLAINTNATALDELIVERYTYPE =
  "DELETEPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const UPDATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE =
  "UPDATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const CREATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY =
  "CREATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const GETPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY =
  "GETPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const DELETEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY =
  "DELETEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY =
  "UPDATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const CREATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM =
  "CREATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const GETPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM =
  "GETPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const DELETEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM =
  "DELETEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM =
  "UPDATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const CREATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES =
  "CREATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const GETPEDIATRICCOMPLAINTPOSTNATALPROCEDURES =
  "GETPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const DELETEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES =
  "DELETEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES =
  "UPDATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const CREATEPEDIATRICCOMPLAINTPOSTNATAL =
  "CREATEPEDIATRICCOMPLAINTPOSTNATAL";
export const GETPEDIATRICCOMPLAINTPOSTNATAL = "GETPEDIATRICCOMPLAINTPOSTNATAL";
export const DELETEPEDIATRICCOMPLAINTPOSTNATAL =
  "DELETEPEDIATRICCOMPLAINTPOSTNATAL";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATAL =
  "UPDATEPEDIATRICCOMPLAINTPOSTNATAL";
export const CREATEPEDIATRICCOMPLAINTNATALHISTORY =
  "CREATEPEDIATRICCOMPLAINTNATALHISTORY";
export const GETPEDIATRICCOMPLAINTNATALHISTORY =
  "GETPEDIATRICCOMPLAINTNATALHISTORY";
export const DELETEPEDIATRICCOMPLAINTNATALHISTORY =
  "DELETEPEDIATRICCOMPLAINTNATALHISTORY";
export const UPDATEPEDIATRICCOMPLAINTNATALHISTORY =
  "UPDATEPEDIATRICCOMPLAINTNATALHISTORY";
export const CREATECOMPLAINTSYMPTOMSASSOCIATED =
  "CREATECOMPLAINTSYMPTOMSASSOCIATED";
export const GETCOMPLAINTSYMPTOMSASSOCIATED = "GETCOMPLAINTSYMPTOMSASSOCIATED";
export const DELETECOMPLAINTSYMPTOMSASSOCIATED =
  "DELETECOMPLAINTSYMPTOMSASSOCIATED";
export const UPDATECOMPLAINTSYMPTOMSASSOCIATED =
  "UPDATECOMPLAINTSYMPTOMSASSOCIATED";
export const CREATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT =
  "CREATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const GETPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT =
  "GETPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const DELETEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT =
  "DELETEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const UPDATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT =
  "UPDATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const CREATEPEDIATRICCOMPLAINTFEEDINGHISTORY =
  "CREATEPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const GETPEDIATRICCOMPLAINTFEEDINGHISTORY =
  "GETPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const DELETEPEDIATRICCOMPLAINTFEEDINGHISTORY =
  "DELETEPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const UPDATEPEDIATRICCOMPLAINTFEEDINGHISTORY =
  "UPDATEPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const CREATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY =
  "CREATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const GETPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY =
  "GETPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const DELETEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY =
  "DELETEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const UPDATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY =
  "UPDATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const CREATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY =
  "CREATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const GETPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY =
  "GETPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const DELETEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY =
  "DELETEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY =
  "UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const CREATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES =
  "CREATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const GETPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES =
  "GETPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const DELETEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES =
  "DELETEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES =
  "UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const CREATEPEDIATRICCOMPLAINTPASTILLNESS =
  "CREATEPEDIATRICCOMPLAINTPASTILLNESS";
export const GETPEDIATRICCOMPLAINTPASTILLNESS =
  "GETPEDIATRICCOMPLAINTPASTILLNESS";
export const DELETEPEDIATRICCOMPLAINTPASTILLNESS =
  "DELETEPEDIATRICCOMPLAINTPASTILLNESS";
export const UPDATEPEDIATRICCOMPLAINTPASTILLNESS =
  "UPDATEPEDIATRICCOMPLAINTPASTILLNESS";
export const GETPHYSIOTHERAPY = "GETPHYSIOTHERAPY";
export const CREATEPHYSIOTHERAPY = "CREATEPHYSIOTHERAPY";
export const UPDATEPHYSIOTHERAPYBYID = "UPDATEPHYSIOTHERAPYBYID";
export const DELETEPHYSIOTHERAPY = "DELETEPHYSIOTHERAPY";
export const GETPHYSIOTHERAPYSEVERITY = " GETPHYSIOTHERAPYSEVERITY";
export const CREATEPHYSIOTHERAPYSEVERITY = "CREATEPHYSIOTHERAPYSEVERITY";
export const UPDATEPHYSIOTHERAPYSEVERITYBYID =
  "UPDATEPHYSIOTHERAPYSEVERITYBYID";
export const DELETEPHYSIOTHERAPYSEVERITY = "DELETEPHYSIOTHERAPYSEVERITY";
export const GETPAINNATURE = "GETPAINNATURE";
export const CREATEPAINNATURE = "CREATEPAINNATURE";
export const UPDATEPHYSIOTHERAPYPAINNATUREBYID =
  "UPDATEPHYSIOTHERAPYPAINNATUREBYID";
export const DELETEPAINNATURE = "DELETEPAINNATURE";
export const GETPHYSIOTHERAPYPAINONSET = "GETPHYSIOTHERAPYPAINONSET";
export const CREATEPAINONSET = "CREATEPAINONSET";
export const UPDATEPHYSIOTHERAPPAINONSETBYID =
  "UPDATEPHYSIOTHERAPPAINONSETBYID";
export const DELETEPAINONSET = "DELETEPAINONSET";
export const GETPHYSIOTHERAPYDIURNAL = "GETPHYSIOTHERAPYDIURNAL";
export const CREATEPHYSIOTHERAPYDIURNAL = "CREATEPHYSIOTHERAPYDIURNAL";
export const UPDATEPHYSIOTHERAPYDIURNALBYID = "UPDATEPHYSIOTHERAPYDIURNALBYID";
export const DELETEPHYSIOTHERAPYDIURNAL = "DELETEPHYSIOTHERAPYDIURNAL";
export const GETPHYSIOTHERAPYTESTTYPE = "GETPHYSIOTHERAPYTESTTYPE";
export const CREATEPHYSIOTHERAPYTESTTYPE = "CREATEPHYSIOTHERAPYTESTTYPE";
export const UPDATEPHYSIOTHERAPYTESTTYPEBYID =
  "UPDATEPHYSIOTHERAPYTESTTYPEBYID";
export const DELETEPHYSIOTHERAPYTESTTYPE = "DELETEPHYSIOTHERAPYTESTTYPE";
export const GETPHYSIOTHERAPYTEST = "GETPHYSIOTHERAPYTEST";
export const CREATEPHYSIOTHERAPYTEST = "CREATEPHYSIOTHERAPYTEST";
export const UPDATEPHYSIOTHERAPYTESTBYID = "UPDATEPHYSIOTHERAPYTESTBYID";
export const DELETEPHYSIOTHERAPYTYPE = "DELETEPHYSIOTHERAPYTYPE";
export const GETPHYSIOTHERAPYTESTINVESTIGATION =
  "GETPHYSIOTHERAPYTESTINVESTIGATION";
export const CREATEPHYSIOTHERAPYTESTINVESTIGATION =
  "CREATEPHYSIOTHERAPYTESTINVESTIGATION";
export const UPDATEPHYSIOTHERAPYTESTTINVESTIGATIONBYID =
  "UPDATEPHYSIOTHERAPYTESTTINVESTIGATIONBYID";
export const DELETEPHYSIOTHERAPYTYPETINVESTIGATION =
  "DELETEPHYSIOTHERAPYTYPETINVESTIGATION ";
export const GETPHYSIOTHERAPYTDIAGNOSIS = "GETPHYSIOTHERAPYTDIAGNOSIS";
export const CREATEPHYSIOTHERAPYDIAGNOSIS = "CREATEPHYSIOTHERAPYDIAGNOSIS";
export const UPDATEPHYSIOTHERAPYDIAGNOSISBYID =
  "UPDATEPHYSIOTHERAPYDIAGNOSISBYID";
export const DELETEPHYSIOTHERAPYDIAGNOSIS = "DELETEPHYSIOTHERAPYDIAGNOSIS ";
export const GETPHYSIOTHERAPYTPROGNOSIS = "GETPHYSIOTHERAPYTPROGNOSIS";
export const CREATEPHYSIOTHERAPYPROGNOSIS = "CREATEPHYSIOTHERAPYPROGNOSIS";
export const UPDATEPHYSIOTHERAPYPROGNOSISBYID =
  "UPDATEPHYSIOTHERAPYPROGNOSISBYID";
export const DELETEPHYSIOTHERAPYPROGNOSIS = "DELETEPHYSIOTHERAPYPROGNOSIS ";
export const GETPHYSIOTHERAPYFREQUENCY = "GETPHYSIOTHERAPYFREQUENCY";
export const CREATEPHYSIOTHERAPYFREQUENCY = "CREATEPHYSIOTHERAPYFREQUENCY";
export const UPDATEPHYSIOTHERAPYFREQUENCYBYID =
  "UPDATEPHYSIOTHERAPYFREQUENCYBYID";
export const DELETEPHYSIOTHERAPYFREQUENCY = "DELETEPHYSIOTHERAPYFREQUENCY ";
export const GETPHYSIOTHERAPYDUTYCYCLE = "GETPHYSIOTHERAPYDUTYCYCLE";
export const CREATEPHYSIOTHERAPYDUTYCYCLE = "CREATEPHYSIOTHERAPYDUTYCYCLE";
export const UPDATEPHYSIOTHERAPYDUTYCYCLEBYID =
  "UPDATEPHYSIOTHERAPYDUTYCYCLEBYID";
export const DELETEPHYSIOTHERAPYDUTYCYCLE = "DELETEPHYSIOTHERAPYDUTYCYCLE ";
export const GETPHYSIOTHERAPYWARMING = "GETPHYSIOTHERAPYWARMING";
export const CREATEPHYSIOTHERAPYWARMING = "CREATEPHYSIOTHERAPYWARMING";
export const UPDATEPHYSIOTHERAPYWARMINGBYID = "UPDATEPHYSIOTHERAPYWARMINGBYID";
export const DELETEPHYSIOTHERAPYWARMING = "DELETEPHYSIOTHERAPYWARMING ";
export const GETPHYSIOTHERAPYINTENSITY = "GETPHYSIOTHERAPYINTENSITY";
export const CREATEPHYSIOTHERAPYINTENSITY = "CREATEPHYSIOTHERAPYINTENSITY";
export const UPDATEPHYSIOTHERAPYINTENSITYBYID =
  "UPDATEPHYSIOTHERAPYINTENSITYBYID";
export const DELETEPHYSIOTHERAPYINTENSITY = "DELETEPHYSIOTHERAPYINTENSITY ";
export const GETPHYSIOTHERAPYOPDOUT = "GETPHYSIOTHERAPYOPDOUT";
export const CREATEPHYSIOTHERAPYOPDOUT = "CREATEPHYSIOTHERAPYOPDOUT";
export const GETPHYSIOTHERAPYOPDOUTBODYCHARTTYPE =
  "GETPHYSIOTHERAPYOPDOUTBODYCHARTTYPE";
export const CREATEPHYSIOTHERAPYOPDOUTBODYCHARTTYPE =
  "CREATEPHYSIOTHERAPYOPDOUTBODYCHARTTYPE";
export const UPDATEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD =
  "UPDATEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD";
export const DELETEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD =
  "DELETEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD";
export const UPDATEPHYSIOTHERAPYPAINASSESSMENTOPDOUT =
  "UPDATEPHYSIOTHERAPYPAINASSESSMENTOPDOUT";
export const DELETEPHYSIOTHERAPYPAINASSESSMENTOPD =
  "DELETEPHYSIOTHERAPYPAINASSESSMENTOPD";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATION =
  "GETPHYSIOTHERAPYOPDOUTEXAMINATION";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATION =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATION";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATION =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATION";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATION =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATION";
export const GETPHYSIOTHERAPYOPDEXAMINATIONCERVICALSPINE =
  "GETPHYSIOTHERAPYOPDEXAMINATIONCERVICALSPINE";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE";
export const GETPHYSIOTHERAPYOPDEXAMINATIONTEMROMANDIBULARJOINT =
  "GETPHYSIOTHERAPYOPDEXAMINATIONTEMROMANDIBULARJOINT";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT";
export const GETPHYSIOTHERAPYOPDEXAMINATIONSHOLDER =
  "GETPHYSIOTHERAPYOPDEXAMINATIONSHOLDER";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER";
export const GETPHYSIOTHERAPYOPDEXAMINATIONELBOW =
  "GETPHYSIOTHERAPYOPDEXAMINATIONELBOW";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW";
export const GETPHYSIOTHERAPYOPDEXAMINATIONWRISTANDFINGERS =
  "GETPHYSIOTHERAPYOPDEXAMINATIONWRISTANDFINGERS";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS";
export const GETPHYSIOTHERAPYOPDEXAMINATIONTHORACICSPINE =
  "GETPHYSIOTHERAPYOPDEXAMINATIONTHORACICSPINE";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE";
export const GETPHYSIOTHERAPYOPDEXAMINATIONHIP =
  "GETPHYSIOTHERAPYOPDEXAMINATIONHIP";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP";
export const GETPHYSIOTHERAPYOPDEXAMINATIONKNEE =
  "GETPHYSIOTHERAPYOPDEXAMINATIONKNEE";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE";
export const GETPHYSIOTHERAPYOPDEXAMINATIONLEANDFOOT =
  "GETPHYSIOTHERAPYOPDEXAMINATIONLEANDFOOT";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT";
export const GETPHYSIOTHERAPYOPDEXAMINATIONDEEPTENDENREFLEXES =
  "GETPHYSIOTHERAPYOPDEXAMINATIONDEEPTENDENREFLEXES";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES";
export const GETPHYSIOTHERAPYOPDEXAMINATIONSUPERFICIALREFLEXES =
  "GETPHYSIOTHERAPYOPDEXAMINATIONSUPERFICIALREFLEXES";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE =
  "GETPHYSIOTHERAPYOPDEXAMINATIONLUMBERSPINE";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY =
  "GETPHYSIOTHERAPYOPDEXAMINATIONSENSORY";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION =
  "GETPHYSIOTHERAPYOPDEXAMINATIONHIGHERFUNCTION";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE =
  "GETPHYSIOTHERAPYOPDEXAMINATIONCARNIALNERVE";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION =
  "GETPHYSIOTHERAPYOPDEXAMINATIONCOORDINATION";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE =
  "GETPHYSIOTHERAPYOPDEXAMINATIONTESTCERVICLESPINE";
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE =
  "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE =
  "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE =
  "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE";
export const GETPHYSIOTHERAPYOPDOUTDIAGNOSIS =
  "GETPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const CREATEPHYSIOTHERAPYOPDOUTDIAGNOSIS =
  "CREATEPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const UPDATEPHYSIOTHERAPYOPDOUTDIAGNOSIS =
  "UPDATEPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const DELETEPHYSIOTHERAPYOPDOUTDIAGNOSIS =
  "DELETEPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const GETPHYSIOTHERAPYOPDOUTPROGNOSIS =
  "GETPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const CREATEPHYSIOTHERAPYOPDOUTPROGNOSIS =
  "CREATEPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const UPDATEPHYSIOTHERAPYOPDOUTPROGNOSIS =
  "UPDATEPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const DELETEPHYSIOTHERAPYOPDOUTPROGNOSIS =
  "DELETEPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const GETPHYSIOTHERAPYOPDOUTTREATMENT =
  "GETPHYSIOTHERAPYOPDOUTTREATMENT";
export const CREATEPHYSIOTHERAPYOPDOUTTREATMENT =
  "CREATEPHYSIOTHERAPYOPDOUTTREATMENT";
export const UPDATEPHYSIOTHERAPYOPDOUTTREATMENT =
  "UPDATEPHYSIOTHERAPYOPDOUTTREATMENT";
export const DELETEPHYSIOTHERAPYOPDOUTTREATMENT =
  "DELETEPHYSIOTHERAPYOPDOUTTREATMENT";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORY =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORY";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORY =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORY";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORY =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORY";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORY =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORY";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYSLIP =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYNATURE =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY =
  "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY =
  "GETPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY =
  "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY =
  "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const CREATEPEDIATRICCOMPLAINTFAMILYHISTORY =
  "CREATEPEDIATRICCOMPLAINTFAMILYHISTORY";
export const GETPEDIATRICCOMPLAINTFAMILYHISTORY =
  "GETPEDIATRICCOMPLAINTFAMILYHISTORY";
export const DELETEPEDIATRICCOMPLAINTFAMILYHISTORY =
  "DELETEPEDIATRICCOMPLAINTFAMILYHISTORY";
export const UPDATEPEDIATRICCOMPLAINTFAMILYHISTORY =
  "UPDATEPEDIATRICCOMPLAINTFAMILYHISTORY";
export const CREATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY =
  "CREATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const GETPEDIATRICCOMPLAINTSYMPTOMSHISTORY =
  "GETPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const DELETEPEDIATRICCOMPLAINTSYMPTOMSHISTORY =
  "DELETEPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const UPDATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY =
  "UPDATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const CREATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY =
  "CREATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const GETPEDIATRICCOMPLAINTCOMORBIDITYHISTORY =
  "GETPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const DELETEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY =
  "DELETEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const UPDATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY =
  "UPDATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const CREATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY =
  "CREATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";
export const GETPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY =
  "GETPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";
export const DELETEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY =
  "DELETEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";
export const UPDATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY =
  "UPDATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";

export const CREATEPEDIATRICEXAMINATION = "CREATEPEDIATRICEXAMINATION";
export const GETPEDIATRICEXAMINATION = "GETPEDIATRICEXAMINATION";
export const DELETEPEDIATRICEXAMINATION = "DELETEPEDIATRICEXAMINATION";
export const UPDATEPEDIATRICEXAMINATION = "UPDATEPEDIATRICEXAMINATION";

export const CREATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE =
  "CREATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";
export const GETPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE =
  "GETPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";
export const DELETEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE =
  "DELETEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";
export const UPDATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE =
  "UPDATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";

export const CREATEPEDIATRICEXAMINATIONNUTRITION =
  "CREATEPEDIATRICEXAMINATIONNUTRITION";
export const GETPEDIATRICEXAMINATIONNUTRITION =
  "GETPEDIATRICEXAMINATIONNUTRITION";
export const DELETEPEDIATRICEXAMINATIONNUTRITION =
  "DELETEPEDIATRICEXAMINATIONNUTRITION";
export const UPDATEPEDIATRICEXAMINATIONNUTRITION =
  "UPDATEPEDIATRICEXAMINATIONNUTRITION";
export const CREATEPEDIATRICEXAMINATIONANAEMIA =
  "CREATEPEDIATRICEXAMINATIONANAEMIA";
export const GETPEDIATRICEXAMINATIONANAEMIA = "GETPEDIATRICEXAMINATIONANAEMIA";
export const DELETEPEDIATRICEXAMINATIONANAEMIA =
  "DELETEPEDIATRICEXAMINATIONANAEMIA";
export const UPDATEPEDIATRICEXAMINATIONANAEMIA =
  "UPDATEPEDIATRICEXAMINATIONANAEMIA";
export const CREATEPEDIATRICEXAMINATIONNECKVEIN =
  "CREATEPEDIATRICEXAMINATIONNECKVEIN";
export const GETPEDIATRICEXAMINATIONNECKVEIN =
  "GETPEDIATRICEXAMINATIONNECKVEIN";
export const DELETEPEDIATRICEXAMINATIONNECKVEIN =
  "DELETEPEDIATRICEXAMINATIONNECKVEIN";
export const UPDATEPEDIATRICEXAMINATIONNECKVEIN =
  "UPDATEPEDIATRICEXAMINATIONNECKVEIN";
export const CREATEPEDIATRICEXAMINATIONLYMPHNODES =
  "CREATEPEDIATRICEXAMINATIONLYMPHNODES";
export const GETPEDIATRICEXAMINATIONLYMPHNODES =
  "GETPEDIATRICEXAMINATIONLYMPHNODES";
export const DELETEPEDIATRICEXAMINATIONLYMPHNODES =
  "DELETEPEDIATRICEXAMINATIONLYMPHNODES";
export const UPDATEPEDIATRICEXAMINATIONLYMPHNODES =
  "UPDATEPEDIATRICEXAMINATIONLYMPHNODES";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION =
  "CREATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const GETPEDIATRICOPDSETTINGEXAMINATIONNUTRITION =
  "GETPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION =
  "DELETEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION =
  "UPDATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA =
  "CREATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const GETPEDIATRICOPDSETTINGEXAMINATIONANAEMIA =
  "GETPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA =
  "DELETEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA =
  "UPDATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN =
  "CREATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const GETPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN =
  "GETPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN =
  "DELETEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN =
  "UPDATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES =
  "CREATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const GETPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES =
  "GETPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES =
  "DELETEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES =
  "UPDATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const CREATEPEDIATRICEXAMINATIONVITALS =
  "CREATEPEDIATRICEXAMINATIONVITALS";
export const GETPEDIATRICEXAMINATIONVITALS = "GETPEDIATRICEXAMINATIONVITALS";
export const DELETEPEDIATRICEXAMINATIONVITALS =
  "DELETEPEDIATRICEXAMINATIONVITALS";
export const UPDATEPEDIATRICEXAMINATIONVITALS =
  "UPDATEPEDIATRICEXAMINATIONVITALS";

export const CREATEPEDIATRICEXAMINATIONGENERALAPPEARANCE =
  "CREATEPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const GETPEDIATRICEXAMINATIONGENERALAPPEARANCE =
  "GETPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const DELETEPEDIATRICEXAMINATIONGENERALAPPEARANCE =
  "DELETEPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const UPDATEPEDIATRICEXAMINATIONGENERALAPPEARANCE =
  "UPDATEPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const CREATEPEDIATRICEXAMINATIONSKIN = "CREATEPEDIATRICEXAMINATIONSKIN";
export const GETPEDIATRICEXAMINATIONSKIN = "GETPEDIATRICEXAMINATIONSKIN";
export const DELETEPEDIATRICEXAMINATIONSKIN = "DELETEPEDIATRICEXAMINATIONSKIN";
export const UPDATEPEDIATRICEXAMINATIONSKIN = "UPDATEPEDIATRICEXAMINATIONSKIN";
export const CREATEPEDIATRICEXAMINATIONHEENT =
  "CREATEPEDIATRICEXAMINATIONHEENT";
export const GETPEDIATRICEXAMINATIONHEENT = "GETPEDIATRICEXAMINATIONHEENT";
export const DELETEPEDIATRICEXAMINATIONHEENT =
  "DELETEPEDIATRICEXAMINATIONHEENT";
export const UPDATEPEDIATRICEXAMINATIONHEENT =
  "UPDATEPEDIATRICEXAMINATIONHEENT";
export const CREATEPEDIATRICEXAMINATIONCHEST =
  "CREATEPEDIATRICEXAMINATIONCHEST";
export const GETPEDIATRICEXAMINATIONCHEST = "GETPEDIATRICEXAMINATIONCHEST";
export const DELETEPEDIATRICEXAMINATIONCHEST =
  "DELETEPEDIATRICEXAMINATIONCHEST";
export const UPDATEPEDIATRICEXAMINATIONCHEST =
  "UPDATEPEDIATRICEXAMINATIONCHEST";
export const CREATEPEDIATRICEXAMINATIONABDOMEN =
  "CREATEPEDIATRICEXAMINATIONABDOMEN";
export const GETPEDIATRICEXAMINATIONABDOMEN = "GETPEDIATRICEXAMINATIONABDOMEN";
export const DELETEPEDIATRICEXAMINATIONABDOMEN =
  "DELETEPEDIATRICEXAMINATIONABDOMEN";
export const UPDATEPEDIATRICEXAMINATIONABDOMEN =
  "UPDATEPEDIATRICEXAMINATIONABDOMEN";
export const CREATEPEDIATRICEXAMINATIONMSK = "CREATEPEDIATRICEXAMINATIONMSK";
export const GETPEDIATRICEXAMINATIONMSK = "GETPEDIATRICEXAMINATIONMSK";
export const DELETEPEDIATRICEXAMINATIONMSK = "DELETEPEDIATRICEXAMINATIONMSK";
export const UPDATEPEDIATRICEXAMINATIONMSK = "UPDATEPEDIATRICEXAMINATIONMSK";
export const CREATEPEDIATRICEXAMINATIONNEURO =
  "CREATEPEDIATRICEXAMINATIONNEURO";
export const GETPEDIATRICEXAMINATIONNEURO = "GETPEDIATRICEXAMINATIONNEURO";
export const DELETEPEDIATRICEXAMINATIONNEURO =
  "DELETEPEDIATRICEXAMINATIONNEURO";
export const UPDATEPEDIATRICEXAMINATIONNEURO =
  "UPDATEPEDIATRICEXAMINATIONNEURO";
export const CREATEOPDOUTPEDIATRICVACCINE = "CREATEOPDOUTPEDIATRICVACCINE";
export const GETOPDOUTPEDIATRICVACCINE = "GETOPDOUTPEDIATRICVACCINE";
export const UPDATEOPDOUTPEDIATRICVACCINE = "UPDATEOPDOUTPEDIATRICVACCINE";
export const DELETEOPDOUTPEDIATRICVACCINE = "DELETEOPDOUTPEDIATRICVACCINE";
export const CREATEOPDOUTPEDIATRICDIETCHART = "CREATEOPDOUTPEDIATRICDIETCHART";
export const GETOPDOUTPEDIATRICDIETCHART = "GETOPDOUTPEDIATRICDIETCHART";
export const UPDATEOPDOUTPEDIATRICDIETCHART = "UPDATEOPDOUTPEDIATRICDIETCHART";
export const DELETEOPDOUTPEDIATRICDIETCHART = "DELETEOPDOUTPEDIATRICDIETCHART";
export const CREATEOPDOUTPEDIATRICDIETCHARTSELECTION =
  "CREATEOPDOUTPEDIATRICDIETCHARTSELECTION";
export const GETOPDOUTPEDIATRICDIETCHARTSELECTION =
  "GETOPDOUTPEDIATRICDIETCHARTSELECTION";
export const UPDATEOPDOUTPEDIATRICDIETCHARTSELECTION =
  "UPDATEOPDOUTPEDIATRICDIETCHARTSELECTION";
export const DELETEOPDOUTPEDIATRICDIETCHARTSELECTION =
  "DELETEOPDOUTPEDIATRICDIETCHARTSELECTION";
export const CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT =
  "CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const GETOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT =
  "GETOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT =
  "UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT =
  "DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIET =
  "CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const GETOPDOUTPEDIATRICDIETCHARTDAILYDIET =
  "GETOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIET =
  "UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIET =
  "DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE =
  "CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const GETOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE =
  "GETOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE =
  "UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE =
  "DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const CREATEOPDOUTDIETCHARTPRINT = "CREATEOPDOUTDIETCHARTPRINT";
export const GETOPDOUTDIETCHARTPRINT = "GETOPDOUTDIETCHARTPRINT";
export const UPDATEOPDOUTDIETCHARTPRINT = "UPDATEOPDOUTDIETCHARTPRINT";
export const DELETEOPDOUTDIETCHARTPRINT = "DELETEOPDOUTDIETCHARTPRINT";
export const CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE =
  "CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const GETOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE =
  "GETOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE =
  "UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE =
  "DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const CREATEOPDOUTEXERCISEPRINT = "CREATEOPDOUTEXERCISEPRINT";
export const GETOPDOUTEXERCISEPRINT = "GETOPDOUTEXERCISEPRINT";
export const UPDATEOPDOUTEXERCISEPRINT = "UPDATEOPDOUTEXERCISEPRINT";
export const DELETEOPDOUTEXERCISEPRINT = "DELETEOPDOUTEXERCISEPRINT";
export const CREATEOPDOUTEXERCISE = "CREATEOPDOUTEXERCISE";
export const GETOPDOUTEXERCISE = "GETOPDOUTEXERCISE";
export const UPDATEOPDOUTEXERCISE = "UPDATEOPDOUTEXERCISE";
export const DELETEOPDOUTEXERCISE = "DELETEOPDOUTEXERCISE";
export const CREATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM =
  "CREATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const GETOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM =
  "GETOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const UPDATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM =
  "UPDATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const DELETEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM =
  "DELETEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const CREATEOPDOUTDENTALASSOCIATEDSYMPTOM =
  "CREATEOPDOUTDENTALASSOCIATEDSYMPTOM";
export const GETOPDOUTDENTALASSOCIATEDSYMPTOM =
  "GETOPDOUTDENTALASSOCIATEDSYMPTOM";
export const UPDATEOPDOUTDENTALASSOCIATEDSYMPTOM =
  "UPDATEOPDOUTDENTALASSOCIATEDSYMPTOM";
export const DELETEOPDOUTDENTALASSOCIATEDSYMPTOM =
  "DELETEOPDOUTDENTALASSOCIATEDSYMPTOM";
export const CREATEOPDOUTDENTALPRESENTILLNESSHISTORY =
  "CREATEOPDOUTDENTALPRESENTILLNESSHISTORY";
export const GETOPDOUTDENTALPRESENTILLNESSHISTORY =
  "GETOPDOUTDENTALPRESENTILLNESSHISTORY";
export const UPDATEOPDOUTDENTALPRESENTILLNESSHISTORY =
  "UPDATEOPDOUTDENTALPRESENTILLNESSHISTORY";
export const DELETEOPDOUTDENTALPRESENTILLNESSHISTORY =
  "DELETEOPDOUTDENTALPRESENTILLNESSHISTORY";
export const GETDENTALCOMPLAINTCHILDILLNESS = "GETDENTALCOMPLAINTCHILDILLNESS";
export const CREATEDENTALCOMPLAINTCHILDILLNESS =
  "CREATEDENTALCOMPLAINTCHILDILLNESS";
export const DELETEDENTALCOMPLAINTCHILDILLNESS =
  "DELETEDENTALCOMPLAINTCHILDILLNESS";
export const UPDATEDENTALCOMPLAINTCHILDILLNESS =
  "UPDATEDENTALCOMPLAINTCHILDILLNESS";
export const GETDENTALCOMPLAINTADULTILLNESS = "GETDENTALCOMPLAINTADULTILLNESS";
export const CREATEDENTALCOMPLAINTADULTILLNESS =
  "CREATEDENTALCOMPLAINTADULTILLNESS";
export const DELETEDENTALCOMPLAINTADULTILLNESS =
  "DELETEDENTALCOMPLAINTADULTILLNESS";
export const UPDATEDENTALCOMPLAINTADULTILLNESS =
  "UPDATEDENTALCOMPLAINTADULTILLNESS";
export const GETDENTALCOMPLAINTHEALTHMAINT = "GETDENTALCOMPLAINTHEALTHMAINT";
export const CREATEDENTALCOMPLAINTHEALTHMAINT =
  "CREATEDENTALCOMPLAINTHEALTHMAINT";
export const DELETEDENTALCOMPLAINTHEALTHMAINT =
  "DELETEDENTALCOMPLAINTHEALTHMAINT";
export const UPDATEDENTALCOMPLAINTHEALTHMAINT =
  "UPDATEDENTALCOMPLAINTHEALTHMAINT";
export const GETDENTALCOMPLAINTRELATION = "GETDENTALCOMPLAINTRELATION";
export const CREATEDENTALCOMPLAINTRELATION = "CREATEDENTALCOMPLAINTRELATION";
export const DELETEDENTALCOMPLAINTRELATION = "DELETEDENTALCOMPLAINTRELATION";
export const UPDATEDENTALCOMPLAINTRELATION = "UPDATEDENTALCOMPLAINTRELATION";
export const GETDENTALAPPITITLE = "GETDENTALAPPITITLE";
export const CREATEDENTALAPPITITLE = "CREATEDENTALAPPITITLE";
export const DELETEDENTALAPPITITLE = "DELETEDENTALAPPITITLE";
export const UPDATEDENTALAPPITITLE = "UPDATEDENTALAPPITITLE";
export const GETDENTALDIGESTIVETRACT = "GETDENTALDIGESTIVETRACT";
export const CREATEDENTALDIGESTIVETRACT = "CREATEDENTALDIGESTIVETRACT";
export const DELETEDENTALDIGESTIVETRACT = "DELETEDENTALDIGESTIVETRACT";
export const UPDATEDENTALDIGESTIVETRACT = "UPDATEDENTALDIGESTIVETRACT";
export const GETDENTALBOWEL = "GETDENTALBOWEL";
export const CREATEDENTALBOWEL = "CREATEDENTALBOWEL";
export const DELETEDENTALBOWEL = "DELETEDENTALBOWEL";
export const UPDATEDENTALBOWEL = "UPDATEDENTALBOWEL";
export const GETDENTALSLIP = "GETDENTALSLIP";
export const CREATEDENTALSLIP = "CREATEDENTALSLIP";
export const DELETEDENTALSLIP = "DELETEDENTALSLIP";
export const UPDATEDENTALSLIP = "UPDATEDENTALSLIP";
export const GETDENTALADDICTIONS = "GETDENTALADDICTIONS";
export const CREATEDENTALADDICTIONS = "CREATEDENTALADDICTIONS";
export const DELETEDENTALADDICTIONS = "DELETEDENTALADDICTIONS";
export const UPDATEDENTALADDICTIONS = "UPDATEDENTALADDICTIONS";
export const GETDENTALHIGHRISKANDBEHAVIOR = "GETDENTALHIGHRISKANDBEHAVIOR";
export const CREATEDENTALHIGHRISKANDBEHAVIOR =
  "CREATEDENTALHIGHRISKANDBEHAVIOR";
export const DELETEDENTALHIGHRISKANDBEHAVIOR =
  "DELETEDENTALHIGHRISKANDBEHAVIOR";
export const UPDATEDENTALHIGHRISKANDBEHAVIOR =
  "UPDATEDENTALHIGHRISKANDBEHAVIOR";
export const GETDENTALPOSITIONDURINGWORK = "GETDENTALPOSITIONDURINGWORK";
export const CREATEDENTALPOSITIONDURINGWORK = "CREATEDENTALPOSITIONDURINGWORK";
export const DELETEDENTALPOSITIONDURINGWORK = "DELETEDENTALPOSITIONDURINGWORK";
export const UPDATEDENTALPOSITIONDURINGWORK = "UPDATEDENTALPOSITIONDURINGWORK";
export const GETDENTALNATUREOFWORK = "GETDENTALNATUREOFWORK";
export const CREATEDENTALNATUREOFWORK = "CREATEDENTALNATUREOFWORK";
export const DELETEDENTALNATUREOFWORK = "DELETEDENTALNATUREOFWORK";
export const UPDATEDENTALNATUREOFWORK = "UPDATEDENTALNATUREOFWORK";
export const GETDENTALALLOPATHIC = "GETDENTALALLOPATHIC";
export const CREATEDENTALALLOPATHIC = "CREATEDENTALALLOPATHIC";
export const DELETEDENTALALLOPATHIC = "DELETEDENTALALLOPATHIC";
export const UPDATEDENTALALLOPATHIC = "UPDATEDENTALALLOPATHIC";
export const GETDENTALAYURVEDA = "GETDENTALAYURVEDA";
export const CREATEDENTALAYURVEDA = "CREATEDENTALAYURVEDA";
export const DELETEDENTALAYURVEDA = "DELETEDENTALAYURVEDA";
export const UPDATEDENTALAYURVEDA = "UPDATEDENTALAYURVEDA";
export const GETDENTALHOMEOPATHIC = "GETDENTALHOMEOPATHIC";
export const CREATEDENTALHOMEOPATHIC = "CREATEDENTALHOMEOPATHIC";
export const DELETEDENTALHOMEOPATHIC = "DELETEDENTALHOMEOPATHIC";
export const UPDATEDENTALHOMEOPATHIC = "UPDATEDENTALHOMEOPATHIC";
export const GETDENTALOTHERMEDICINE = "GETDENTALOTHERMEDICINE";
export const CREATEDENTALOTHERMEDICINE = "CREATEDENTALOTHERMEDICINE";
export const DELETEDENTALOTHERMEDICINE = "DELETEDENTALOTHERMEDICINE";
export const UPDATEDENTALOTHERMEDICINE = "UPDATEDENTALOTHERMEDICINE";
export const GETALLDOCTOR = "GETALLDOCTOR";
export const CREATEOFFER = "CREATEOFFER";
export const DELETEOFFER = "DELETEOFFER";
export const GETOFFER = "GETOFFER";
export const UPDATEOFFER = "UPDATEOFFER";

 export const CREATEOFFER_REQUEST = "CREATEOFFER_REQUEST"; 
 export const CREATEOFFER_SUCCESS = "CREATEOFFER_SUCCESS"; 
 export const CREATEOFFER_FAIL = "CREATEOFFER_FAIL"; 
 export const DELETEOFFER_REQUEST = "DELETEOFFER_REQUEST"; 
 export const DELETEOFFER_SUCCESS = "DELETEOFFER_SUCCESS"; 
  export const DELETEOFFER_FAIL = "DELETEOFFER_FAIL";
 export const GETOFFER_REQUEST = "GETOFFER_REQUEST"; 
  export const GETOFFER_SUCCESS = "GETOFFER_SUCCESS";
 export const GETOFFER_FAIL = "GETOFFER_FAIL"; 
export const UPDATEOFFER_REQUEST = "UPDATEOFFER_REQUEST";  
export const UPDATEOFFER_SUCCESS = "UPDATEOFFER_SUCCESS";  
export const UPDATEOFFER_FAIL = "UPDATEOFFER_FAIL";  
export const GETPRODUCTCURRENCY = "GETPRODUCTCURRENCY";
export const CREATEPRODUCTCURRENCY = "CREATEPRODUCTCURRENCY";
export const UPDATEPRODUCTCURRENCY = "UPDATEPRODUCTCURRENCY";
export const DELETEPRODUCTCURRENCY = "DELETEPRODUCTCURRENCY";
export const SET_SELECTED_CURRENCY = "SET_SELECTED_CURRENCY"; 
// types.js

// Send OTP Types
export const SEND_OTP_REQUEST = 'SEND_OTP_REQUEST';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAILURE = 'SEND_OTP_FAILURE';

// Verify OTP Types
export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

// captca Types
export const GENERATE_CAPTCHA_SUCCESS = 'GENERATE_CAPTCHA_SUCCESS';
export const GENERATE_CAPTCHA_ERROR = 'GENERATE_CAPTCHA_ERROR';